export const FRENCH_TRANSLATIONS = {
  text: {
    //Retainership
    retainership: {
      resetExpiryDate: "Réinitialiser la date d'expiration",

      resetSuccessful: "Réinitialisation réussie",
      approveRequest: "Approuver la demande",
      orderDate: "Date de commande",
      orderAmount: "Montant de la commande",
      issuedCard: "Total des cartes émises",
      unissuedCard: "Total des cartes non émises",
      availableCards: "Cartes disponibles",
      cardRequest: "Demande de carte",
      numberOfCards: "Nombre de cartes demandées",
      setCardCharge: "Définir le débit de la carte",
      enterAmount: "Entrez un montant",
      assignCard: "Attribuer une carte",
      selectCustomer: "sélectionner un client",
      selectCard: "Sélectionnez la carte",
      totalCards: "Total des cartes",
      cardList: "Liste des cartes disponibles",
      selectAllCards: "Sélectionnez le nombre de cartes nécessaire",
      currentCardCharge: "Frais de carte actuels",
      walletTopup: "Rechargement du portefeuille",
      selectClient: "Sélectionnez un client",
      selectChargeMode: "Sélectionnez le mode de chargement",
      billClient: "Facturer le client pour le paiement",
      dontBill: "Ne facturez pas le client",
      walletUpdatedSuccesfully: "Portefeuille mis à jour avec succès",
      enterAmount: "Entrer le montant",
      assignedSuccess: "Affecté avec succès",
      accountProvider: "Fournisseur de compte",
      assignedTo: "Assigné à",
      activated: "Activé",
      nameOnCard: "Nom sur la carte",
      linkedTerminals: "Terminaux liés",
      nonLinkedTerminals: "Terminaux non liés",
      walletHistory: "Historique du portefeuille",
      channel: "Canal",
      pendingRequest: "Requêtes en attente",
    },
    //posRevamp

    posRevamp: {
      selectVendor: "Sélectionnez le fournisseur",
      fee: "Frais",
      transactionLimit: "Limite de transaction",
    },

    // Products In Portal
    products: {
      Settle: "Régler",
      sureDeleteRequest: "Voulez-vous vraiment supprimer cette demande ?",
      requestDeleted: "Demande supprimée avec succès",
      updateBankRequest: "Mettre à jour la demande bancaire",
      requestSent: "Demande envoyée avec succès",
      efueling: "Faire le plein",
      priceUpdate: "mise à jour des prix",
      itemsPerPage: "objets par page",
      total: "TOTALE",
      productDischarged: "Produit déchargé",
      productDischargedOn: "Produit déchargé le",
      totalVolume: "Volume total",
      productsVolumeDetails: "Détails du volume du produit",
      ltrs: "Litres",
      productsDischargedOn: "Produit déchargé le",
      product: "Produit",
      plateNumber: "Numéro de la plaque",
      stockValuation: "Valorisation des stocks",
      noStockValuation: "Aucune valorisation des stocks enregistrée",
      currentVolume: "Volume actuel",
      valuation: "Évaluation",
      manageProducts: "Gérer le produit",
      manageProductHere: "Gérer le produit ici",
      createProduct: "Créer un produit",
      totalProducts: "Produit total",
      programName: "Nom du programme",
      name: "Nom",
      desc: "Description",
      quantityPerUnit: "Quantité par unité",
      productCategory: "Catégorie de produit",
      action: "Action",
      productDischarged: "Produit déchargé",
      productDischargedOn: "Produit déchargé le",
      plateNumber: "Numéro de la plaquete Number",
      val: "Évaluationuation:",
      retailOutlets: "Point de venteail Outlets",
      seeProductsStock: "Voir le stock de produits Product Stock",
      totalStock: "Stock totalal Stock",
      totalQuantitySupplied: "Quantité totale fournieal Quantity Supplied",
      totalQuantitySold: "Quantité totale vendueal Quantity Sold",
      productName: "Nom du produitduct Name",
      quantitySupplied: "Qualité fournientity supplied",
      quantitySold: "Qualité vendue",
      updated: "Mis à jour",
      added: "Ajoutée",
    },

    // Vue-ctk-date-picker
    calendar: {
      today: "Aujourd'hui",
      yesterday: "Hier",
      last7Days: "Les 7 derniers jours",
      lastWeek: "La semaine dernière",
      last30Days: "Les 30 derniers jours",
      lastMonth: "Le mois dernier",
      dateRange: "Sélectionner une plage de dates",
      selectDate: "Sélectionner une date",
      selectDateAndTime: "Sélectionner la date et l'heure",
      date: "Date",
      time: "L'heure",
      from: "Depuis",
      to: "à",
      dateTime: "Date/Heure",
    },

    // Action Buttons For Table
    actionButtons: {
      title: "Action",
      edit: "Modifier",
      delete: "Supprimer",
      submit: "Soumettre",
      upload: "Téléverser un fichier",
      select: "Sélectionner",
      exportPdf: "Exporter pdf",
      cancel: "Annuler",
      ok: "D'accord",
      update: "Réactualiser",
      fund: "Fonds",
      status: "Statut",
      page: "Page",
    },

    //Click buttons
    clickButtons: {
      status: "Statut",
      details: "Détails",
      viewAsset: "Afficher l'actif",
      viewGroup: "Afficher le groupe",
      unLinkVehicle: "Dissocier le véhicule",
      viewDetails: "Voir les détails",
      maintenance: "Entretien",
      tankDetails: "Afficher les détails du réservoir",
      toDashboard: "Aller au tableau de bord",
      unmapFromGroup: "Démapper du groupe",
      reject: "Rejeter",
      close: "Fermer",
      startShift: "Début de quart",
      deleteFault: "Supprimer le défaut",
      editMaintenance: "Modifier la maintenance",
      maxCash: "Montant maximal en espèces",
      paymentRecords: "Dossiers de paiement",
      parentAssets: "Actif parent",
      addFile: "Ajouter le fichier",
      recordService: "Service d'enregistrement",
      renewItem: "Renouveler l'article",
      supplyHistory: "Historique des approvisionnements",
      salesHistory: "Historique des ventes",
      acceptSupply: "Accepter l'approvisionnement",
      seeReason: "Voir la raison",
      companies: "Entreprises",
      transactionHistory: "Historique des transactions",
      addTransaction: "Ajouter opération",
      companyDetails: "Coordonnées de l'entreprise",
      gensysDetails: "Coordonnées de Gensys",
      viewBreakDown: "Voir la répartition",
      view: "Voir",
      reAssignPos: " Réattribuer POS",
      viewHistory: "Voir l'historique",
      branches: "Branches",
      mapToBranch: "Carte des succursales",
      users: "Utilisateurs",
      mapUsersToGroup: "Mapper les utilisateurs à afficher",
      mapBranchesToView: "Branche de la carte à visualiser",
      mapBranchesToViewDashboard:
        "Branche de carte pour afficher le tableau de bord",
      viewDashboard: "Afficher le tableau de bord",
      sites: "Des sites",
      mapSitesToView: "Cartographier les sites à afficher",
      download: "Télécharger",
      viewBranches: "Voir les succursales",
      mapBranchesToViewList: "Mapper la branche pour voir la liste",
      forward: "Avant",
      fundAccount: "Compte de fonds",
      vouchersBy: "Bon par",
      refresh: "Rafraîchir",
      send: "Envoyer",
      resend: "Renvoyer",
      remove: "Retirer",
    },

    // Password Prompt
    passwordPrompt: {
      pleaseInput: "Veuillez entrer le mot de passe",
      cancel: "Annuler",
      submit: "Soumettre",
      password: "Mot de passe",
    },

    // And Text
    and: {
      text: "Et",
    },
    of: {
      text: "De",
    },
    for: {
      text: "pour",
    },
    units: {
      litres: "Ltrs",
    },

    errors: {
      selectDate: "Sélectionner une date",
      amountError: "Entrez un montant",
      emailMissing: "Veuillez saisir un e-mail",
      invalidEmail: "Format d'email invalide",
      firstNameMissing: "Veuillez saisir le prénom",
      lastNameMissing: "Veuillez entrer le nom de famille",
      passwordMissing: "Veuillez entrer le mot de passe",
      priceFieldMissing: "Veuillez entrer un prix",
      productMissing: "Veuillez sélectionner un produit",
      contactNameMissing: "Veuillez saisir un nom de contact",
      cityMissing: "Veuillez entrer une ville",
      streetMissing: "Veuillez saisir une rue",
      stateMissing: "Veuillez sélectionner un état",
      contactPhoneMissing: "Veuillez entrer un numéro de téléphone",
      shortPhoneNumber:
        "Le numéro de téléphone doit comporter entre 10 et 13 chiffres",
      shortPassword: "Le mot de passe doit comporter entre 8 et 100 caractères",
      accountNameMissing: "Veuillez saisir un nom de compte",
      accountNumberMissing: "Veuillez saisir un numéro de compte",
      dateMissing: "Veuillez sélectionner une date",
      invalidPrice: "Veuillez entrer un prix supérieur à zéro",
      confirmPassword: "Confirmez le mot de passe",
      passwordMatch: "Le mot de passe doit correspondre",
      networkError: "Erreur réseau veuillez vérifier votre connexion internet",
      errorOccured: "Une erreur s'est produite",
      accessDenied: "Accès refusé",
      noAccess:
        "La page à laquelle vous essayez d'accéder ne peut pas être accordée,Vous pouvez contacter l'administrateur pour obtenir de l'aide",
      descIsRequired: "La description est obligatoire",
      pleaseSelectCategory: "Veuillez sélectionner une catégorie",
      enterQuantityUnit: "Veuillez entrer la quantité par unité",
      nameIsRequired: "Le nom est requis",
      descIsRequired: "La description est obligatoire",
      productUpdatedSuccessfully: "Produit mis à jour avec succès",
      productCreatedSuccessfully: "Produit créé avec succès",
      selectBranch: "Veuillez sélectionner une succursale",
      nwProductCreated:
        "Approvisionnement en produits non humides créé avec succès",
      propertyNameRequired: "Le nom de la propriété est requis",
      propertyDescriptionRequired: "La description de la propriété est requise",
      rentFeeRequired: "Le loyer est obligatoire",
      restroomRequired: "Le nombre de salles de repos est requis",
      roomsRequired: "Le nombre de chambres est requis",
      detailsRequired: "Des détails supplémentaires sont requis",
      rentDurationRequired: "La durée de location est requise",
      updatedBranchSpace: "Espace de succursale mis à jour avec succès",
      unitPriceRequired: "Prix ​​unitaire requis",
      transAddedSuccess: "Transaction ajoutée avec succès",
      driverNameReq: "Le nom du pilote est requis",
      emailIsRequired: "L'e-mail est requis",
      inputPhoneNo: "Veuillez entrer un numéro de téléphone",
      hasBeenUnmappedSuccess: "A été démappé avec succès de",
      sureWantUnmap: "Êtes-vous sûr de vouloir démapper",
      enterAmount: "Entrez un montant",
    },

    //General form
    form: {
      name: "Nom",
      firstName: "Prénom",
      lastName: "Nom de famille",
      fullName: "Nom et prénom",
      address: "Adresse",
      phoneNo: "Numéro de téléphone",
      email: "E-mail",
      state: "Etat",
      date: "Date",
      country: "Pays",
      status: "Statut",
      product: "Produit",
      user: "Utilisateur",
      volume: "Volume",
      amount: "Montant",
      code: "Code",
      city: "Ville",
      category: "Catégorie",
      desc: "Description",
      action: "Action",
      city: "Ville",
      company: "Entreprise",
      contactEmail: "Email du contact",
      contactPhone: "Numéro du contact",
    },

    //General
    general: {
      company: "Fuelmetrics",
      country: "Nigeria",
      state: "Lagos",
      rating: "Notation",
      na: "N/A",
      ussd: "USSD",
      first: "d'abord",
      last: "dernier",
    },

    //Requests
    request: {
      settementSuccessful: "Règlement réussi",
      success: "Demande réussie",
      failure: "Demande échoué",
      pending: "Demande en attente",
      network: "Panne de réseau",
      downloadSuccess: "Téléchargement réussi",
      responseCode: "Code de réponse",
    },

    // Subscription
    subscribe: {
      expireIn: "Votre abonnement sera dans",
      makePayment: "Veuillez effectuer le paiement",
      expired: "Votre abonnement a expiré, veuillez effectuer le paiement",
    },

    /***Company Portal */

    // Company Master Layout
    cMasterLayout: {
      selectLanguage: "Choisir la langue",
      manageCompanies: "Gérer les entreprises",
      mgtDesc:
        "Vous pouvez accéder aux entreprises pour gérer n'importe quel compte d'entreprise ici",
      bankAcctRequest: "Demande de compte bancaire",
      dashboard: "Tableau de bord",
      stationManagement: "Gestion des gares",
      priceManagement: "Gestion des prix",
      updatePrice: "Mettre à jour le prix",
      report: "Rapport",
      companySales: "Ventes de l'entreprise",
      sales: "Ventes",
      varianceReport: "Rapport d'écart",
      tanksFilledReport: "Rapport produit déchargé",
      posReport: "POS Rapport de transaction",
      peddlingManagement: "Gestion du colportage",
      peddling: "Colportage",
      orders: "Ordres",
      products: "Produit",
      manageDrivers: "Gérer les chauffeurs",
      manageTrucks: "Gérer les camions",
      ourDealers: "Nos revendeurs",
      retailOutlets: "Point de vente",
      corporateCustomers: "Clients corporatifs",
      retainership: "Mandat",
      walletFundRequest: "Demande de fonds de portefeuille",
      customers: "Clients",
      manageExpenses: "Gérer les dépenses",
      expenses: "Dépenses",
      categories: "Catégories de dépenses",
      bankAccounts: "Compte bancaire",
      zones: "Région",
      outstandingPayments: "Impayé",
      payments: "Paiements",
      signOut: "Se déconnecter",
      confirmLogout: "Voulez-vous vraiment vous déconnecter",
      profile: "profil",
      SubExpire: "Votre abonnement sera dans",
      makePayment: ",Veuillez effectuer le paiement",
      subHasExpired: "Votre abonnement a expiré veuillez effectuer le paiement",

      logOut: "Se déconnecter",
      supportAdmin: "Administrateur de l'assistance",
      invoices: "Factures",
      wallet: "Portefeuille",
      drivers: "Conducteurs",
      managePeddling: "Gérer le colportage",
      loyalty: "loyauté",
      litresForPoint: "Litres pour point",
      alertsAlarms: "Alerte et alarme",
      trucksDrivers: "Camions et chauffeurs",
      maintenance: "Maintenance",
      waybill: "Lettre de voiture",
      aggregatedCompanyFault: "Agrégare fautes de l'entreprise",
      shutdownPumps: "Pompes d'arrêt",
      companyWallet: "Portefeuille d'entreprise",
      assetGroup: "Groupes d'éléments",
      regions: "Zones",
      branchWalletTransactions: "Transactions de portefeuille de succursale",
      transactionSalesCount: "Nombre de ventes par transaction",
      management: "Gestion",
      manageUsers: "Gérer les utilisateurs",
      subscriptionTransactions: "Opérations d'abonnement",
      recurringPayment: "Mettre en place un paiement récurrent",
      posTerminals: "Terminaux de point de vente",
      bankTrans: "Opérations bancaires",
      bankDeposit: "Dépôts de banque",
      bank: "Banque",
      sufficiencyMetrics: "Métriques de suffisance",
      dealers: "Concessionnaires",
      groupManagement: "Gestion de groupe",
      category: "Catégories",
      branchProduct: "Stock de produits de la succursale",
      supplies: "Fournitures",
      dryStock: "Stock sec",
      branchLease: "Baux de succursale",
      services: "Prestations de service",
      manualRecords: "Enregistrement manuel",
      dailyBranchTransactions: "Transactions quotidiennes en succursale",
      sendBranchReport: "Envoyer le rapport de succursale",
      stockValuation: "Valorisation des stocks",
      productsReceived: "Produit reçu",
      tankVariance: "Écart de réservoir",
      tanksFilled: "Réservoirs remplis",
      cashflow: "Des flux de trésorerie",
      tankStock: "Stock de réservoir",
      companySalesSummary: "Résumé des ventes de l'entreprise",
      productsDischarged: "Décharge de produit",
      faults: "Défauts",
      contactCom:
        "Contactez votre entreprise pour effectuer le paiement nécessaire",
    },

    // Company Dashboard
    cDashboard: {
      salesVTarget: "Ventes par rapport à l'objectif",
      dealers: "Concessionnaires",
      branches: "Gare",
      tanksFilled: "Produit déchargé",
      totalPumps: "Nombre total de pompes",
      disconnectedPumps: "Nombre de pompes déconnectées",
      duration: "Durée",
      offlinePumps: "Nombre de pompes hors ligne",
      lowTanksTitle: "Réservoirs avec moins de 30% de leur capacité",
      curVolume: "Volume actuel",
      maxVolume: "Volume maximal",
      showAllButton: "Afficher tout",
      todaySalesTransactions:
        "Transactions de vente de l'entreprise aujourd'hui",
      branch: "Gare",
      productVolume: "Volume (litres)",
      productAmount: "Montant {currency}",
      total: "Total {currency}",
      nA: "N'est pas applicable",
      tanK: "Stock de réservoir",
      pms: "Essence",
      ltrs: "Litres",
      lpg: "LPG",
      ago: "Gasoil",
      dpk: "DPK",
      tankVariance: "Écart de réservoir",
      branchName: "Nom de la filiale",
      pmsVolume: "PMS volume",
      agoVolume: "AGO Volume",
      dpkVolume: "DPK Volume",
      lpgVolume: "LPG Volume",
      branchTank:
        "Aucun réservoir n'est presque épuisé Tous les réservoirs peuvent durer pendant les prochaines",
      noTank:
        "Aucun réservoir n'est presque épuisé Tous les réservoirs peuvent durer pendant les prochaines",
      saleprojection: "Projection des ventes sur 48 heures:",
      volProjection: "Projection de volume sur 48 heures",
      saleTransactionToday:
        "Transaction de vente au concessionnaire aujourd'hui",
      branchSales: "Ventes en succursale",
      state: "État",
      region: "Région",
      salesReport: "Région de vente",
      stations: "Gare",
      productDischarged: "Produit déchargé",
      companyDashboard: "Tableau de bord de l'entreprise",
      productInventory: "Inventaire des produits",
      transactionCount: "Nombre de transactions",
      tankStockProjection: "Stock et projection du réservoir de branche",
      noLowTanks:
        " Aucun réservoir n'est presque épuisé Tous les réservoirs peuvent durer pendant les prochaines 48 heures",
      salesProjection: "Projection des ventes sur 48 heures",
      volProjection: "Projection de volume sur 48 heures",
      offlinePumps: "Nombre de pompes hors ligne",
      lowTanksTitle: "Réservoirs avec moins de 30% de leur capacité",
      station: "Gare",
      state: "État",
      region: "Région",
      backCDashboard: "Retour au tableau de bord de l'entreprise",
      productsDischargedOn: "Produit déchargé le",
      totalVol: "Volume total",
      tankStock: "Stock de réservoir",
      cashReport: "Rapport de caisse",
    },

    //Company Loyalty page
    loyalty: {
      confirmDelete: "Êtes-vous sûr de vouloir supprimer ce programme?",
      redeemType: "Type d'échange",
      startDate: "date de début",
      endDate: "date de fin",
      title: "Mettre en place la fidélité",
      pointVolume: "Volume de points",
      literPts: "Litres pour point",
      howLtrsPts: "Combien de litres font un point",
      ptsVal: "Valeur en points",
      worth: "Combien de {currency} vaut un point",
      pointConvert:
        "Combien de point est échangeable (Converti en portefeuille pour l'achat)",
      redeemablePoint: "Point échangeables",
      literPointErr: "Veuillez entrer des litres pour le point",
      pointValueErr: "Veuillez entrer la valeur en points",
      pointValue: "Valeur en points",
      redeemPointErr: "Veuillez saisir un point échangeable",
      loyaltySuccess: "La fidélité a été configurée avec succès",

      loyaltyDeleteSuccess: "La fidélité a été supprimée avec succès",
      totalPointEarnedCus: "Total des points gagnés par les clients",
      totalPendingPoints: "Total des points en attente",

      totalPointsRedeem: "Total des points échangés",
      currentPointBalance: "Solde de points actuel",
      toTalPointEarned: "Total des points gagnés",
      toTalPointRedeemed: "Total des points échangés",
    },

    //Company Expense page
    cExpense: {
      title: "Dépenses par catégories",
      allCate: "Toutes catégories",
      totEx: "Dépenses totales",
      exBreakdownFor: "Répartition des dépenses pour",
    },

    //Company Transaction Count page
    cTranCount: {
      title: "Nombre de transactions",
      between: "Nombre de transactions à partir de",
    },

    //Company branch wallet transaction page
    cBranchWallet: {
      totalTran: "Transaction totale",
      title: "transaction de portefeuille",
      between: "Transactions de portefeuille de points de vente entre",
      date: "Date",
      station: "Gare",
      creditTran: "Nombre d'opérations de crédit",
      creditAmt: "Montant total du crédit",
      debitAmt: "Nombre d'opérations de débit",
      totalDebitAmt: "Montant total du débit",
      action: "Action",
      viewMore: "Voir plus de détails",
    },

    //COMPANY ASSETS
    cAsset: {
      totalAsset: "Total des groupes d'actifs",
      title: "Groupe d'actifs de l'entreprise",
      desc: "Vous pouvez créer et gérer les groupes d'actifs de votre entreprise ici",
      createButton: "Créer un groupe",
      grpName: "Nom de groupe",
      description: "Description",
      grpType: "Type de groupe",
      numAsset: "Nombre d'actifs",
      assetReq: "Actifs nécessitant une attention particulière",
      noAssetGrp: "Vous n'avez actuellement aucun groupe d'éléments",
      createAssGrp: "Créer un groupe d'actifs",
      details: {
        title: "Atout pour",
        desc: "Veuillez sélectionner une station pour afficher son actif",
        selectStation: "Sélectionnez la station",
        allStation: "Toutes les gares",
        totalAsset: "Total des actifs",
        selectStatus: "Sélectionnez un statut",
        allStatus: "Tous les statuts",
        okay: "D'accord",
        serviceDue: "Service rendu",
        renewalDue: "Renouvellement dû",
        notActive: "Pas actif",
        renewed: "Renouvelé",
        enterAsset: "Saisir l'actif",
        assetName: "Nom de l'actif",
        licenseNo: "Numéro de licence",
        station: "Gare",
        status: "Statut",
      },
    },

    //COMPANY WALLET
    cWallet: {
      title: "Portefeuille d'entreprise",
      balance: "Solde comptable",
      ba: "Solde comptable",
      date: "Date",
      amount: "Montant",
      source: "Source",
      status: "Statu",
      companyWalletTransactions: "Transactions du portefeuille de l'entreprise",
    },

    //Company Send branch report
    cBranchReport: {
      title: "Rapport des succursales de l'entreprise",
      description:
        "	Vous pouvez envoyer et transmettre les rapports de vos succursales ici...",
      all: "Tout",
      sent: "Envoyé",
      notSent: "Pas envoyé",
      totalCount: "Le compte total",
      sendReport: "Envoyer le rapport de l'entreprise",
      station: "Gare",
      company: "Entreprise",
      address: "Adresse",
      region: "Région",
      state: "État",
      action: "Action",
    },

    //COMPANY SERVICES
    cServices: {
      title: "Gérer les services",
      description: "Gérez vos services pour",
      addService: "Ajouter un service",
      viewTransactions: "Afficher les transactions",
      totalService: "Services totaux",
      serviceName: "Nom du service",
      action: "Action",
      totalSoldPrice: "Prix ​​de vente total",
      customer: "Client",
      price: "Prix",
      serviceDescription: "Description du service",
      service: "Services",
      RecordDate: "Date d'enregistrement",
      totalAmount: "Montant total",
      station: "Gare",
      amount: "Montant",
    },

    //COMPANY BRANCH LEASE
    cBranchLease: {
      weekly: "Hebdomadaire",
      monthly: "Mensuel",
      yearly: "Annuel",
      title: "Baux de succursale",
      title1: "Baux/Louer pour",
      description:
        "Voir tous les baux des succursales en sélectionnant une succursale ici",
      desc: "Voir tous les baux ici",
      allLeases: "Tous les baux",
      allLR: "Tous les baux/Louer",
      date: "Date de location",
      branchSpace: "Espace succursale",
      leaseBy: "Louer par",
      occupant: "Nom de l'occupant",
      occupantEmail: "Courriel de l'occupant",
      payment: "Paiement terminé",
      propertyName: "Nom de la propriété",
      propertyDescription: "Descriptif de la propriété",
      rentFee: "Frais de location",
      rooms: "Nombre de chambres",
      restRoom: "nombre de salle de repos",
      addtional: "Détails supplémentaires",
      rentDuration: "Durée du loyer",
      branchSpaceTitle: "Gérer l'espace de la succursale",
      branchSpaceDesc: "Gérez votre espace agence ici pour votre agence ici",
      createSpace: "Créer un espace succursale",
      room: "Pièces",
      available: "Disponible",
      action: "Action",
      selectBranch: "Sélectionnez la branche",
    },

    //COMPANY BRANCHES RETAIL OUTLET
    cOurBranches: {
      title: "Gérer le point de ventes",
      description: "Vous pouvez voir et gérer tous vos points de vente ici",
      totalOutlet: "Sortie totale",
      setupBudget: {
        title: "Établir un budget de dépenses mensuel pour",
        expense: "Budget de dépenses du mois",
        button: "Configurer le budget",
        successMsg: "configuration du budget réussie",
        errorMsg: "Veuillez entrer un budget",
      },
      mapGroup: {
        title: "Mapper le site au groupe",
        title2: "Mapper la branche au groupe",
        selectIndustryGroup: "Sélectionnez le groupe d'industrie",
        selectCompanyGroup: "Sélectionnez le groupe d'entreprises",
        mapSite: "Plan du site",
        mapBranch: "Branche de la carte",
        noGroup: "Il n'y a pas de groupe créé par cette société",
        toastError1: "Groupe non sélectionné",
        toastSuccess: "Mappage réussi de la branche au groupe",
      },
    },

    //COMPANY DEALERS PAGE
    cDealers: {
      totalDealer: "Nombre total de concessionnaires",
      mapButton: "Carte vers un nouveau concessionnaire",
    },

    //COMPANY GROUP MANAGEMENT PAGE
    cGrpMgt: {
      title: "Gestion de groupe",
      desc: "Créez et gérez vos groupes d'entreprise ici",
      createButton: "Créer un nouveau",
      totalGrps: "Groupes totaux",
      description: "Description",
      category: "Catégorie",
      email: "E-mail",
      action: "Action",
      name: "Nom",
      successMsg: "Suppressions de groupe",
    },

    //COMPANY REGION PAGE
    cRegion: {
      totalRegion: "Régions totales",
      region: "Région",
    },

    //Company sufficiency metric page
    cSufficiency: {
      title: "Suffisance",
      projectionRate: "Taux de projection du réservoir",
      selectOption: "Sélectionnez augmenter ou diminuer",
      increase: "Augmenter",
      decrease: "Diminuer",
      inputPer: "Pourcentage d'entrée",
      button: "Soumettre",
      volumeProjection: "Projection de volume sur les 2 prochains jours",
      salesProjection: "Projection des ventes sur les 2 prochains jours",
    },

    //Company Users
    cUsers: {
      title: "Gérer les utilisateurs",
      description: "Gérez vos utilisateurs et leurs rôles ici",
      createButton: "Créer un utilisateur",
      addExistingUser: "Ajouter un utilisateur existant",
      users: "Utilisateurs",
      firstName: "Prénom",
      lastName: "Nom de famille",
      email: "Adresse e-mail",
      status: "Statut",
      accessLevel: "Niveau d'accès",
      mapSuccess: "A été démappé avec succès",
      confirmMsg: "Êtes-vous sûr de vouloir supprimer cet utilisateur",
      subTitle: "Ajouter un utilisateur de rôle",
      subTitle: "Ajouter un utilisateur de rôle",
      selectGrp: "Sélectionnez le groupe",
      availableRoles: "Rôles disponibles",
      createUser: {
        title1: "Ajouter un utilisateur",
        title2: "Ajouter un rôle",
        phone: "Numéro de téléphone",
        selectAccess: "Sélectionnez le niveau d'accès",
        select: "Sélectionner",
        successMsg: "Utilisateur créé avec succès",
        categoryError: "Veuillez sélectionner une catégorie pour continuer",
        search: "Recherche",
      },
      addUserToRole: {
        selectRole: "Sélectionnez le rôle",
        companyAdmin: "Administrateur de l'entreprise",
        branchManager: "Directeur de succursale",
        station: "Gare",
        selectStation: "Sélectionnez la station",
        roleError: "Veuillez sélectionner un rôle",
        stationError: "Veuillez sélectionner une station",
        mapSuccess: "L'utilisateur a été ajouté avec succès au rôle",
      },
      userDetails: {
        title: "Modifier l'utilisateur",
        active: "Actif",
        deactivate: "Désactivé",
        suspend: "Suspendu",
        forcePassword: "Sélectionnez tous les rôles",
        selectAll: "Sélectionnez tous les rôles",
      },
    },

    // Compny cashflow report
    cashflow: {
      title: "Des flux de trésorerie",
      showAll: "Afficher tout",
      selectStation: "Sélectionnez la station",
      reportBetween: "Flux de trésorerie entre",
      date: "Date",
      station: "Gare",
      region: "Région",
      state: "État",
      total: "Ventes totales {currency}",
      posSales: "Ventes POS {currency}",
      retainerSales: "Ventes d'acompte {currency}",
      epumpSales: "Vente d'Epump {currency}",
      bankedCash: "Espèces en banque {currency}",
      expense: "Frais {currency}",
      previousBalance: "Solde précédent {currency}",
      outstandingCash: "Trésorerie en circulation {currency}",
      vaultLimit: "Limite du coffre-fort {currency}",
      compliance: "Conformité (%)",
    },

    //Company Aggregated Faults
    cAggregated: {
      title: "Défauts agrégés",
      desc: "Afficher les défauts agrégés de votre entreprise ici",
      totalFault: "Défauts totaux",
      station: "Gare",
      name: "Nom",
      recordedBy: "Enregistré par",
      type: "Taper",
    },

    //COMPANY MAINTENANCE PAGE
    cMaintenance: {
      title: "Liste d'entretien",
      desc: "Consultez la liste de maintenance de votre entreprise ici",
      totalMain: "Entretien total",
    },

    cWaybill: {
      title: "Liste des lettres de voiture",
      desc: "Consultez la lettre de voiture de votre entreprise ici",
      createWaybill: "CRÉER LETTRE DE TRANSPORT",
      totalWaybill: "Total lettre de voiture",
      date: "Date",
      refNo: "Numéro de réference",
      product: "Produit",
      vol: "Volume",
      comment: "commentaire",
      // New
      waybillDetailsFor: "Détails de la lettre de voiture pour",

      delWaybill: "supprimer la lettre de voiture?",
      delatedWaybill: "lettre de voiture supprimée",
      askMark: "Marquer comme utilisé?",
      markUsed: "Marquer comme utilisé",
      used: "utilisé",
      waybillMarked: "lettre de voiture marquée",
    },

    cTrucks: {
      title: "Liste des camions et chauffeurs",
      desc: "Consultez la liste des camions et chauffeurs de votre entreprise ici",
      addTruck: "AJOUTER UN CAMION",
      addDriver: "AJOUTER UN CONDUCTEUR",
      totalTruck: "Camion total",
      totalDriver: "Conducteur total",
      totalAssigned: "Total attribué",
      allTruck: "TOUS LES CAMIONS",
      allDrivers: "TOUS LES PILOTES",
      assignedTrucks: "Toutes les figures attribuées aux pilotes",
      fullname: "Nom et prénom",
      phoneNo: "Numéro de téléphone",
      tankType: "Type de réservoir",
      email: "E-mail",
      driver: "Conducteur",
    },

    //COMPANY ALERT PAGE
    cAlerts: {
      title: "ALERTES ET ALARME",
      desc: "Créez et gérez vos alertes et alarmes ici",
      createButton: "Créer un nouveau",
      totalAlert: "Alerte/alarme totale",
      owner: "Propriétaire",
      event: "Événement",
      deleteQuest: "Supprimer l'alerte et l'alarme?",
      deletedAA: "Alerte/Alarme supprimée",
    },

    //Company Wallet
    cWallet: {
      title: "Portefeuille",
      description: "Consultez les transactions de votre portefeuille ici",
      fundButton: "Portefeuille de fonds",
      walletBalance: "Solde du portefeuille",
      date: "Date",
      amount: "Montant",
      source: "Source",
      status: "Statut",
      desc: "Description",
    },

    cShutdown: {
      pumpShut: "Arrêt de la pompe",
      shutdownHistory: "Historique des arrêts",
      shutdownPump: "Pompes d'arrêt",
      action: "Action",
    },

    //Company Invoice
    cInvoice: {
      title: "Factures",
      overdue: "En retard",
      last: "Dernier",
      due: "Dû dans les 30 prochains jours",
      allStatus: "Tous les statuts",
      paid: "Payé",
      partPaid: "Partie payée",
      allInvoice: "Toutes les factures",
      status: "Statut",
      du: "Exigible",
      date: "Date",
      customer: "Client",
      amountDue: "Montant dû",
      fuelMetrics: "Fuelmetrics",
      nigeria: "Nigeria",
      station: "Gare",
      setupPayment: "Configurer le paiement",
      settleInvoice: "Régler la facture",
      details: {
        makePayment: "Effectuer le paiement",
        invoicePayment: "Paiement de facture",
        exportPDF: "Exporter PDF",
        billTo: "facturer",
        invoiceNum: "Numéro de facture",
        invoiceDate: "Date de facturation",
        paymentDue: "Paiement dû",
        items: "Articles",
        quantity: "Quantité",
        price: "Prix",
        amount: "Montant",
        noItem: "Vous n'avez ajouté aucun élément",
        subTotal: "Sous-total",
        total: "Total",
        amountPaid: "Le montant payé",
        edit: "Édité",
      },
      payment: {
        totalAmount: "Montant total payé",
        payments: "Paiements",
        method: "Mode de paiement",
        note: "Note",
        action: "Action",
      },
      breakdown: {
        title: "Répartition des paiements mensuels par stations",
        desc1:
          "le paiement est maintenant plus facile avec le paiement récurrent",
        desc2:
          "   nous déduisons automatiquement l'abonnement mensuel du compte fourni",
        totalAmount: "Montant total",
        monthly: "Mensuel",
        subList: "Répartition de la liste des abonnements de l'entreprise",
      },
      setRecurring: {
        title: "Facture mensuelle",
        edited: "Édité",
      },
      sub: {
        title: "Transactions d'abonnement par stations",
        desc: "Vous pouvez gérer vos transactions d'abonnement ici ;)",
      },
      subTran: {
        title: "Opérations d'abonnement",
        desc2: "Vous pouvez gérer vos transactions d'abonnement ici ;)",
      },
      success: {
        success: "Succès",
        error1: "Quelque chose s'est mal passé",
        error2: "We are unable to set up your payment successfully",
        continue: "Continuer vers les abonnements",
      },
    },

    //Company Bank page
    cBank: {
      confirmSettlement: "Confirmer le règlement",
      paymentConfirmed: "Paiement accepté",
      makeRequest: "Faire une requête",
      confirm: "confirmer",
      amountToSettle: "Montant à régler",
      confirmSettlement: "Confirmer le règlement",
      transactionType: "Type de transaction",
      makeBankRequestTitle: "Faire une demande bancaire",
      bankAcctRequestDesc: "Voir les demandes de compte bancaire ici...",
      confirmMsg: "Voulez-vous vraiment supprimer ce compte ?",
      removedSuccess: "Compte supprimé avec succès",
      date: "Date",
      transactionRef: "Référence de l'opération",
      station: "Gare",
      status: "Statut",
      summary: "Résumé",
      bank: "Banque",
      accountName: "Nom du compte",
      accountNumber: "Numéro de compte",
      linked: "Lié",
      linkedService: "Service lié",
      credit: "Crédit",
      debit: "Débit",
      selectStation: "Sélectionnez la station",
      showAll: "Afficher tout",
      selectStatus: "Sélectionnez le statut",
      approve: "Approuvé",
      declined: "Diminué",
      totalTransactions: "Transactions totales",
      successTrans: "Transactions réussies",
      failedTrans: "Transactions échouées",
      cashBack: "Total des frais de remise en argent",
      amount: "Montant",
      hi: "Salut",
      action: "Action",
      account: {
        title: "Comptes bancaires",
        description:
          "Liez vos comptes bancaires pour rapprocher les dépôts bancaires",
        desc1: "payer un abonnement mensuel, etc..",
        addBank: "Ajouter une nouvelle banque",
        accountList: "Liste des comptes bancaires",
        iconInfo:
          "Cette icône indique les comptes bancaires liés, cela signifie que nous confirmons votre dépôt sur le compte. Vous pouvez avoir plusieurs comptes liés",
        removeBank: "Supprimer la banque",
        accountsAdded: "Les comptes ajoutés s'afficheront ici",
        noBankLinked: "Vous n'avez actuellement aucune banque liée",
        accountDisplayed:
          "Les comptes bancaires seront affichés une fois ajoutés",
      },
      bankLinked: {
        title: "Dépôts de banque",
        amountPaid: "Le montant payé",
        amountRaised: "Montant amassé",
        difference: "Différence",
        accountDisplayed:
          "Les transactions liées à la banque seront affichées lorsqu'elles seront ajoutées",
      },
      transaction: {
        title: "Opérations bancaires",
        title1: "Répartition des opérations bancaires",
        description: "Consultez vos opérations bancaires ici",
        totalCredit: "Crédit total",
        totalDebit: "Débit total",
        balance: "Équilibre",
        totalBalance: "Solde total",
        previous: "Précédent",
        currentPage: "Page actuelle",
        next: "Suivant",
        noTransaction:
          "Vous n'avez actuellement aucune transaction bancaire en direct",
        accountDisplayed:
          "Les transactions bancaires en direct seront affichées lorsqu'elles seront ajoutées",
      },
      posTerminal: {
        description:
          "Vous pouvez attribuer et réattribuer POS à une station sélectionnée ici",
        between: "Transactions au point de vente entre",
        transactionDate: "Date de la transaction",
        pump: "Pompe",
        maskedPan: "Casserole masquée",
      },
      terminal2: {
        title:
          "Vous pouvez attribuer et réattribuer POS à une station sélectionnée ici",
        allTerminals: "Toutes les bornes",
        id: "Identifiant du terminal",
        serialNum: "Numéro de série",
        vendor: "Fournisseur",
        noTerminal: "Il n'y a actuellement aucun terminal créé",
      },
      bExpenses: {
        title: "Frais de gare",
        desc: "Vous pouvez filtrer les données en fonction d'une succursale et d'une région sélectionnées ici.",
        selectRegion: "Choisissez une région",
        allRegions: "Toute la région",
        selectBranch: "Sélectionnez la branche",
        allBranches: "Toutes les succursales",
        totalBranches: "Nombre total de succursales",
        expense: "Frais (NGN)",
      },
    },

    //COMPANY DRYSTOCK
    cDrystock: {
      stock: "le stock",
      edit: "Modifier",
      add: "Ajouter",
      product: {
        title: "Gérer les produits",
        description: "Gérez vos produits ici",
        createProduct: "Créer un produit",
        totalProduct: "Produit total",
        name: "Nom",
        desc: "Description",
        qtnUnit: "Quantité par unité",
        category: "Catégorie de produit",
        cate: "Catégorie",
        selectCate: "Choisir une catégorie",
        action: "Action",
        qtn: "Quantité",
        createHeader: "Produit non humide",
      },
      productStock: {
        description: "Afficher les détails des stocks pour",
      },
      supplies: {
        title: "Gérer les approvisionnements en stock sec",
        description: "Gérez vos approvisionnements ici...",
        addSupply: "Ajouter de l'approvisionnement",
        totalSupply: "Fournitures totales",
        totalCost: "Coût total",
        qtnSupplied: "Quantité fournie",
        date: "Date",
        station: "Gare",
        status: "Statut",
        action: "Action",
        supply: "Fournir",
        selectProd: "Sélectionner un produit",
        unitPrice: "Prix ​​unitaire",
        removeItem: "Retirer l'objet",
        selectStation: "Sélectionnez la station",
        enterDiscountAmount: "Entrez le montant de la remise",
        discountAmount: "le montant de la remise",
        totalQtn: "Quantité totale",
        totalPrice: "Prix ​​total",
        supplyAccepted: "Fourniture acceptée",
        supplyCompleted: "Fourniture terminée",
        noSupply: "Vous n'avez actuellement aucune offre ajoutée",
        noSupplyDesc:
          "Les fournitures seront ajoutées ici lorsqu'elles seront ajoutées",
        history: {
          title: "Historique des fournitures pour",
          description:
            "Consultez l'historique de vos fournitures de stock sec ici",
        },
        details: {
          title: "Détails de l'approvisionnement en stock sec?",
          description:
            "Consultez les détails de votre approvisionnement en stock sec ici",
        },
      },
      sales: {
        table: "Tableau",
        chart: "Graphique",
        companySales: "Ventes de l'entreprise",
        salesReport: "Rapport sur les ventes de l'entreprise entre",
        branch: "Bifurquer",
        date: "Date",
        dateOfSales: "Date de vente",
        branchName: "Nom de la filiale",
        stationName: "Nom de la station",
        tankName: "Nom du réservoir",
        product: "Produit",
        action: "Action",
        productCategory: "Catégorie de produit",
        vol: "Volume (litres)",
        amount: "Montant {currency}",
        total: "Tableau {currency}",
        totalSales: "ventes totales",
        posSales: "Ventes POS",
        retainerSales: "Ventes d'acompte",
        epumpSales: "Ventes à la pomper",
        expense: "frais",
        prevBal: "Solde précédent",
        previousBal: "Solde précédent",
        outstandingCash: "Trésorerie en circulation",
        cshFlow: "Des flux de trésorerie",
        compliance: "Conformité",
        selectBranch: "Sélectionnez la branche",
        cashVaultLimit: "Limite du coffre-fort",
        bankedCash: "Espèces en banque",
        totalVolumeSold: "Nombre total de volumes vendus par stations",
        totalSoldPrice: "Prix de vente total",
        totalQuantitySold: "Quantité totale vendue",
        quantitySupplied: "Quantité fournie",
        totalSupplies: "Fournitures totales",
        total: "Coût total",
        totalPrice: "Prix ​​total",
        totalVolumeForDealers:
          "Volumes totaux de produits vendus par les revendeurs",
        dealerSalesSummary: "Résumé des ventes du concessionnaire",
        groupSalesSummary: "Résumé des ventes de groupe",
        salesHistoryFor: "Historique des ventes pour",
        branchSales: "Ventes en succursale",
        stationSales: "Ventes en gare",
        state: "État",
        cashFlow: "Flux de trésorerie entre",
        totalCost: "Coût total",
        and: "et",
        regionSales: "Ventes régionales",
        status: "Statut",
        unitPrice: "Prix ​​unitaire",
        region: "Région",
        pmsPumpSale: "Vente de pompes PMS",
        pmsVolume: "Volume PMS",
        agoVolume: "Volume AGO",
        dpkVolume: "Volume DPK",
        lpgVolume: "Volume de LPG",
        pmsTankSale: "Vente de réservoirs PMS",
        pmsSurplus: "Excédent du PMS",
        agoPumpSale: "Ago Pompe Vente",
        agoTankSale: "Vente de chars Ago",
        agoSurplus: "Excédent antérieur",
        dpkPumpSale: "Vente de pompes DPK",
        dpkTankSale: "Vente de chars DPK",
        dpkSurplus: "Excédent DPK",
        quantitySold: "Quantité vendue",
        productSaleBreakdown: "Répartition des ventes de produits pour",
        on: "sur",
        suppliesHistoryFor: "Historique des fournitures pour",
        saleDetailsFor: "Détails de la vente pour",
        dryStockSale:
          "Consultez la répartition de vos ventes de stocks secs ici...",
        dryStockDetails:
          "Consultez les détails de votre vente de stock sec ici...",
        dryStockHistory:
          "Consultez l'historique de vos ventes de stocks secs ici...",
        dryStockSupplyDetail:
          "Consultez les détails de votre approvisionnement en stock sec ici...",
        supplyAccepted: "Fourniture acceptée",
        supplyCompleted: "Fourniture terminée",
        manageDryStock: "Gérer les approvisionnements en stock sec",
        manageDryStockSales: "Gérer les ventes de stock sec",
        dryStockSupply: "Détails de l'approvisionnement en stock sec",
        dryStockSupplies: "Gérez ici vos approvisionnements en stock sec",
        tankSales: "Ventes de réservoirs",
        volFilled: "Volume rempli (litres)",
        volSold: "Volume vendu (litres)",
        tankStock: "Stock de réservoir",
        ltrs: "litres",
        pms: "Essence",
        nA: "N / A",
        ago: "Gasoil",
        dpk: "DPK",
        lpg: "LPG",
        tankVariance: "Écart de réservoir",
        title: "Ventes de produits",
        description: "Gérez vos ventes de stock sec ici...",
        totalSales: "Ventes totales",
        totalSoldPrice: "Prix de vente total",
        totalQtnSold: "Quantité totale vendue",
        date: "Date",
        station: "Gare",
        discount: "Prix ​​bas",
        qtnSold: "Quantité vendue",
        totalPrice: "Prix total {currency}",
        action: "Action",
        breakDown: {
          title: "Répartition des ventes de produits pour",
          desc: "voir la répartition de vos ventes de stock sec ici...",
          customer: "Client",
        },
        details: {
          title: "Détails de la vente pour",
          desc: "voir les détails de votre vente de stock sec ici...",
        },
        history: {
          title: "Historique des ventes pour",
          desc: "Consultez l'historique de vos ventes de stocks secs ici...",
        },
      },
      // sales: {},
      branchStock: {
        title: "Stock de produits de la branche",
        description:
          "Sélectionnez une succursale pour voir le stock de produits correspondant ici",
        selectBranch: "Sélectionnez la branche",
        totalStock: "Stock total",
        station: "Gare",
        totalQtnSupplied: "Quantité totale fournie",
        totalQtnSold: "Quantité totale vendue",
        product: "Nom du produit",
        qtnSupplied: "Quantité fournie",
        qtnRemaining: "Quantité restante",
        qtnSold: "Quantité vendue",
        action: "Action",
      },

      categories: {
        title: "Catégories de produits de stock sec",
        description: "Gérez vos catégories de produits de stock sec ici...",
        createCate: "Créer une catégorie",
        totalCate: "Catégorie totale",
        name: "Nom",
        desc: "Description",
        action: "Action",
        add: "Ajouter",
        save: "Sauvegarder",
        successfullyCreated: "Catégorie créée avec succès",
        successfullyUpdated: "Catégorie mise à jour avec succès",
      },
    },

    //company partners
    cPartners: {
      managePartners: "Gérer les partenaires acquéreurs",
      managePartnersHere: "Gérez vos partenaires acquéreurs ici...",
      addPartner: "Ajouter un partenaire",
      totalPartners: "Nombre total de partenaires",
    },

    //COMPANY SALES SUMMARY
    cSalesSummary: {
      title: "Résumé des ventes de l'entreprise",
      state: "État",
      date: "Date",
      region: "Région",
      pmsPump: "Vente de pompes PMS",
      pmsTank: "Vente de réservoirs PMS",
      pmsSurplus: "Excédent du PMS",
      agoPump: "Vente de pompes AGO",
      agoTank: "Vente de chars AGO",
      agoSurplus: "AGO Excédent",
      dpkPump: "Vente de pompes DPK",
      dpkTank: "Vente de chars DPK",
      dpkSurplus: "Excédent DPK",
      branch: "Bifurquer",
      station: "Gare",
    },

    //COMPANY STOCK VALUATION
    cStockValuation: {
      title: "Valorisation des stocks",
      noStock: "Aucune valorisation des stocks enregistrée",
      curVol: "Volume actuel",
      valuation: "Évaluation",
    },

    //COMPANY DAILY BRANCH TRANSACTION
    cBranchTransaction: {
      title: "Transactions quotidiennes en succursale",
      description:
        "Vous pouvez voir les transactions quotidiennes de la succursale ici...",
      reportBetween: "Transactions quotidiennes en succursale sur",
      state: "État",
      region: "Région",
      product: "Produit",
      transactionCount: "Nombre de transactions",
      station: "Gare",
    },

    // Company disconnected pumps
    cDisconnectedPumps: {
      title: "Pompes déconnectées de l'entreprise",
      deviceId: "Appareil Id",
      pump: "Pompe",
      branchName: "Nom de la station",
      date: "Date",
      disconnectedHistory: "Historique déconnecté",
      startTime: "Heure de début",
      disconnectionHistory: "Historique des déconnexions",
      endTime: "Heure de fin",
      salesReport: "Rapport des ventes",
      nA: "N / A",
      ltrs: "Ltrs",
      kg: "Kg",
    },

    // Company offline pumps
    cOfflinePumps: {
      title: "Pompes hors ligne",
      deviceId: "Reference de l'appareil",
      nozzles: "Buses (si pompe)",
      branchName: "Nom de la station",
      lastDate: "Dernier rendez-vous",
    },

    // Our Dealers
    dealers: {
      title: "Nos concessionnaires",
      details: "Détails",
      branches: "Gares",
      searchDealers: "Rechercher des revendeurs",
      selectDate: "sélectionner la date et l'heure de début",
      selectEndDate: "sélectionner la date et l'heure de fin",
    },

    // Dealer Details
    dealerDetails: {
      title: "Détails du concessionnaire",
      street: "Rue",
      city: "Ville",
      state: "État",
      goBack: "Retour aux concessionnaires",
      street: "Rue",
      city: "Ville",
      state: "État",
    },

    // Driver
    // Assign Truck
    assignTruck: {
      title: "Camions",
      assignTruck: "Attribuer un camion",
      truckName: "Nom du camion",
      plateNumber: "Numéro de la plaque",
      tankType: "Type de réservoir",
      capacity: "Capacité",
      successfullyAssignedTruck: "Camion attribué avec succès",
      failedToAssign: "Échec de l'attribution du camion",
      assignToDriver: "Attribuer au conducteur",
      assignToTruck: "Attribuer au camion",
    },

    // Assigned Orders
    assignedOrders: {
      title: "Commandes attribuées",
      companyName: "Nom de l'entreprise",
      contactName: "Nom du contact",
      contactPhone: "Numéro du contact",
      driverName: "Nom du chauffeur",
      state: "État",
      quantity: "Quantité",
      status: "Statut",
      product: "Produit",
      successfullyAssignedTruck: "Camion attribué avec succès",
      failedToAssign: "Échec de l'attribution du camion",
    },

    // Assigned Truck
    assignedTruck: {
      title: "Camion assigné | Camions assignés",
      truckName: "Nom du camion",
      plateNumber: "Numéro de la plaque",
      tankType: "Type de réservoir",
      capacity: "Capacité",
    },

    // Customer Location
    customerLocation: {
      totLoc: "Emplacements totaux",
      locations: "Emplacements",
      desc: "Vous pouvez voir toute votre entreprise",
      desc1: "emplacements ici",
      locationName: "Nom de la localisation",
      longitude: "Longitude",
      latitude: "Latitude",
    },

    // Manage Drivers
    manageDrivers: {
      title: "Chauffeur d'entreprise | Chauffeurs de l'entreprise",
      addDriver: "AJOUTER UN CHAUFFEUR",
      fullName: "Nom et prénom",
      email: "E-mail",
      phoneNo: "Pas de téléphone.",
      assignedOrders: "Commandes attribuées",
      assignTruck: "Attribuer un camion",
      assignedTrucks: "Camions assignés",
      successfullyDeletedDriver: "Pilote supprimé avec succès",
      failedToDelete: "Impossible de supprimer le pilote",
      confirmDelete: "Voulez-vous vraiment supprimer ce pilote ?",
    },

    // Manage Trucks
    manageTrucks: {
      title: "Camion d'entreprise | Camions d'entreprise",
      addTruck: "AJOUTER UN CAMION",
      truckName: "Nom du camion",
      plateNumber: "Numéro de la plaque",
      tankType: "Type de réservoir",
      capacity: "Capacité",
      successfullyDeletedTruck: "Pilote supprimé avec succès",
      failedToDelete: "Impossible de supprimer le pilote",
      confirmDelete: "Voulez-vous vraiment supprimer ce pilote ?",
    },

    // Fund Wallet Request
    fundWalletRequest: {
      title: "Demande de fonds de portefeuille",
      showAll: "Afficher tout",
      approved: "approuvé",

      pending: "En attente",
      depositorsName: "Nom du déposant",
      amountPaid: "Le montant payé",
      bankName: "Nom de banque",
      depositSlipNo: "Bordereau de dépôt n°",
      datePaid: "Date de paiement",
      requestDate: "Date de la demande",
      walletCredited: "Portefeuille crédité",
      approveRequest: "Approuver la demande",
      successfullyApproved: "Demande de fonds approuvée avec succès",
    },

    // Branch

    // Mail Recipient
    mailRecipient: {
      title: "Destinataires du courrier",
      addRecipient: "Ajouter un destinataire à la station",
      add: "Ajouter ",
      emailPlaceholder: "E-mail *",
      phonePlaceholder: "Téléphone",
      email: "E-mail ",
      phone: "Numéro de téléphone",
      successfullyRemoved: "Destinataire du courrier supprimé avec succès",
      successfullyAdded: "Destinataire du courrier ajouté avec succès",
      confirmDelete: "Voulez-vous vraiment supprimer ce destinataire ?",
    },

    // Targets
    targets: {
      title: "Cibles",
      branchTargets: "Cibles des points de vente au détail",
      createTarget: "Créer une cible",
      product: "Produit",
      quantity: "Quantité",
      emptyTarget: "Vous n'avez actuellement aucun enregistrement cible",
      editTarget: "Modifier la cible",
      deleteTarget: "Supprimer la cible",
      confirmDelete: "Voulez-vous vraiment supprimer cette cible ?",
      successfullyDeleted: "Cible supprimée avec succès",

      targetNotFound:
        "Nous n'avons pas trouvé de cible de produits existante à supprimer ou elle a déjà été supprimée",
      unsuccessfulDelete: "Échec de la suppression de la cible",
    },

    // Manage Expenses Section
    // Bank Accounts
    bankAccounts: {
      noOfBankAccounts: "Nombre de comptes bancaires",
      bankName: "Nom de banque",
      selectBankName: "Sélectionnez un nom de banque",
      accountNumber: "Numéro de compte",
      inputAccountNumber: "Numéro de compte",
      accountName: "Nom du compte",
      inputAccountName: "Nom du compte",
      save: "Sauver",
      name: "Nom",
      accountNo: "N ° de compte.",
      delete: "Supprimer",
      emptyBankRecord:
        "Vous n'avez actuellement aucun enregistrement de compte bancaire",
      selectBankError: "Veuillez sélectionner une banque",
      bankAdded: "Compte bancaire ajouté avec succès",
      confirmDelete: "Voulez-vous vraiment supprimer ce compte ?",
      successfullyDeleted: "Compte bancaire supprimé avec succès",
      unsuccessfulDelete: "Impossible de supprimer le compte bancaire",
      linkedAccounts:
        "Cette icône indique les comptes bancaires liéscela signifie que nous confirmons",
      multipleLinkedAccounts:
        "votre dépôt sur le compte. Vous pouvez avoir plusieurs comptes liés",
      accountsShow: "Les comptes ajoutés s'afficheront ici",
      bankDeposits: "Dépôts de banque",
      amountPaid: "Le montant payé",
      amountRaised: "Montant collecté",
      difference: "Différence",
      noLinkedTransaction:
        "Vous n'avez actuellement aucune transaction liée à une banque",
      bankTransDisplay:
        "Les transactions liées à la banque seront affichées lorsqu'elles seront ajoutées",
      dateCreated: "Date créée",
      dateLinked: "Date de liaison",
      transactionReference: "Référence de l'opération",
      station: "Gare",
      summary: "Sommaire",
      bank: "Banque",
      linked: "lié",
      linkedService: "Service lié",
      status: "Statut",
      bankTrans: "Opérations bancaires",
      viewBankTrans: "Consultez vos opérations bancaires ici...",
      totalCredit: "Crédit total:",
      totalDebit: "Débit total :",
      balance: "Équilibre:",
      bal: "Équilibre:",
      noLiveTrans:
        "Vous n'avez actuellement aucune transaction bancaire en direct",
      displayLiveTrans:
        "les transactions bancaires en direct seront affichées lorsqu'elles seront ajoutées",
      action: "Action",
      debit: "Débit",
      credit: "Crédit total:",
      bankTransBreakdown: "Répartition des opérations bancaires",
      date: "Date",
      amount: "Montant",
      type: "Taper",
      narration: "Narration",
    },

    // Categories
    categories: {
      title: "Catégories",
      createCategory: "Créer une catégorie",
      inputCategoryPlaceholder: "Catégorie d'entrée",
      create: "Créer",
      category: "Catégorie",
      dateCreated: "date créée",
      confirmDelete: "Voulez-vous vraiment supprimer cette catégorie ?",
      successfullyDeleted: "Catégorie supprimée avec succès",
      unsuccessfulDelete: "Échec de la suppression de la catégorie",
      successfullyAdded: "Catégorie ajoutée avec succès",
      inputCategory: "Veuillez entrer une catégorie",
      dryStock: "Catégories de produits de stock sec ici...",
      manageDryStock: "Gérez vos catégories de produits de stock sec ici...",
      totalCategories: "Catégories totales",
      name: "Nom",
      customer: "Client",
      desc: "Description",
      quantity: "Quantité",
      action: "Action",
      selectBranch: "Sélectionnez la branche",
      unitPrice: "Prix ​​unitaire",
      nonWetProduct: "Produit non humide",
      categories: "Catégories",
      selectCategory: "Choisir une catégorie",
      quantityPerUnit: "Quantité par unité",
      quantitySupplied: "Quantité fournie",
      addSupply: "Ajouter de l'approvisionnement",
      enterDiscount: "Entrez le montant de la remise",
      totalQuantity: "Quantité totale:",
      totalPrice: "Prix ​​total:",
      submitSupplies: "Soumettre les fournitures",
      noSuppliesAdded: "Vous n'avez actuellement aucune offre ajoutée",
      supplyAdded:
        "Les fournitures seront ajoutées ici lorsqu'elles seront ajoutées",
      stock: "Stock",
      viewStock: "afficher les détails des stocks pour",
      here: "ici",
      totalStock: "Stock total",
      totalQuantitySupplied: "Quantité totale fournie",
      totalQuantitySold: "Quantité totale vendue",
      productName: "Nom du produit",
      productCategory: "catégorie de produit",
      branch: "Bifurquer",
      station: "Gare",
      discountPrice: "Prix ​​bas",
      quantitySold: "Quantité vendue",
      quantityRemaining: "Quantité restante",
      dateOfSales: "Date de vente",
      service: "Service",
      addTransaction: "Ajouter une opération",
      trans: "transaction",
      totalPrice: "Prix ​​total",
      totalPrc: "Prix ​​total",
      customerName: "Entrez le nom du client",
      selectBranch: "Sélectionnez la branche",
      submit: "Soumettre",
      noTransAdded: "Vous n'avez actuellement aucune transaction ajoutée",
      transAdded:
        "les transactions seront ajoutées ici lorsqu'elles seront ajoutées",
    },

    // Manage Expenses
    manageExpenses: {
      totalExpenses: "Nombre de dépenses",
      title: "Gérer les dépenses",
      companyExpensesBetween: "Dépenses de l'entreprise entre",
      expensesBreakdown: "Répartition des dépenses",
      income: "Revenu",
      expenses: "Dépenses",
      retailOutlets: "Points de vente au détail",
      amount: "Montant",
      account: "Compte",
      successfullyDeleted: "Catégorie supprimée avec succès",
      unsuccessfulDelete: "Impossible de supprimer la catégorie",
      confirmDelete: "Voulez-vous vraiment supprimer cette catégorie ?",
      branchExpenses: "Dépenses des succursales",
      filterData:
        "Vous pouvez filtrer les données en fonction d'une succursale et d'une région sélectionnées ici.",
      selectRegion: "Choisissez une région",
      allRegions: "Toutes les régions",
      selectBranch: "Sélectionnez la branche",
      allBranches: "Toutes les succursales",
      totalBranches: "Nombre total de succursales",
      branch: "Bifurquer",
      station: "Gare",
      region: "Région",
      expense: "Dépense(NGN)",
      expenseCategory: "Dépenses par catégories",
      allCategories: "Toutes catégories",
      totalExpense: "Dépense totale",
      expenseBreakdown: "Répartition des dépenses pour",
      date: "Date",
      retailOutlets: "Commerces de détail",
      description: "Description",
      category: "Catégorie",
    },

    // Orders Section
    // Add Order
    addOrder: {
      title: "Créer une commande",
      orderInformation: "Informations sur la commande",
      quantity: "Quantité",
      contactName: "Nom du contact",
      paymentMode: "Mode de paiement",
      cash: "argent",
      cheque: "Vérifier",
      transfer: "Transfert",
      paid: "Payé",
      true: "Vrai",
      false: "FAUX",
      deliveryHours: "Heures de livraison",
      product: "Produit",
      selectAProduct: "choisissez un produit",
      contactInformation: "Informations de contact",
      street: "Rue",
      city: "Ville",
      state: "État",
      contactPhone: "Numéro du contact",
      phonePlaceholder: "Pas de téléphone.",
      productMissing: "Veuillez sélectionner un produit",
      quantityMissing: "Veuillez entrer une quantité",
      deliveryHoursMissing: "Veuillez saisir une heure de livraison",
      successfullyCreated: "Commande créée avec succès",
      unsuccessfullyCreated: "Échec de l'ajout de la commande",
    },

    // Assign Driver
    assignDriver: {
      drivers: "chauffer",
      title: "Attribuer un chauffeur",
      fullName: "Nom et prénom",
      email: "E-mail",
      phoneNo: "Pas de téléphone.",
      successfullyAssigned: "Chauffeur assigné avec succès",
      unsuccessfullyAssigned: "Échec de l'attribution du chauffer",
    },

    // Edit Order
    editOrder: {
      title: "Modifier la commande",
      orderInformation: "Informations sur la commande",
      quantity: "Quantité",
      contactName: "Nom du contact",
      status: "Statut",
      driverAssigned: "Chauffeur assigné",
      paymentPending: "Paiement en attente",
      paymentCompleted: "Paiement terminé",
      paymentConfirmed: "Paiement accepté",
      orderCompleted: "Commande terminée",
      orderAccepted: "Commande acceptée",
      orderRejected: "Commande rejetée",
      processing: "Traitement",
      inTransit: "En transit",
      arrived: "Arrivé",
      ownerAccepted: "Propriétaire accepté",
      fillStarted: "Remplissage commencé",
      fillEnded: "Remplissage terminé",
      product: "Produit",
      selectAStatus: "Sélectionnez un statut",
      selectAProduct: "Choisissez un produit",
      contactInformation: "Informations de contact",
      street: "Rue",
      city: "Ville",
      state: "État",
      contactPhone: "Numéro du contact",
      phonePlaceholder: "Pas de téléphone.",
      updateOrder: "Mettre à jour la commande",
      quantityMissing: "Veuillez saisir une quantité",
      deliveryHoursMissing: "Veuillez saisir une heure de livraison",
      successfullyUpdated: "Commande mise à jour avec succès",
    },

    // Manage Orders
    manageOrders: {
      title: "Ordres",
      showAll: "Montre tout",
      driverAssigned: "Chauffeur assigné",
      paymentPending: "Paiement en attente",
      paymentCompleted: "Paiement terminé",
      paymentConfirmed: "Paiement confirmé",
      orderCompleted: "Commande terminée",
      orderAccepted: "Commande acceptée",
      orderRejected: "Commande rejetée",
      processing: "En traitement",
      inTransit: "En transit",
      arrived: "Arrivé",
      ownerAccepted: "Propriétaire accepté",
      fillStarted: "Remplissage commencé",
      fillEnded: "Remplissage terminé",
      orderStatusFilter: "Filtre de statut de commande",
      contactName: "Nom du contact",
      contactPhone: "Numéro du contact",
      status: "Statut",
      quantity: "Quantité",
      city: "Ville",
      state: "État",
      assignDriver: "Attribuer un chauffeur",
      editOrder: "Modifier la commande",
      updateStatus: "État de mise à jour",
      confirmDelete: "Voulez-vous vraiment supprimer cette commande ?",
      successfullyDeleted: "commande supprimée avec succès",
      unsuccessfulDelete: "Échec de la suppression de la commande",
    },

    // Company Price Management
    priceManagement: {
      title: "Change le prix",
      priceChangeLog: "Journal des modifications de prix",
      companyPriceUpdate: "Mise à jour des prix de l'entreprise",
      selectZone: "CHOISIR LA RÉGION | sélectionner une région",
      selectState: "CHOISIR L'ÉTAT | sélectionner l'état",
      selectProduct: "SÉLECTIONNER UN PRODUIT",
      newPrice: "NOUVEAU PRIX | Nouveau prix",
      retailOutlets: "Points de vente au détail",
      searchRetailOutlets: "Rechercher des points de vente au détail",
      selectAllRetailOutlets: "Sélectionnez tous les points de vente au détail",
      updateNow: "Mettez à jour maintenant",
      scheduleUpdate: "Mise à jour de l'horaire",
      recentlyUpdated: "Récemment mis à jour",
      formerPrice: "Ancien prix",
      updatedPrice: "Prix ​​actualisé",
      viewMore: "Voir plus",
      branchName: "Nom de la station",
      product: "Produit",
      currentPrice: "Prix ​​actuel",
      previousPrice: "Prix précédent",
      changedBy: "Changé par",
      date: "Date",
      password: "Mot de passe",
      cancel: "Annuler",
      submit: "Soumettre",
      selectProductSmall: "Sélectionner le produit",
      selectBranch:
        "Veuillez sélectionner au moins un point de vente au détail",
      successfullyChanged: "Prix modifié avec succès",
      putPassword: "Veuillez saisir votre mot de passe",
      putToken: "Veuillez saisir votre jeton",
      sendingToken: "Attendez, nous envoyons un jeton à",
      tokenExpired: "Jeton expiré, cliquez ici pour renvoyer",
      tokenExpire: "Le jeton a été envoyé à",
      tokenExpire2: "et expirera dans",
      token: "Jeton",
      branchPriceUpdate: "Mise à jour des prix de la succursale",
    },

    // Product
    // Add Product
    addProduct: {
      title: "Ajouter produit",
      productInformation: "Information produit",
      product: "Produit",
      selectAProduct: "Sélectionnez un produit",
      price: "Prix",
      state: "État",
      localGovArea: "Zone de gouvernement local",
      localGov: "Gouvernement local",
      deliveryHour: "Heure de livraison",
      addMore: "Ajouter plus",
      addProduct: "Ajouter un produit",
      selectLGA: "Veuillez sélectionner une LGA",
      deliveryHourMissing: "Veuillez saisir une heure de livraison",
      successfullyAdded: "Produit ajouté avec succès",
      invalidDeliveryHour: "Veuillez entrer une heure de livraison valide",
    },

    // Products
    deliverableProducts: {
      totalDeliverableProd:
        "Produit livrable total | Total des produits livrables,",
      addProduct: "Ajouter un produit",
      productName: "Nom du produit",
      price: "Prix",
      state: "État",
      noOfDeliverableLGAs: "Nombre de LGA livrables",
      manageLGAs: "Gérer les LGA",
      confirmDelete: "Voulez-vous vraiment supprimer ce produit ?",
      successfullyDeleted: "Produit supprimé avec succès",
      unsuccessfulDelete: "Échec de la suppression du produit",
    },
    // Product LGAs
    productLGA: {
      title: "LGAs",
      localGovAreas: "Zones de gouvernement local",
      lgaName: "Nom LGA",
      deliveryHour: "Heure de livraison",
    },

    // Profile
    profile: {
      accountSettings: "Paramètres du compte",
      email: "E-mail",
      firstName: "Prénom",
      lastName: "Nom de famille",
      phoneNumber: "Numéro de téléphone",
      editProfile: "Editer le profil",
      changeYourPassword: "Changez votre mot de passe",
      oldPassword: "ancien mot de passe",
      newPassword: "nouveau mot de passe",
      confirmPassword: "Confirmez le mot de passe",
      passwordMustContain: "Le mot de passe doit contenir",
      oneNumeric: "Un caractère numérique",
      specialCharacter: "Un caractère spécial",
      changePassword: "Changer le mot de passe",
      successfullyChanged: "Mot de passe changé avec succès !",
      fillIn: "Remplissez les champs manquants",
      updated: "Profil mis à jour avec succès",
      passwordBlank: "Le champ Mot de passe ne peut pas être vide",
      passwordsDontMatch: "Les mots de passe ne correspondent pas",
      oneNumbericCharacter: "Un caractère numérique",
      oneSpecialCharacter: "Un caractère spécial",
    },

    // Retainerhip
    companyRetainership: {
      title: "acompte",
      addExisting: "Ajouter existant",
      addNew: "Ajouter un nouveau mandat",
      firstName: "Prénom",
      lastName: "Nom de famille",
      email: "E-mail",
      balance: "Équilibre",
      creditLimit: "Limite de crédit",
      walletTransactions: "Transactions de portefeuille",
      loyaltyPts: "Points de fidélité",
      downloadReport: "Télécharger le rapport",
      generate: "Générer",
    },

    walletTransactions: {
      title: "Transactions de portefeuille",
      transBetween: "Transactions de portefeuille entre",
      date: "Date",
      status: "Statut",
      amount: "Montant",
      currentBalance: "Solde actuel",
      description: "Description",
      newBal: "Nouvel équilibre",
    },

    // Company Sales Report
    sales: {
      table: "Tableau",
      chart: "Graphique",
      companySales: "Ventes de l'entreprise",
      salesReport: "Rapport sur les ventes de l'entreprise entre",
      branch: "Bifurquer",
      date: "Date",
      dateOfSales: "Date de vente",
      branchName: "Nom de la filiale",
      stationName: "Nom de la station",
      tankName: "Nom du réservoir",
      product: "Produit",
      action: "Action",
      productCategory: "Catégorie de produit",
      vol: "Volume (litres)",
      amount: "Montant {currency}",
      total: "Tableau {currency}",
      totalSales: "ventes totales",
      posSales: "Ventes POS",
      retainerSales: "Ventes d'acompte",
      epumpSales: "Ventes à la pomper",
      expense: "frais",
      prevBal: "Solde précédent",
      previousBal: "Solde précédent",
      outstandingCash: "Trésorerie en circulation",
      cshFlow: "Des flux de trésorerie",
      compliance: "Conformité",
      selectBranch: "Sélectionnez la branche",
      cashVaultLimit: "Limite du coffre-fort",
      bankedCash: "Espèces en banque",
      totalVolumeSold: "Nombre total de volumes vendus par stations",
      totalSoldPrice: "Prix de vente total",
      totalQuantitySold: "Quantité totale vendue",
      quantitySupplied: "Quantité fournie",
      totalSupplies: "Fournitures totales",
      total: "Coût total",
      totalPrice: "Prix ​​total",
      totalVolumeForDealers:
        "Volumes totaux de produits vendus par les revendeurs",
      dealerSalesSummary: "Résumé des ventes du concessionnaire",
      groupSalesSummary: "Résumé des ventes de groupe",
      salesHistoryFor: "Historique des ventes pour",
      branchSales: "Ventes en succursale",
      stationSales: "Ventes en gare",
      state: "État",
      cashFlow: "Flux de trésorerie entre",
      totalCost: "Coût total",
      and: "et",
      regionSales: "Ventes régionales",
      status: "Statut",
      unitPrice: "Prix ​​unitaire",
      region: "Région",
      pmsPumpSale: "Vente de pompes PMS",
      pmsVolume: "Volume PMS",
      agoVolume: "Volume AGO",
      dpkVolume: "Volume DPK",
      lpgVolume: "Volume de LPG",
      pmsTankSale: "Vente de réservoirs PMS",
      pmsSurplus: "Excédent du PMS",
      agoPumpSale: "Ago Pompe Vente",
      agoTankSale: "Vente de chars Ago",
      agoSurplus: "Excédent antérieur",
      dpkPumpSale: "Vente de pompes DPK",
      dpkTankSale: "Vente de chars DPK",
      dpkSurplus: "Excédent DPK",
      quantitySold: "Quantité vendue",
      productSaleBreakdown: "Répartition des ventes de produits pour",
      on: "sur",
      suppliesHistoryFor: "Historique des fournitures pour",
      saleDetailsFor: "Détails de la vente pour",
      dryStockSale:
        "Consultez la répartition de vos ventes de stocks secs ici...",
      dryStockDetails:
        "Consultez les détails de votre vente de stock sec ici...",
      dryStockHistory:
        "Consultez l'historique de vos ventes de stocks secs ici...",
      dryStockSupplyDetail:
        "Consultez les détails de votre approvisionnement en stock sec ici...",
      supplyAccepted: "Fourniture acceptée",
      supplyCompleted: "Fourniture terminée",
      manageDryStock: "Gérer les approvisionnements en stock sec",
      manageDryStockSales: "Gérer les ventes de stock sec",
      dryStockSupply: "Détails de l'approvisionnement en stock sec",
      dryStockSupplies: "Gérez ici vos approvisionnements en stock sec",
      tankSales: "Ventes de réservoirs",
      volFilled: "Volume rempli (litres)",
      volSold: "Volume vendu (litres)",
      tankStock: "Stock de réservoir",
      ltrs: "litres",
      pms: "Essence",
      nA: "N / A",
      ago: "Gasoil",
      dpk: "DPK",
      lpg: "LPG",
      tankVariance: "Écart de réservoir",
      title: "Ventes de produits",
      description: "Gérez vos ventes de stock sec ici...",
      totalSales: "Ventes totales",
      totalSoldPrice: "Prix de vente total",
      totalQtnSold: "Quantité totale vendue",
      date: "Date",
      station: "Gare",
      discount: "Prix ​​bas",
      qtnSold: "Quantité vendue",
      totalPrice: "Prix total {currency}",
      action: "Action",
      breakDown: {
        title: "Répartition des ventes de produits pour",
        desc: "voir la répartition de vos ventes de stock sec ici...",
        customer: "Client",
      },
      details: {
        title: "Détails de la vente pour",
        desc: "voir les détails de votre vente de stock sec ici...",
      },
      history: {
        title: "Historique des ventes pour",
        desc: "Consultez l'historique de vos ventes de stocks secs ici...",
      },
    },

    // Company Tanks Filled Report
    tanksFilledReport: {
      title: "Produit déchargé",
      tanksFilledOn: "Produit déchargé le",
      branchName: "Nom de la station",
      tankName: "Nom du réservoir",
      eVolumeDischarged: "Volume de pompe déchargé (litres)",
      mVolumeDischarged: "Volume manuel déchargé (litres)",
      variance: "Variance",
      eStartVolume: "Volume de démarrage de la pompe (litres)",
      eVolumeEnd: "Volume final de la pompe (litres)",
      mStartVolume: "Volume de démarrage manuel (litres)",
      mEndVolume: "Volume final manuel (litres)",
      startTime: "Heure de début",
      endTime: "Heure de fin",
      plateNumber: "Numéro de la plaque",
      noTanksFilledOn: "Aucun produit déchargé sur",
    },

    // Company Variance Report
    varianceReport: {
      totalTransactions: "Transactions totales",
      showAll: "Afficher tout",
      productFilter: "Filtre de produit",
      title: "Rapport d'écart",
      eVolumeSold: "Lecture ATG",
      mVolumeSold: "Trempage manuel",
      variance: "Variance",
      total: "TOTAL",
      reportBetween: "Rapport d'écart de l'entreprise entre",
      date: "Date/Heure",
      branch: "Gare",
      product: "Produit",
      eVolumeSoldLtr: "Volume de pompe vendu (litres)",
      mVolumeSoldLtr: "Volume manuel vendu (litres)",
      atgReading: "Lecture ATG (litres)",
      manualDipping: "Trempage manuel (litres)",
      varianceLtr: "Écart (litres)",
      tankVarianceTitle: "Écart de réservoir",
      region: "Région",
      state: "État",
    },

    // AssignBranch In Zones
    assignBranch: {
      retailOutlets: "Points de vente",
      title: "Attribuer des points de vente",
      retailOutletName: "Nom du point de vente",
      city: "Ville",
      state: "État",
      successfullyAssigned: "Point de vente attribué avec succès",
      assignOutlet: "Attribuer une prise",
    },

    // Zones
    zones: {
      createAZone: "Créer une zone",
      zoneName: "Nom de zone",
      createZone: "CRÉER UNE ZONE",
      outletsAssigned: "Nombre de points de vente affectés",
      dateCreated: "date créée",
      viewOutlets: "Voir les points de vente",
      assignOutlets: "Attribuer des prises",
      pleaseInputZone: "Veuillez saisir une zone",
      successfullyCreatedZone: "Zone créée avec succès",
      successfullyDeleted: "Zone supprimée avec succès",
      unsuccessfulDelete: "Impossible de supprimer la zone",
      confirmDelete: "Voulez-vous vraiment supprimer cette zone ?",
    },

    // Branches in zone
    zoneBranches: {
      assignedOutlets: "Points de vente assignés",
      zonesOutlets: "Points de vente assignés à la région",
      outletName: "Nom du point de vente",
      city: "Ville",
      state: "État",
      unassignOutlet: "Désaffecter la prise",
      successfullyUnassigned: "Point de vente désaffecté avec succès",
      branchMissing: "Veuillez entrer une station",
    },

    /****Branch Portal */

    // Branch Master Layout
    bMasterLayout: {
      companyDashboard: "Tableau de bord de l'entreprise",
      dealerDashboard: "Tableau de bord du concessionnaire",
      groupDashboard: "Tableau de bord du groupe",
      regionDashboard: "Tableau de bord régional",
      dashboard: "Tableau de bord",
      report: "Rapports",
      inventoryReport: "Rapport d'inventaire",
      salesTransactions: "Opérations de vente",
      varianceReport: "Rapport d'écart",
      productSummary: "Informations sur le produit",
      pumpSummary: "Résumé de la pompe",
      endOfDayReport: "Rapport de fin de journée",
      tankReport: "Rapport de réservoir",
      tanksFilledReport: "Rapport de produit déchargé",
      posReport: "Rapport sur les transactions POS",
      tanks: "réservoirs",
      pumps: "Pompes",
      stationManagement: "Gestion des gares",
      updatePrice: "Mettre à jour le prix",
      pumpFaults: "Défauts de la pompe",
      pumpMaintenance: "Entretien de la pompe",
      eChannel: "Canaux électroniques",
      eSales: "E-vente",
      settlementAccount: "Compte de règlement",
      accounting: "Comptabilité",
      expenses: "Dépenses",
      bankAccounts: "Comptes bancaires",
      peopleManagement: "Ressources humaines",
      people: "Personnes",
      staff: "Personnel",
      shift: "Changement",
      settings: "Paramètres",
      profile: "Profil",
      signOut: "Se déconnecter",
      confirmLogout: "Voulez-vous vraiment vous déconnecter ?",
      pumpsVariance: "Écart des pompes",
      tanksVariance: "Écart des réservoirs",
      tanksFilled: "Réservoirs remplis",
      cashFlowReport: "Rapport de flux de trésorerie",
      tankDippings: "Trempages de réservoir",
      productsFilled: "Produits remplis",
      productsReceived: "Produits reçus",
      stockValuation: "Évaluation des stocks",
      productSales: "Ventes de produits",
      manualRecords: "Enregistrements manuels",
      rejectedEODrecord: "Enregistrement EOD rejeté",
      dryStockSales: "Ventes de stocks secs",
      manageServices: "Gérer les services",
      leases: "Baux",
      availableSpaces: "Espaces disponibles",
      availableOccupants: "Occupants disponibles",
      ratings: "Notes",
      branchRating: "Classement de la branche",
      branchRatingsBreakdown: "Répartition des notes de la branche",
      staffRatings: "Évaluations du personnel",
      sufficiencyMetrics: "Métriques de suffisance",
      manageUsers: "Gérer les utilisateurs",
      faultsAndMaintenance: "Défauts et entretien",
      bank: "Banque",
      bankDeposits: "Dépôts de banque",
      management: "Gestion",
      createDepositReference: "Créer une référence de dépôt",
      walletTransactions: "Transactions de portefeuille",
      settlementTransactions: "Opérations de règlement",
      posTerminals: "Terminaux de point de vente",
      invoices: "Factures",
      assets: "Actifs",
      supportAdmin: "Administrateur de l'assistance",
      logout: "Se déconnecter",
      networkError: "Erreur réseau Veuillez vérifier votre connexion Internet",
      errorOccured: "Une erreur s'est produite",
    },

    // Branch Dashboard
    bDashboard: {
      salesVTarget: "Ventes vs cible",
      tanksInStation: "Réservoirs en station",
      pumpsInStation: "Pompes en station",
      tanksFilled: "Produit déchargé en station",
      pumpsAvgTime: "Temps moyen des pompes par litre",
      secs: "secondes",
      estimatedPumpsCalibration: "Étalonnage estimé des pompes",
      pumpsFault: "Défaut des pompes",
      disconnectedPumps: "Nombre de pompes déconnectées",
      offlinePumps: "Nombre de pompes hors ligne",
      hourlyTransactions: "Transactions horaires par volume",
      productGuage: "Jauge de produit",
      tanksStock: "Stock de réservoirs par heure",
      salesReport: "Rapport des ventes",
      na: "N / A",
      dailyTcount: "Nombre de transactions quotidiennes",
      pmsAgo: "PMS / AGO",
    },

    // Branch disconnected pumps
    bDisconnectedPumps: {
      title: "Pompes déconnectées",
      deviceId: "Reference de l'appareil",
      pump: "Pompe",
      date: "Date",
    },

    // Branch offline pumps
    bOfflinePumps: {
      title: "Pompes hors ligne",
      deviceId: "Reference de l'appareil",
      nozzles: "Buses (si pompe)",
      lastDate: "Dernier rendez-vous",
    },

    // Pumps average time per litre
    avgTimePerLitre: {
      title: "Temps moyen des pompes par litre",
      displayName: "Afficher un nom",
      avgTimePerLitre: "Temps moyen par litre (secondes)",
      totalTime: "Temps total",
      totalSale: "Vente totale (Ltr)",
      date: "Date",
    },

    // Pumps calibration
    pumpsCalibration: {
      title: "Étalonnage des pompes",
      calibrationRatio: "Rapport d'étalonnage",
      pumpName: "Nom de la pompe",
      calibrate: "Étalonner",
      calLog: "Journal d'étalonnage",
      calibration: "ÉTALONNAGE",
      successfullyChanged: "Étalonnage modifié avec succès",
      selectNone: "sélectionnez aucun pour tout calibrer",
      tTBC: "BASCULER L'ETALONNAGE LIMITE DANS LE TEMPS",
      TBC: "ÉTALONNAGE LIMITÉ DANS LE TEMPS",
      startingHour: "HEURE DE DÉBUT",
      selectSH: "sélectionner une heure de départ",
      closingHour: "HEURE DE FERMETURE",
      selectCH: "sélectionner une heure de fermeture",
      curCal: "Eta. courant.",
      prevCal: "Eta. précédent.",
      timeBound: "Limité dans le temps",
      errorSC:
        "l'heure de début ne peut pas être supérieure ou égale à l'heure de fermeture",
      yes: "OUI",
      no: "NON",
    },

    // Bank Accounts
    bBankAccounts: {
      noBankAccts: "Nombre de comptes bancaires",
      bankName: "Nom de banque",
      selectBankName: "Sélectionnez une banque",
      accountNumber: "Numéro de compte",
      accountName: "Nom du compte",
      inputAccountNumber: "Numéro de compte",
      inputAccountName: "Nom du compte",
      bank: "Banque",
      bankCode: "Code bancaire",
      save: "Sauvegarder",
      name: "Nom",
      accountNo: "N ° de compte.",
      delete: "Supprimer",
      emptyBankRecord:
        "Vous n'avez actuellement aucun enregistrement de compte bancaire",
      confirmDelete: "Voulez-vous vraiment supprimer ce compte ?",
      selectBankError: "Veuillez sélectionner une banque",
      selectAccountError: "Veuillez sélectionner un compte à ajouter",
      bankAdded: "Compte bancaire ajouté avec succès",
      successfullyDeleted: "Compte bancaire supprimé avec succès",
      unsuccessfulDelete: "Impossible de supprimer le compte bancaire",
      addBank: "Ajouter une banque",
      addedBankLink: "Dépôt lié à la banque ajouté avec succès",
      iconLinked:
        "Cette icône indique les comptes bancaires liés, cela signifie que nous confirmons votre dépôt sur le compte. Vous pouvez avoir plusieurs comptes liés",
      removeBank: "Supprimer la banque",
      accountAddShow: "Les comptes ajoutés s'afficheront ici",
      bankAccountRequired: "Sélectionnez un compte bancaire",
      amountRequired: "Le montant est requis",
      inventoryReport: "Rapport d'inventaire",
      lastFilledDate: "Date du dernier remplissage",
      lastFilledVolume: "Dernier volume rempli",
      avgProductDispensePerDay: "Distribution moyenne par jour",
      bankAccounts: "comptes bancaires",
      reconcileBankDepo:
        "Liez vos comptes bancaires pour rapprocher les dépôts bancaires",
      addNewBank: "Ajouter une nouvelle banque",
      bankAccountList: "Liste des comptes bancaires au compte.",
      linkedAccount:
        "Cette icône indique les comptes bancaires liés, cela signifie que nous confirmons",
      multipleAccounts:
        "votre dépôt sur le compte. vous pouvez avoir plusieurs comptes liés",
      removeBank: "Supprimer la banque",
      accountsShow: "Les comptes ajoutés s'afficheront ici",
      noLinkedBank: "Vous n'avez actuellement aucune banque liée",
      bankAccountDisplay:
        "Les comptes bancaires seront affichés une fois ajoutés",
      removeAccount: "Voulez-vous vraiment supprimer ce compte ?",
      successfullyRemoved: "Compte supprimé avec succès",
    },

    // Bank Linked Deposit
    bBankLinked: {
      title: "Dépôts liés à la banque",
      addBLinked: "Ajouter un dépôt lié à une banque",
      description:
        "entrez le montant et sélectionnez le compte bancaire que vous souhaitez ajouter",
      amount: "Montant",
      selectAccount: "Sélectionnez un compte",
      submit: "Soumettre",
      delete: "Supprimer",
    },

    // Linked Bank Account
    bLinkedBank: {
      title: "comptes bancaires",
      description:
        "Liez vos comptes bancaires pour rapprocher les dépôts bancaires",
      description2: "payer un abonnement mensuel, etc..",
      addNewBank: "Ajouter une nouvelle banque",
      listBankAcc: "Liste des comptes bancaires",
      dateCreated: "date créée",
      transactionRef: "Référence transactionnelle",
      summary: "Sommaire",
      linked: "Lié",
      noBankLinked: "Vous n'avez actuellement aucune banque liée",
      bankAccDisplayed:
        "Les comptes bancaires seront affichés une fois ajoutés",
      bankTraDisplayed:
        "Les transactions liées à la banque seront affichées lorsqu'elles seront ajoutées",
    },

    // Bank Deposit
    bBankDeposit: {
      title: "Dépôts de banque",
      genTitle: "Générer le dépôt bancaire",
      genDeposit: "Générer dépôt",
      description:
        "entrez le montant et sélectionnez le compte bancaire pour obtenir une référence",
      account: "Compte",
      reference: "Référence",
      difference: "Différence",
      amount: "Montant",
      amountPaid: "Somme payée",
      amountRaised: "Montant amassé",
      dateRec: "Date enregistrée",
      depositSuccess: "Dépôt généré avec succès",
    },

    // Branch Expenses:
    bExpenses: {
      title: "Frais de gare",
      recordExpenses: "Enregistrer les dépenses",
      expenseCategory: "Catégorie de dépenses",
      selectCategory: "Choisir une catégorie",
      paymentMode: "Mode de paiement",
      amount: "Montant",
      recipient: "Destinataire",
      description: "Description",
      recordExpense: "Enregistrer les dépenses",
      dateTime: "Date / heure",
      descriptionMissing: "Veuillez saisir une description",
      amountMissing: "Veuillez saisir un montant",
      expenseCategoryError: "Sélectionnez une catégorie de dépenses",
      successfullyRecorded: "Dépenses enregistrées avec succès",
      successfullyDeleted: "Dépenses supprimées avec succès",
      unsuccessfulRecord: "Impossible d'ajouter des dépenses",
      accountNumberMissing:
        "Vous n'avez actuellement pas de compte bancaire, veuillez d'abord ajouter un compte pour enregistrer les dépenses",
      cash: "Espèces",
      cheque: "Vérifier",
      transfer: "Transfert",
      accountNumber: "Numéro de compte",
      selectAccount: "Sélectionner le compte",
      category: "Catégorie",
      account: "Compte",
      paymentMode: "Mode de paiement",
    },

    // Branch Users
    bUsers: {
      title: "Afficher les utilisateurs",
      description: "Afficher les utilisateurs de la succursale",
      users: "Utilisateurs",
    },

    // Branch Wallet
    bWallet: {
      walletBalance: "Équilibre du portefeuille",
      title: "Portefeuille de gare",
      date: "Date",
      voucherPin: "Goupille de bon",
      amountSpent: "Montant dépensé",
      totalAmountSpent: "Montant total dépensé",
      product: "Produit",
      salesType: "Type de vente",
      identifier: "Identifiant de transaction",
      salesType: "Type de vente",
      bookBalance: "Équilibre du livre",
    },

    // Branch Assets Folder
    bAssets: {
      title: "Actif total",
      bAssets: "Actifs de succursale",
      pAssets: "Actifs parents",
      here: " ici",
      create: "Créer un actif",
      selectStatus: "Sélectionnez un statut",
      allStatus: "Tout statut",
      okay: "D'accord",
      serviceDue: "Service rendu",
      renewalDue: "Renouvellement dû",
      notActive: "Pas actif",
      renewed: "Renouvelé",
      selectGroup: "Sélectionnez un groupe",
      allGroups: "Tous les groupes",
      licenseNo: "N ° de licence.",
      assetGroup: "Groupe d'actifs",
      description: "Vous pouvez créer et gérer vos actifs de succursale",
      noAssets: "Vous n'avez actuellement aucun actif",
      addAssets: "Ajouter un nouvel actif",
      enterAssets: "Entrez l'actif #",
    },

    // Branch Settlement
    bSettlement: {
      title: "Total des colonies",
      history: "Historique des colonies",
      transactionBtw:
        "Transactions de portefeuille de sortie de vente au détail entre",
      amount: "Montant de la transaction",
      source: "Source",
      transactionId: "identifiant de transaction",
      sessionId: "ID de session",
      settlement: "Règlement",
      settlementRequest: "Demande de règlement",
      settlementRequestDesc: "Voir et gérer les demandes de règlement ici",
      makeSetRequest: "Faire une demande de règlement",
      settleWalletAmt: "Régler le montant du portefeuille",
      settleCustomAmt: "Régler le montant personnalisé",
      inputGreater: "Le montant saisi est supérieur au solde du portefeuille",
      selectAccType: "Sélectionnez le type de compte",
      approved: "Approuvé",
      unapproved: "Désapprouvé",
      comAct: "Compte d'entreprise",
      braAct: "Compte de succursale",
    },

    // Branch Sufficiency
    bSufficiency: {
      title: "Métriques suffisantes",
      tprojectionR: "Taux de projection de réservoir",
      selectIorD: "Sélectionnez l'augmentation ou la diminution",
      increase: "Augmenter",
      decrease: "Diminuer",
      inputPercent: "Pourcentage d'entrée",
      nextTwoDaysVol: "2 jours suivants vol. projection",
      nextTwoDaysSales: "Projection des ventes sur les 2 prochains jours",
      noTanksAdded: "Aucun réservoir ajouté",
    },

    bCashFlow: {
      title: "Des flux de trésorerie",
      titleBtw: "Flux de trésorerie entre",
      totalSales: "Ventes totales",
      posSales: "Ventes POS",
      retainerSales: "Ventes d'honoraires",
      epumpSales: "Ventes de pompes",
      bankedCash: "Espèces en banque",
      expense: "Frais",
      previousBalance: "Solde précédent",
      outstandingCash: "Trésorerie exceptionnelle",
      cashInsuranceRatio: "Limite d'assurance en espèces",
      compliance: "Conformité(%)",
    },

    // Branch Dry Stock
    bSales: {
      // Create Sales
      sale: "vente",
      products: "Des produits",
      unitPrice: "Prix ​​unitaire",
      quantitySold: "Quantity sold",
      addSale: "Ajouter une vente",
      totQty: "Quantité totale:",
      totPrice: "Prix ​​total:",
      applyDiscount: "Appliquer la remise",
      enterDiscountAmt: "Entrez le montant de la remise",
      enterCustomerName: "Entrez le nom du client",
      addSalesWarning: "Vous n'avez actuellement aucune vente ajoutée",
      suppWillAdd:
        "Les fournitures seront ajoutées ici lorsqu'elles seront ajoutées",
      reqUnitPrice: "Le prix unitaire est requis",
      reqUnitQty: "La quantité fournie est requise",
      reqUnitProd: "le produit est requis",
      salesAdded: "Vente ajoutée avec succès",
      reqQtySold: "La quantité vendue est requise",
      reqSupplyTo: "Veuillez sélectionner une fourniture pour",
      salesUpdated: "Vente mise à jour avec succès",
      //Sales
      dsSales: "Ventes de stocks secs",
      manageDS: "Gérez vos ventes de stock sec ici...",
      recordSale: "Vente record",
      recordSupply: "Approvisionnement record",
      totSales: "Ventes totales",
      totSoldPrice: "Prix de vente total",
      totQtySold: "Quantité totale vendue",
      dateSold: "Date de vente",
      quantitySold: "Quantité vendue",
      totalSoldPrice: "Prix ​​total",
      discountPrice: "Prix ​​bas",
      customer: "Client",
      //Sales Details
      productSales: "Ventes de produits",
      nonWetProductName: "Nom du produit",
      productCategoryName: "Catégorie de produit",
      // Product Sales
      managePS: "Gérez vos ventes de produits ici...",
      openingRead: "Lecture d'ouverture",
      closingRead: "Lecture de clôture",
      vol: "Volume",
      amt: "Montant",
      priceSold: "Prix vendu",
      nozzle: "Buse",
      transactionType: "Type de transaction",
      operatingHours: "Heures d'ouverture",
    },

    //Branch Supply
    bSupply: {
      title: "Gérer les approvisionnements en stock sec",
      station: "Gare",
      description: "Gérez vos approvisionnements en stock sec ici...",
      totSupply: "Fournitures totales",
      totProSup: "Total des produits fournis",
      totQtySup: "Quantité totale fournie",
      companyName: "Nom de l'entreprise",
      totalCostProductsSupplied: "Coût total",
      totalProductQuantitySupplied: "Quantité totale de produits fournis",
      totalProductsSupplied: "Produits fournis",
      //Supply Details
      title2: "Détails de l'approvisionnement en stock sec",
      description2:
        "Consultez les détails de votre approvisionnement en stock sec ici...",
      product: "Produit",
      productCategoryName: "Nom de catégorie",
      qtySupplied: "Quantité fournie",
      isSupplyAccepted: "Fourniture acceptée",
      isSupplyCompleted: "Fourniture terminée",
    },

    //Branch Settingg
    bSettings: {
      title: "Paramètres de la succursale",
      useCompanySet: "Utiliser les paramètres de l'entreprise",
      showDS: "Afficher Stock sec",
      showMM: "Afficher l'argent mobile",
      selectMRfromMR:
        "Sélectionnez les relevés de compteur pour l'enregistrement manuel",
      selectMRfromCalc: "Sélectionnez la lecture manuelle pour le calcul",
      updateSettings: "Mettre à jour les paramètres",
      updateSuccess: "Paramètres de branche mis à jour avec succès",
      multiMR: "Plusieurs enregistrements manuels",
    },

    // Branch Invoice
    bInvoices: {
      title: "Factures",
      overdue: "En retard",
      last: "Dernier",
      due30: "Dû dans les 30 prochains jours",
      allStatus: "Tous les statuts",
      paid: "Payé",
      partPaid: "Partiellement payé",
      allInvoices: "Toutes les factures",
      status: "Statut",
      dateTemp: "Exigible",
      amountDue: "Montant dû",
      invoicePayments: "Paiements de facture",
      billTo: "facturer",
      invoiceNo: "Numéro de facture:",
      invoiceDate: "Date de facturation",
      paymentDue: "Paiement dû :",
      amountDue: "Montant dû:",
      items: "Articles",
      qty: "Quantité",
      price: "Prix",
      amt: "Montante",
      noAddedItems: "Vous n'avez ajouté aucun élément.",
      subTot: "Sous-total :",
      total: "Totale:",
      amtPaid: "Le montant payé:",
      noInvoiceSelected:
        "Aucune facture sélectionnée. Veuillez sélectionner une facture à afficher",
      totAmtPaid: "Montant total payé",
      payments: "Paiements",
      paymentMtd: "Mode de paiement",
      note: "Note",
    },

    // Branch Lease Folder
    bLease: {
      title: "Gérer les baux",
      lDescription: "Gérez vos baux ici...",
      createLease: "Créer un bail",
      paymentDate: "Date de paiement",
      isRequest: "est requis",
      successfullyCreatedLease:
        "Enregistrement de paiement de location créé avec succès",
      successfullyUpdatedLease:
        "Enregistrement de paiement de location mis à jour avec succès",
      manageBspace: "Gérer l'espace de la succursale",
      BSdescription: "Gérez votre espace de succursale ici...",
      createBS: "Créer un espace succursale",
      totCount: "Le compte total",
      branchSpace: "Espace succursale",
      rooms: "Pièces",
      durations: "Durée(s) de location",
      isAvailable: "disponible",
      propertyName: "Nom de la propriété",
      rentFee: "Frais de location",
      noRooms: "Nombre de chambres",
      noRestRoom: "Nombre de salles de repos",
      restRoom: "TOILETTES",
      rentDuration: "Durée du loyer",
      propDesc: "Description de la propriété",
      addSet: "Détails supplémentaires",
      propNameReq: "Le nom de la propriété est requis",
      noRoomReq: "le nombre de chambres est requis",
      noRestroomReq: "le nombre de salles de repos est requis",
      propDescReq: "La description de la propriété est obligatoire",
      addDetReq: "Des détails supplémentaires sont requis",
      allMissingData: "Remplissez tous les champs manquants",
      successfullyCreatedBS: "Espace de succursale créé avec succès",
      successfullyCreatedBL: "Le bail de succursale a été créé avec succès",
      successfullyCreatedBO: "Occupant de succursale créé avec succès",
      successfullyUpdatedBS: "Espace de succursale mis à jour avec succès",
      successfullyUpdatedBL: "Bail de succursale mis à jour avec succès",
      successfullyUpdatedBO: "Occupant de succursale mis à jour avec succès",
      newUser: "Nouvel utilisateur",
      existingUser: "Utilisateur existant",
      leaseInfo: "Informations sur le bail",
      rentPaid: "Loyer payé",
      rentDate: "Date de location",
      exDate: "Date d'expiration",
      availableBs: "Espace de succursale disponible",
      selectBS: "sélectionner l'espace de la succursale",
      selectRentDur: "Sélectionnez la durée du loyer",
      rentDurLength: "Durée de la location",
      availableOccupants: "Occupants disponibles",
      seleceOcc: "sélectionner l'occupant",
      leasedBy: "Loué par",
      userDetails: "Détails de l'utilisateur",
      rentPaidRequired: "Le loyer payé est obligatoire",
      rentDurationRequired: "La durée de location est requise",
      rentDurLenRequired: "La durée de location est requise",
      leasedByRequired: "Loué par est requis",
      btw1013: "doit contenir entre 10 et 13 caractères",
      inputAvalid: "Veuillez entrer un valide",
      allRentLease: "Tous les baux/loyers",
      rentDate: "Date de location",
      occ: "Occupant",
      occupantName: "Nom de l'occupant",
      occupantEmail: "Courriel de l'occupant",
      manageOcc: "Gérer les occupants",
      occDescription: "Gérez les occupants de votre succursale ici...",
      createBranchOcc: "Créer un occupant de succursale",
      managePaymentRec: "Gérer les dossiers de paiement",
      mprDescription:
        "Gérez les enregistrements de paiement pour votre bail ici...",
      addPR: "Ajouter un enregistrement de paiement",
      outstandingAmt: "Encours",
    },

    // Branch Manual Records
    bManualRec: {
      title: "Enregistrement manuel",
      description: "Gérez vos approvisionnements en stock sec ici...",
      setZeroSales: "Définir des ventes nulles",
      outerMeter: "Mètre extérieur",
      selectReportDate: "Sélectionnez la date du rapport",
      openingRead: "Lecture d'ouverture",
      closingRead: "Lecture finale",
      totOuterSales: "Total des ventes externes",
      innerMeter: "Mètre intérieur",
      totInnerSales: "Total des ventes internes",
      rtt: "Retour au réservoir",
      trf: "Transfert",
      openingDip: "Creux d'ouverture (litres)",
      closingDip: "Creux de fermeture (litres)",
      closingDipT: "Temps de creux de clôture",
      volDisc: "Volume déchargé (litres)",
      totEx: "Dépense totale",
      mmSales: "Ventes d'argent mobile",
      pumpReading: "Lectures de la pompe",
      tankReading: "Lectures de réservoir",
      innerOpeningReading: "Lecture d'ouverture intérieure",
      outerOpeningReading: "Lecture d'ouverture extérieure",
      innerClosingReading: "Lecture intérieure de clôture",
      outerClosingReading: "Lecture de clôture extérieure",
      innerTotSales: "Ventes totales intérieures",
      outerTotSales: "Ventes totales externes",
      otherSummary: "Autre résumé",
      totRetSales: "Ventes totales de mandats",
      totPOSsales: "Total des ventes au point de vente",
      totMMsales: "Ventes totales d'argent mobile",
      previous: "Précédent",
      rttError: "Le RTT ne peut pas être supérieur aux ventes",
      openGreaterClose:
        "L'ouverture ne peut pas être supérieure à la fermeture",
      dipPlusDischargeError:
        "Valeurs incorrectes : le creux de fermeture ne peut pas être supérieur au creux d'ouverture + décharge",
      summarySuccess: "Résumé envoyé avec succès",
      rejectedEOD: "Dossiers EOD rejetés",
      recordType: "Type d'enregistrement",
      updatedReject: "Mettre à jour l'enregistrement rejeté pour",
      oirm: "Lecture d'ouverture (compteur intérieur)",
      orom: "Lecture d'ouverture (compteur extérieur)",
      cirm: "Lecture de clôture (compteur intérieur)",
      crom: "Lecture de clôture (compteur extérieur)",
      updateRecord: "Mettre à jour l'enregistrement",
      recordUpdated: "Enregistrement mis à jour avec succès",
    },

    // End of day report
    endOfDayReport: {
      title: "Rapport de fin de journée",
      hours: "heures",
      usageTime: "temps d'utilisation",
      totalVolumeSold: "Volume total vendu",
      totalRtt: "RTT total",
      totalSales: "Ventes totales",
      totalCashSale: "Total de la vente au comptant",
      epumpSales: "E-Sel",
      retainershipSales: "Vente de mandat",
      accountSummary: "Relevé de compte",
      cashSales: "Les ventes au comptant",
      cashAtHand: "Trésorerie à portée de main",
      cashToBank: "Espèces à la banque",
      pos: "POS",
      returnToTank: "Retour au réservoir",
      expense: "Frais",
      salesSummary: "Résumé des ventes",
      pumpSales: "Ventes de pompes",
      tankSales: "Ventes de réservoirs",
      operatingHours: "Heures d'ouverture",
      surplus: "Surplus",
      totOfflineSales: "Total des ventes hors ligne",
      esalesSummary: "Résumé des ventes en ligne",
      retainershipSales: "Ventes de mandat",
      swipeCardSales: "Ventes par carte magnétique",
      ussdSales: "Ventes USSD",
      voucherSales: "Ventes de bons",
    },

    // People Management
    // Edit Staff, Add Staff and View Staff
    editStaff: {
      title: "Personnel d'édition",
      personalInformation: "Informations personnelles",
      firstName: "Prénom",
      lastName: "Nom de famille",
      cardName: "Nom de la carte",
      dateOfBirth: "Date de naissance",
      gender: "Genre",
      male: "Mâle",
      female: "Femme",
      email: "E-mail",
      contactInformation: "Coordonnées",
      streetAddress: "Adresse de la rue",
      city: "Ville",
      state: "État",
      country: "Pays",
      phone: "Pas de téléphone.",
      updateStaff: "Mise à jour du personnel",
      cardNameMissing: "Veuillez saisir un nom de carte",
      dateOfBirthMissing: "Veuillez sélectionner une date de naissance",
      genderMissing: "Veuillez sélectionner un sexe",
      countryMissing: "Veuillez saisir un pays",
      successfullyUpdated: "Successfully updated staff",
      unsuccessfulUpdate: "Échec de la mise à jour des dossiers du personnel",
    },

    // Add Staff
    addStaff: {
      title: "Ajouter un nouveau personnel",
      successfullyAdded: "Personnel ajouté avec succès",
      unsuccessfulAdd: "Échec de l'ajout du personnel",
    },

    viewStaff: {
      title: "Détails du personnel",
    },

    // Staff
    staff: {
      title: "Gérer le personnel",
      description: "Vous pouvez voir et gérer tous vos états-majors ici...",
      noOfStaffs: "Nombre d'employés",
      addNew: "Ajouter nouveau",
      fuelCard: "Carte Carburant",
      gender: "Genre",
      view: "Voir",
      edit: "Modifier",
      delete: "Supprimer",
      noStaff: "Aucune équipe n'a encore été créée",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer ce personnel ?",
      successfullyDeleted: "Personnel supprimé avec succès",
      unsuccessfulDelete: "Échec de la suppression du personnel",
      totalStaffs: "Effectifs totaux",
      staffName: "Nom du personnel",
      avgRV: "Valeur moyenne du taux",
      totSale: "Vente totale",
      totPriceSold: "Prix total vendu",
      mapCard: "MapCard",
      unMapCard: "UnMapCard",
      cardId: "Card ID",
      map: "Map",
      toCard: "to Card",
      inputCardId: "Input Card ID",
      inputPin: "Input pin",
    },

    //Staff Ratings
    staffRatings: {
      title: "Répartition des notes du personnel",
      description: "vous pouvez voir les évaluations de votre personnel ici...",
      allRec: "Tous les enregistrements",
      selectStaff: "sélectionner le personnel",
      rateValue: "Valeur du taux",
    },
    // Shift
    shift: {
      totalShifts: "Nombre total de quarts de travail",
      shiftDetails: "Détails du quart de travail",
      addShift: "Ajouter un quart de travail",
      shiftName: "Nom de l'équipe | NOM DE MAJ",
      addShift: "Ajouter un quart de travail",
      startTime: "Heure de début",
      endTime: "Heure de fin",
      status: "Statut",
      enterShift: "Entrer Maj",
      shiftMissing: "Veuillez saisir un décalage",
      successfullyCreated: "Shift créé avec succès",
      unsuccessfullyCreated: "Impossible d'ajouter Shift",
      assignments: "Missions",
      deposits: "Dépôts",
      manageShift: "Gérer les quarts de travail",
      decription: "Vous pouvez voir et gérer tous vos quarts de travail ici...",
      totalStaffs: "Effectifs totaux",
    },

    // Shift Assignments
    shiftAssignments: {
      totalShiftAss: "Total des affectations de quart",
      shiftAss: "Affectations d'équipe",
      pumpName: "Nom de la pompe",
      staffName: "Nom du personnel",
      openingReading: "Lecture d'ouverture | LECTURE D'OUVERTURE",
      closingReading: "Lecture de clôture",
      startNew: "Commencer un nouveau quart de travail",
      pump: "POMPE",
      selectPump: "Sélectionnez la pompe",
      staff: "PERSONNEL",
      chooseStaff: "Choisissez le personnel",
      assignShift: "Attribuer un quart de travail",
      openingReadingMissing: "Veuillez entrer une lecture d'ouverture",
      staffMissing: "Veuillez choisir un personnel",
      pumpMissing: "Veuillez sélectionner une pompe",
      successfullyAssigned: "Shift attribué avec succès",
      unsuccessfullyAssigned: "Shift attribué avec succès",
      manageShiftAss: "Gérer les affectations de poste",
      description:
        "Vous pouvez voir et gérer toutes vos affectations de quart ici...",
      totalStaffs: "Effectifs totaux",
    },

    // Shift Deposits
    shiftDeposits: {
      totalShiftDeposit: "Total des dépôts de quart",
      shiftDeposits: "Dépôt de quart | Dépôts de décalage",
      bank: "Banque",
      amount: "Montante",
      balance: "Équilibre",
      tellerNumber: "Numéro du caissier",
      selectBank: "Sélectionnez la banque",
      submit: "Soumettre",
      selectPump: "Sélectionnez la pompe",
      chooseStaff: "Choisissez le personnel",
      bankMissing: "Veuillez sélectionner une banque",
      amountMissing: "Veuillez entrer un montant",
      tellerMissing: "Veuillez entrer un numéro de caissier valide",
      successfullyCreated: "Dépôt de quart créé avec succès",
      unsuccessfullyCreated: "Échec de la création du dépôt de quart",
      amountZeroError: "Veuillez saisir un montant supérieur à 0",
      bankAccountError:
        "Vous n'avez actuellement pas d'enregistrement de compte bancaire, veuillez créer un compte pour activer les dépôts de quart",
    },

    //Branch POS
    bPos: {
      selectStatus: "Sélectionnez le statut",
      showAll: "Afficher tout",
      approved: "Approuvé",
      declined: "Diminué",
      totTransact: "Transactions totales",
      successfulTransactions: "Transactions réussies",
      failedTransactions: "Transactions échouées",
      totChargeback: "Total des frais de remise en argent",
      posTransactBtw: "Transactions au point de vente entre",
      transactionDate: "Date de la transaction",
      stan: "Stan",
      pump: "Pompe",
      amount: "Montant",
      rrn: "RRN",
      maskedPan: "Casserole masquée",
      youCan:
        "Vous pouvez attribuer et réattribuer un point de vente à une succursale sélectionnée ici",
    },

    //Branch POS Terminal
    bTerminal: {
      title: "Terminal de point de vente",
      description:
        "Vous pouvez visualiser et gérer les terminaux créés pour cette branche ici",
      createTerminal: "créer une borne",
      allTerminals: "Toutes les bornes",
      terminalId: "Identifiant du terminal",
      serialNo: "Numéro de série.",
      station: "Gare",
    },

    // Product Summary
    productSummary: {
      totalTransactions: "Transactions totales",
      title: "Informations sur le produit",
      total: "TOTALE",
      transBtw: "Résumé des produits entre",
      date: "Date",
      productVolume: "Volume (litres)",
      productAmount: "Monnaie de {currency}",
      total: "Total",
      totalAmount: "Montant total",
    },

    // Product Valuation
    bproductValuation: {
      title: "Valorisation des stocks",
      noValuationRec: "Aucune valorisation des stocks enregistrée",
      currentVolume: "Volume actuel",
      valuation: "évaluation",
    },

    // Branch Profile
    bProfile: {
      accountSettings: "Paramètres du compte",
      email: "E-mail",
      firstName: "Prénom",
      lastName: "Nom de famille",
      phoneNumber: "Numéro de téléphone",
      editProfile: "Editer le profil",
      changeYourPassword: "Changez votre mot de passe",
      oldPassword: "ancien mot de passe",
      newPassword: "nouveau mot de passe",
      confirmPassword: "Confirmez le mot de passe",
      passwordMustContain: "Le mot de passe doit contenir",
      oneNumeric: "Un caractère numérique",
      specialCharacter: "Un caractère spécial",
      changePassword: "Changer le mot de passe",
      successfullyChanged: "Mot de passe changé avec succès !",
      fillIn: "Remplissez les champs manquants",
      updated: "Mise à jour du profil réussie",
      passwordBlank: "Le champ du mot de passe ne peut pas être vide",
      passwordsDontMatch: "Les mots de passe ne correspondent pas",
    },

    //Branch Services
    bServices: {
      title: "Gérer les services",
      description: "Gérez vos services pour",
      descriptionT: "Afficher les détails de votre transaction pour",
      manageTfor: "Gérez vos transactions pour",
      service: "Service",
      selectService: "sélectionner le service",
      transaction: "transaction",
      transactionDet: "Détails de la transaction",
      manageTransaction: "Gérer les transactions",
      unitprice: "Prix ​​unitaire",
      serviceDescription: "Description du service",
      addTransaction: "Ajouter une opération",
      removeItem: "Retirer l'objet",
      totalPrice: "Prix ​​total",
      enterCustomerName: "Entrez le nom du client",
      customerName: "Nom du client",
      submitTransaction: "Soumettre la transaction",
      noTransactAdded: "Vous n'avez actuellement aucune transaction ajoutée",
      transactWillAdd:
        "les transactions seront ajoutées ici lorsqu'elles seront ajoutées",
      unitPriceReq: "Le prix unitaire est requis",
      kindlySelectService: "Veuillez sélectionner un service",
      serviceDescReq: "la description du service est requise",
      customerNameReq: "Le nom du client est requis",
      nonwetProSupplyCreated:
        "L'approvisionnement en produits non humides a été créé avec succès",
      plsSelectBranch: "Veuillez sélectionner une succursale",
      here: "ici",
      totalServices: "Services totaux",
      totalTransact: "Transactions totales",
      serviceName: "Nom du service",
      transactionHistory: "Historique des transactions",
      recordDate: "Date d'enregistrement",
      serviceName: "Nom du service",
      price: "Prix",
      descTion: "Description",
      comService: "Services aux entreprises",
      addTransactions: "Ajouter une opération",
      totSoldPrice: "Prix de vente total",
      customer: "Customer",
    },

    // Pumps
    pumps: {
      showAll: "Afficher tout",
      installedPumps: "Pompes installées",
      lastReading: "Dernière lecture",
      manufacturer: "Fabricant",
      sourceTank: "Réservoir source",
      details: "Détails",
      noPumpsAdded: "Aucune pompe ajoutée",
      transactions: "Transactions",
    },

    // Pump Summary
    pumpSummary: {
      title: "Résumé de la pompe",
      description: "Gérez le récapitulatif de votre pompe ici...",
      totRec: "Nombre total d'enregistrements",
      pump: "Pompe",
      amt: "Montante",
      vol: "Volume",
    },

    // Pump Transactions
    pumpTransactions: {
      totalTransactions: "Transactions totales",
      title: "Transactions à la pompe",
      totalVolume: "Volume distribué",
      totalNumber: "Nombre de transactions",
      totalAmount: "Montant vendu",
      avgLitres: "No. de litres par transaction",
      branchSales: "Commerce de détail Transactions à la pompe entre",
      dateTime: "Date/Heure",
      pumpName: "Nom de la pompe",
      productName: "Nom du produit",
      pricePerLitre: "Prix / Litre",
      openingReading: "Lecture d'ouverture",
      closingReading: "Lecture de clôture",
      priceSoldCash: "Prix Vendu au comptant",
      volumeDispensed: "Volume distribué",
      dispensedBy: "Dispensé par",
      salesType: "Type de vente",
    },

    // Pump Details
    pumpDetails: {
      details: "Détails",
      pumpDisplayName: "Nom d'affichage de la pompe",
      associateTank: "Réservoir associé",
      pumpCalibration: "Étalonnage de la pompe xtr-20ltr",
      manufacturer: "Fabricant de pompes",
      pumpModel: "Modèle de pompe",
      pumpStatus: "État de la pompe",
      title: "Détails de la pompe",
      pumpName: "Nom de la pompe",
      associatePumpToTank: "Associer la pompe au réservoir",
      pumpReading: "Lecture de la pompe",
      throughput:
        "Débit moyen de la pompe / Débit moyen du produit pendant 7 jours",
      throughputPlaceholder: "Débit de la pompe",
    },

    // Pumps Fault
    pumpsFault: {
      total: "Défauts totaux de la pompe",
      totalFaults: "Nombre total de défauts",
      showAll: "Afficher tout",
      pending: "En attente",
      fixing: "Fixation",
      fixed: "Fixé",
      notFixed: "Non fixé",
      pumpStatus: "État de la pompe",
      title: "Défauts de la pompe",
      recordFault: "Défaut d'enregistrement",

      describeFault: "Décrire le défaut",
      fault: "Défaut",
      addFault: "Ajouter un défaut",
      faults: "Défauts",
      pump: "Pompe",
      type: "Taper",
      date: "Date",
      station: "Gare",
      name: "Nom",
      recordedBy: "Enregistré par",
      selectPump: "Sélectionnez la pompe",
      status: "Statut",
      selectPumpStatus: "Sélectionnez le statut",
      urgencyLevel: "Niveau d'urgence",
      date: "Date",
      editFault: "Modifier le défaut",
      updateFault: "Mise à jour",
      addNewFault: "Créer",
      pumpName: "Nom de la pompe",
      faultMissing: "Veuillez saisir un défaut",
      faultCreated: "Erreur créée avec succès",
      faultUpdated: "Défaut mis à jour avec succès",
      faultUnupdated: "Échec de la mise à jour de l'erreur",
      statusMissing: "Veuillez sélectionner un statut",
      pumpMissing: "Veuillez sélectionner une pompe",
      typeMissing: "Veuillez sélectionner un type",
      tankMissing: "Veuillez sélectionner un réservoir",
      issuesMissing: "Veuillez indiquer vos problèmes",
      urgencySelMissing: "Sélectionnez un niveau d'urgence",
      urgencyMissing: "Veuillez saisir un niveau d'urgence",
      confirmDelete: "Voulez-vous vraiment supprimer ce défaut de pompe ?",
      confirmDeleteFault:
        "Voulez-vous vraiment supprimer cet enregistrement de défaut ?",
      successfullyDeleted: "Erreur de pompe supprimée avec succès",
      unsuccessfulDelete: "Impossible de supprimer le défaut de la pompe",
      successfullyAdded: "Défaut de pompe ajouté avec succès",
      unsuccessfulAdd: "Échec de l'ajout d'un défaut de pompe",
      successfullyEdited: "Erreur de pompe modifiée avec succès",
      unsuccessfulEdit: "Impossible de modifier le défaut de la pompe",
      faultsAndMaint: "Défauts et entretien",
      selectType: "Sélectionner le genre",
      tank: "Réservoir",
      others: "Autres",
      optionsSelected: "options sélectionnées",
      otherFaults: "Autres défauts",
      low: "Faible",
      medium: "Moyen",
      high: "Haut",
      recBy: "Enregistré par",
      aggregatedFault: "Défauts agrégés",
      viewFault: "Affichez ici les défauts agrégés de votre concessionnaire...",
      totalFaults: "Défauts totaux",
      maintenanceList: "Liste d'entretien",
      viewMaintenanceList:
        "Consultez la liste d'entretien de votre concessionnaire ici...",
      totalMaintenance: "Entretien total",
      viewAggregatedFault: "Affichez vos défauts de groupe agrégés ici...",
      viewAggregatedRegionFault:
        "Affichez vos défauts de groupe agrégés ici...",
      totalFaults: "Défauts totaux",
    },

    // Pumps Maintenance
    pumpsMaintenance: {
      total: "Entretien total de la pompe",
      showAll: "Afficher tout",
      pending: "En attente",
      fixing: "Fixation",
      fixed: "Fixée",
      notFixed: "Non fixé",
      resolved: "Résolu",
      maintenence: "Entretien",
      totalMaintenence: "Entretien total",
      pumpStatus: "État de la pompe",
      title: "Entretien de la pompe",
      recordMaintenance: "Entretien des dossiers",
      fault: "Défaut",
      pickSome: "Choisissez quelques",
      selectFault: "Sélectionnez le défaut",
      servicingCompany: "Société de service",
      technicianName: "Nom du technicien",
      remarks: "Remarque",
      findings: "Résultats",
      keyReturned: "Clé retournée",
      trueOrFalse: "Sélectionnez vrai ou faux",
      true: "Vrai",
      false: "FAUX",
      pumpFunctional: "Pompe fonctionnelle",
      date: "Date",
      update: "Mise à jour",
      create: "Créer",
      editMaintenance: "Modifier l'entretien",
      pumpName: "Nom de la pompe",
      technician: "Technicien",
      status: "Statut",
      faultMissing: "Veuillez sélectionner un défaut de pompe",
      servicingMissing: "Veuillez entrer la société de service",
      technicianMissing: "Veuillez entrer le nom du technicien",
      remarkMissing: "Veuillez saisir une remarque",
      findingMissing: "Veuillez saisir les résultats concernant la pompe",
      keyReturnedMissing:
        "Veuillez sélectionner vrai ou faux pour la clé renvoyée",
      pumpFunctionalMissing:
        "Veuillez sélectionner vrai ou faux pour que la pompe fonctionne",
      confirmDelete:
        "Voulez-vous vraiment supprimer cette maintenance de la pompe ?",
      successfullyDeleted: "Maintenance de la pompe supprimée avec succès",
      unsuccessfulDelete: "Impossible de supprimer la maintenance de la pompe",
      successfullyAdded: "Maintenance de la pompe ajoutée avec succès",
      unsuccessfulAdd: "Échec de l'ajout de la maintenance de la pompe",
      successfullyEdited: "Maintenance de la pompe mise à jour avec succès",
      unsuccessfulEdit:
        "Échec de la modification de la maintenance de la pompe",
    },

    // Branch Rating
    bRating: {
      title: "Évaluation des transactions en succursale",
      title1: "Évaluations des succursales",
      description:
        "vous pouvez voir les évaluations de votre succursale ici...",
      addRating: "Ajouter une note",
      rateValueWarning: "veuillez sélectionner la valeur du tarif",
      branchIdWarning: "L'identifiant de la succursale est requis",
      userIdWarning: "L'ID utilisateur est requis",
      ratingAdded: "Note de transaction ajoutée avec succès !",
      totalSale: "Vente totale",
      totalPriceSold: "Prix total vendu",
      avgRateValue: "Valeur moyenne du taux",
      allRec: "Tous les enregistrements",
      staffName: "Nom du personnel",
    },

    // Sales Transactions
    salesTransactions: {
      totalTransactions: "Transactions totales",
      showAll: "Afficher tout",
      productFilter: "Filtre de produit",
      title: "Opérations de vente",
      total: "Total",
      transBtw: "Transactions de vente au détail entre",
      date: "Date",
      pumpName: "Nom de la pompe",
      product: "Produit",
      openingReading: "Lecture d'ouverture",
      closingReading: "Lecture de clôture",
      totalDispensed: "Total distribué",
      amount: "Montant",
      viewTransactions: "Afficher les opérations",
    },

    // Settlement Account
    settlementAccount: {
      addNewAccount: "Ajouter un nouveau compte bancaire",
      bankName: "Nom de banque",
      selectBankName: "Sélectionnez une banque",
      accountName: "Nom du compte | NOM DU COMPTE",
      accountNumber: "Nom du compte | NOM DU COMPTE",
      payTime: "TEMPS DE PAIEMENT",
      endOfTheDay: "À la fin de la journée",
      endOfDayValue: "Fin de la journée",
      minimumValue: "Définir une valeur minimale",
      setAValue: "Définir une valeur",
      createBankDetails: "Créer des coordonnées bancaires",
      updateBankDetails: "Mettre à jour les coordonnées bancaires",
      bankMissing: "Veuillez sélectionner une banque",
      payTimeMissing: "Veuillez choisir un temps de paiement",
      minValueMissing: "Veuillez définir une valeur minimale",
      successfullyAdded: "Coordonnées bancaires ajoutées avec succès",
      unsuccessfulAdd: "Échec de l'ajout du compte de règlement",
      successfullyUpdated: "Détails du compte mis à jour avec succès",
      unsuccessfulUpdate: "Échec de la mise à jour des détails du compte",
    },

    // Branch Station Management
    stationManagement: {
      product: "PRODUIT",
      price: "PRIX",
      selectProduct: "Sélectionner un produit",
      enterNewPrice: "Entrez le nouveau prix",
      updatePrice: "Mettre à jour le prix",
      currentPrice: "Prix ​​actuel",
      currentlySellingAt: "Actuellement en vente à",
      priceMissing: "Veuillez entrer un nouveau prix",
      invalidPrice: "Veuillez entrer un montant valide",
      successfullyChanged: "Prix modifié avec succès",
    },

    // Tank Report
    tankReport: {
      title: "Rapports de réservoir",
      reportBetween: "Rapport de réservoirs entre",
      tankName: "Nom du réservoir",
      saleVolume: "Volume des ventes",
      volumeRefilled: "Volume rempli",
      openingVolume: "Volume d'ouverture",
      closingVolume: "Volume de clôture",
      volumeSold: "Volume vendu",
      volumeFilled: "Volume rempli",
      totalVolume: "Volume total (Litres)",
    },

    // Tanks
    tanks: {
      title: "réservoirs",
      productVolume: "Volume de produit",
      tankCapacity: "Capacité du réservoir",
      waterLevel: "Niveau d'eau",
      details: "Détails",
      probeTransactions: "Sonder les transactions",
      noTanksAdded: "Aucun réservoir ajouté",
      stock: "Stock de réservoir",
      consoleStatus: "ÉTAT DE LA CONSOLE",
    },

    // Tank Dippings
    tankDippings: {
      title: "Tank Dippings",
      tankName: "Nom du réservoir",
      probeVol: "Volume de la sonde (litres)",
      actVol: "Volume réel (litres)",
      difference: "Différence (litres)",
      productName: "Nom du produit",
    },

    // Tank Details
    tankDetails: {
      title: "Détails du réservoir",
      ago: "ago",
      productVolume: "Volume de produit",
      waterVolume: "Volume d'eau",
      tankCapacity: "Capacité du réservoir",
      waterLevel: "Niveau d'eau",
      probeTransactions: "Sonder les transactions",
      associatedPumps: "Pompes associées",
      currentReading: "Lecture actuelle",
      transactions: "Transactions",
      graphTitle:
        "Graphique de stock de réservoir pour les sept (7) derniers jours",
      volumeLitres: "Volume (Litres)",
    },

    // Probe Transactions
    probeTransactions: {
      title: "Sonder les transactions",
      transBetween: "Sonder les transactions entre",
      transDate: "Date de la transaction",
      productHeight: "Hauteur du produit",
      productVolume: "Volume de produit",
      temperature: "Température",
      waterHeight: "Hauteur de l'eau",
      waterVolume: "Volume d'eau",
    },

    // Product Filled
    bproductFilled: {
      title: "Produits remplis",
      titleOn: "Produits remplis sur",
      pmsVolume: "Volume PMS",
      agoVolume: "Volume AGO",
      dpkVolume: "Volume DPK",
      lpgVolume: "Volume de LPG",
    },

    // Product Received
    bProductReceived: {
      title: "Total des produits reçus",
      description: "Total des produits reçus entre",
      totalVolume: "Volume total",
      product: "Produit",
    },

    // Tanks Filled
    tanksFilled: {
      title: "Produit déchargé",
      tanksFilledOn: "Produits déchargés sur",
      tankName: "Nom du réservoir",
      eVolumeDischarged: "Volume de pompe déchargé (litres)",
      mVolumeDischarged: "Volume manuel déchargé (litres)",
      variance: "Variance",
      eStartVolume: "Volume de démarrage de la pompe (litres)",
      eVolumeEnd: "Volume final de la pompe (litres)",
      mStartVolume: "Volume de démarrage manuel (litres)",
      mEndVolume: "Volume final manuel (litres)",
      startTime: "Heure de début",
      endTime: "Heure de fin",
      noTanksFilledOn: "Aucun produit déchargé sur",
      efuelingTF: "Remplissage des réservoirs de carburant",
      manualTF: "Remplissage manuel des réservoirs",
      totalTF: "Remplissage total des réservoirs",
    },

    // Branch Variance Report
    bVarianceReport: {
      totalTransactions: "Transactions totales",
      showAll: "Afficher tout",
      productFilter: "Filtre de produit",
      title: "Rapport d'écart",
      eVolumeSold: "Lecture ATG",
      mVolumeSold: "Trempage manuel",
      variance: "Variance",
      total: "TOTALE",
      reportBetween: "Rapport d'écart entre",
      date: "Date",
      product: "Produit",
      pumpName: "Nom de la pompe",
      eVolumeSoldLtr: "Volume de pompe vendu (litres)",
      mVolumeSoldLtr: "Volume manuel vendu (litres)",
      atgReading: "Lecture ATG (litres)",
      manualDipping: "Trempage manuel (litres)",
      varianceLtr: "Écart (litres)",
      eOpeningReading: "Lecture d'ouverture de la pompe (ltr)",
      mOpeningReading: "Lecture d'ouverture manuelle (ltr)",
      eLastReading: "Dernière lecture de la pompe (ltr)",
      mLastReading: "Dernière lecture manuelle (ltr)",
      viewTransactions: "Afficher les opérations",
      tankVariance: "Écart de réservoir",
    },

    // Customer account
    // Customer Master Layout
    cusMasterLayout: {
      customer: "CLIENTE",
      dashboard: "Tableau de bord",
      balance: "Équilibre",
      voucher: "Bon",
      vouchers: "Pièces justificatives",
      vehicles: "Véhicules",
      allVehicles: "Tous les véhicules",
      drivers: "Conducteurs",
      fuelConsumption: "Consommation de carburant",
      fuelBalance: "Bilan de carburant",
      consumption: "Consommation",
      retainership: "Mandat",
      generatedVoucher: "Bon généré",
      outstandingPayments: "Paiements impayés",
      payments: "Paiements",
      subscriptionExpire: "VOTRE ABONNEMENT EXPIRERA dans",
      subAccounts: "Sous-comptes",
      pleasePay: ",VEUILLEZ EFFECTUER LE PAIEMENT",
      profile: "Profil",
      reports: "Rapports",
      extendedReport: "Rapport étendu",
      signOut: "Se déconnecter",
      pumpVariance: "Écart de la pompe",
      tankVariance: "Écart de réservoir",
      tanksFilled: "Réservoirs remplis",
      tankStock: "Stock de réservoir",
      branchSales: "Ventes en succursale",
      remisCards: "Cartes Rémis",
      dealerSalesSummary: "Résumé des ventes du concessionnaire",
      productsDischarged: "Produits déchargés",
      stockValuation: "Évaluation des stocks",
      confirmLogout: "Voulez-vous vraiment vous déconnecter ?",
      logout: "Se déconnecter",
      noAccess:
        "Désolé, vous n'avez pas accès à cette page, cliquez ci-dessous pour revenir à votre tableau de bord",
      expired: "VOTRE ABONNEMENT A EXPIRÉ VEUILLEZ EFFECTUER LE PAIEMENT",
      companyDashboard: "Tableau de bord de l'entreprise",
      dailyBranchTransactions: "Transactions quotidiennes en succursale",
      sendBranchReport: "Envoyer le rapport de succursale",
      retailOutlet: "Points de vente",
      management: "Gestion",
      expenses: "Dépenses",
      expenseCategory: "Catégories de dépenses",
      dealerFault: "Défauts cumulés du concessionnaire",
      maintenance: "Entretien",
      supportAdmin: "Administrateur de l'assistance",
      logout: "Se déconnecter",
      cashFlow: "Des flux de trésorerie",
      groupSalesSummary: "Résumé des ventes de groupe",
      stationSales: "Ventes en gare",
      youHave: ",tu as",
      sales: "Ventes",
      supplies: "Fournitures",
      manualRecords: "Enregistrements manuels",
      dryStock: "Stock sec",
      bank: "Banque",
      regionSalesSummary: "Récapitulatif des ventes de la région",
      regionProductStock: "Stock de produits de la région",
    },

    // Customer Dashboard
    cusDashboard: {
      balance: "Équilibre",
      fuelPoints: "Points de carburant",
      vehicles: "Véhicules",
      fuelConsumed: "Carburant consommé",
      litres: "Litres",
      vouchers: "Pièces justificatives",
      quickDetails: "Détails rapides",
      newVouchersGenerated: "Nouveaux bons générés",
      vouchersTransfered: "Coupons transférés",
      vouchersExpired: "Coupons expirés",
      showMore: "Montre plus",
      last10Trans: "5 dernières transactions",
      date: "Date",
      status: "Statut",
      amount: "Montante",
      remark: "Remarque",
      currentBalance: "Solde actuel",
      showMore: "Montre plus",
      drivers: "Conducteurs",
      subAccounts: "Sous-comptes",
      fuelConsumptionStats: "Statistiques de consommation de carburant",
      totalVolume: "Volume total (Litres)",
      voucherSummary: "Résumé du bon pour aujourd'hui",
    },

    // extended report
    extendedReport: {
      extendedReport: "Rapport étendu",
      excelReport: "Rapport Excel",
      fundWallet: "Portefeuille de fonds",
      bankTransfer: "Virement",
      creditCard: "Fonds avec carte",
      bankDeposit: "Par virement bancaire",
      funding: "Le portefeuille serait financé une fois le paiement reçu",
      form: "Remplissez le formulaire ci-dessous pour approvisionner votre compte par virement bancaire",
      bank: "Banque",
      name: "Nom du déposant",
      slipNumber: "Numéro du bordereau de dépôt",
      amount: "Montant",
      datepaid: "Aide à la date",
      request: "Demande de financement",
      quickFuel: "Carburant rapide",
      quick: "Ajouter une méthode de carburant rapide",
      phone: "Numéro de téléphone",
      cardBalance: "Solde de la carte",
      fundCard: "Carte de fonds",
      changePin: "Changer d'épingle",
      blockCard: "Bloquer la carte",
      cardTrans: "Transactions par carte",
      date: "Date",
      index: "Indice",
      amountNaira: "Montant (Naira)",
      type: "Taper",
      description: "Description",
      fund: "Fonds du portefeuille",
      wallet: "Approvisionnez votre carte depuis votre portefeuille",
      fundRemis: "Combien aimeriez-vous financer votre carte remis avec",
      pay: "Approvisionnez votre carte remis en effectuant un virement aux coordonnées bancaires suivantes",
      providus: "Providus",
      fundCardNoti: "le montant de la carte est requis",
    },

    // customer cards
    cards: {
      allCards: "Toutes les cartes",
      cards: "cartes",
      remisCards: "Cartes Rémis",
      cardNumber: "Numéro de carte",
      amount: "Montant",
      expiryDate: "Date d'expiration",
      user: "Utilisateur",
      locked: "Fermé à clé",
      action: "Action",
      numberOfCards: "Nombre de cartes",
      vehicleCards: "Cartes de véhicules",
      consumedAmount: "Quantité consommée",

      usageLocation: "Lieu d'utilisation",
      location: "Emplacement",
      ownerEmail: "E-mail du propriétaire",
      returnBalance: "Retourner le solde",
      vehicle: "Véhicule",
    },

    // Customer Drivers
    drivers: {
      myDrivers: "Mes pilotes",
      generateVouchers: "Générer des bons pour les chauffeurs",
      sendVoucher: "Créer votre bon",
      printVoucher: "Imprimer le(s) bon(s)",
      wallet: "Portefeuille",
      bearer: "Porteur",
      never: "Jamais",
      sixHours: "6 heures",
      twelveHours: "12 heures",
      twentyFourHours: "24 heures",
      sevenDays: "7 jours",
      thirtyDays: "30 jours",
      addDriver: "Ajouter un pilote",
      createDriver: "Créer un pilote",
      listOfDrivers: "Liste des pilotes",
      name: "Nom",
      phone: "Téléphone",
      email: "E-mail",
      state: "État",
      amount: "Montant",
      balanceTo: "Solde à",
      validity: "Validité",
      driversName: "Nom du conducteur",
      phoneNumber: "Numéro de téléphone",
      driversCode: "Code du conducteur",
      address: "Adresse",
      state: "État",
      confirmDelete: "Voulez-vous vraiment supprimer le pilote ?",
      successfullyRemoved: "Pilote supprimé avec succès",
      amountMissing: "Veuillez entrer un montant",
      balanceToMissing: "Veuillez sélectionner la destination du solde",
      validityMissing: "Veuillez sélectionner une option d'expiration",
      successfullySent: "Bon envoyé avec succès",
      createVehicleVoucher: "Coupon créé avec succès",
      amountZeroError: "Le montant ne peut pas être nul",
      noDriverError: "Sélectionnez au moins un (1) pilote pour continuer",
      nameMissing: "Veuillez entrer un nom",
      codeMissing: "Veuillez entrer un code",
      addressMissing: "Veuillez entrer une adresse",
      stateMissing: "Veuillez saisir un état",
      successfullyAdded: "Pilote ajouté avec succès",
      linkedVehicles: "Véhicules liés",
      date: "Date",
      accountType: "Type de compte",
      customer: "Client",
      currency: "Monnaie",
      naira: "Naira",
      voucherAmount: "Montant du bon d'achat",
      returnBalanceTo: "Retourner le solde à",
      validity: "Validité",
      driversListGVoucher: "Liste des pilotes pour le bon généré",
      drvsName: "Nom",
      drvsPhone: "Numéro de téléphone",
      drvsEmail: "Email",
      drvsState: "État",
    },

    branch: {
      branchExpenses: "Dépenses des succursales",
      filterData:
        "Vous pouvez filtrer les données en fonction d'une succursale et d'une région sélectionnées ici.",
      name: "Nom",
      dealer: "Marchand",
      city: "Ville",
      selectRegion: "Choisissez une région",
      allRegion: "Toutes les régions",
      selectBranch: "Sélectionnez la succursale",
      allBranches: "Toutes les succursales",
      totalBranches: "Nombre total de succursales",
      station: "Nombre total de succursales",
      region: "Région",
      expense: "Dépense(NGN)",
      category: "Dépenses par catégories",
      allCategory: "Toutes catégories",
      totalExpenses: "Dépenses totales",
      expenseBreakdown: "Ventilation des dépenses pour",
      date: "Date",
      retailOutlet: "Point de vente",
      cat: "Catégorie",
      desc: "Description",
      manageRetail: "Gérer les points de vente",
      viewRetailOutlet:
        "Vous pouvez visualiser et gérer tous vos points de vente ici...",
      totalOutlets: "Points de vente totaux",
      dealerPriceUpdate: "Mise à jour des prix du concessionnaire",
      dailyBranchTransaction: "Transactions quotidiennes en succursale",
      dailyBranchTransOn: "Transactions quotidiennes en succursale sur",
      viewTransactions:
        "Vous pouvez voir les transactions quotidiennes de la succursale ici...",
      branchTransactionOn: "Transaction quotidienne en succursale activée",
      product: "Produit",
      transactionCount: "Nombre de transactions",
      status: "Statut",
      address: "Adresse",
      state: "État",
      dealerBranchesReport: "Rapport sur les succursales des concessionnaires",
      sendBranchesReport:
        "Vous pouvez envoyer et transmettre le rapport de votre succursale ici...",
      all: "Tout",
      sent: "Envoyé",
      notSent: "Pas envoyé",
      totalCount: "Le compte total",
      sendDealerReport: "Envoyer le rapport du concessionnaire",
      group: "Groupe",
      showAll: "Afficher tout",
      selectStatus: "Sélectionnez le statut",
      approved: "Approuvé",
      declined: "Diminué",
      totalTransactions: "Transactions totales",
      successfulTransactions: "Transactions réussies",
      failedTransactions: "Transactions échouées",
      totalCashback: "Total des frais de remise en argent",
      posTrans: "Transactions au point de vente entre",
      and: "et",
      transDate: "Date de la transaction",
      pump: "Pompe",
      amount: "Montant",
      rrn: "RRN",
      maskedPan: "Casserole masquée",
      action: "Action",
      assignPos:
        "Vous pouvez attribuer et réattribuer le point de vente à une succursale sélectionnée ici :)",
      hi: "Salut",
      allTerminals: "Toutes les bornes",
      terminalId: "Identifiant du terminal",
      serialNo: "Numéro de série",
      vendor: "Fournisseur",
      companyBranchesReport: "Rapport des succursales de l'entreprise",
      sendCompanyReport: "Envoyer le rapport de l'entreprise",
      company: "Entreprise",
      report: "Rapport",
      reportDate: "Date du compte rendu",
      atgOnly: "Avec ATG uniquement",
      true: "Vrai",
      false: "FAUX",
      forwardReport: "Transférer le rapport",
      mailTo: "Envoyer à",
      title: "Points de vente",
      details: "Détails",
      mailRecipient: "Destinataire du courrier",
      manageTargets: "Gérer les cibles",
      mapUserToBranch: "Mapper l'utilisateur au point de vente",
      branchProduct: "Stock de produits de la branche",
      selectBranch:
        "sélectionnez une succursale pour voir le stock de produits correspondant ici",
      totalStock: "Stock total",
      totalQuantitySupplied: "Quantité totale fournie",
      totalQuantitySold: "Quantité totale vendue",
      productName: "Nom du produit",
      quantitySupplied: "Quantité fournie",
      quantitySold: "Quantité vendue",
      action: "Action",
      stan: "Stan",
    },

    // Customer Balance
    balance: {
      title: "Équilibre",
      fundWallet: "Portefeuille de fonds",
      history: "Histoire",
      last10Trans: "10 dernières transactions",
      date: "Date",
      status: "Statut",
      amount: "Montant",
      remark: "Remarque",
      currentBalance: "Solde actuel",
      paymentConfirmation: "Confirmation de paiement",
    },

    // shutdown History
    shutdownHistory: {
      pumpShutdown: "Arrêt de la pompe",
      shutdownHistory: "Historique des arrêts",
      shutdownPumps: "Pompes d'arrêt",
      shutdownNow: "Arrêter maintenant",
      scheduleShutdown: "Planifier l'arrêt",
      all: "Tout",
      noShutdownHistory:
        "Aucun historique d'arrêt enregistré pour ce revendeur pour le moment",
      reason: "Raison",
    },

    // Previous Wallet Transactions
    previousTrans: {
      balance: "Équilibre",
      transBetween: "Transaction entre",
      prevTransBtw: "Transactions de portefeuille précédentes entre",
      date: "Date",
      status: "Statut",
      amount: "Montant",
      remark: "Remarque",
      currentBalance: "Solde actuel",
    },

    // Fuel Consumption index.uve and vehicle_fuel_consumption.vue
    fuelConsumption: {
      table: "Tableau",
      chart: "Graphique",
      title: "Consommation de carburant",
      plateNumber: "Numéro de la plaque",
      date: "Date",
      email: "E-mail",
      state: "État",
      week: "Semaine",
      chargeType: "Type de frais",
      driver: "Conducteur",
      createdBy: "Créé par",
      volume: "Volume",
      pricePerLitre: "Prix/litre",
      voucher: "Bon",
      stationName: "Nom de la station",
      fuelConsumptionStats: "Statistiques de consommation de carburant",
      totalVolume: "Volume total (Litres)",
      chargeAmount: "Montant des frais",
      description: "Description",
      currentBalance: "Solde actuel",
      voucherPin: "Broche de bon",
      voucherUsed: "Coupon utilisé",
      voucherAmount: "Montant du bon d'achat",
      parentVoucher: "Bon parental",
      amountPaid: "Le montant payé",
      stationState: "État de la station",
    },

    // Lease
    lease: {
      leases: "Baux/loyers pour",
      outlet: "sortie",
      viewEbenLease: "Voir tous les baux pour la succursale d'Eben ici...",
      allLeases: "Tous les baux/loyers",
      rentDate: "Date de location",
      branchSpace: "Espace succursale",
      occupantName: "Nom de l'occupant",
      occupantEmail: "Courriel de l'occupant",
      paymentCompleted: "Paiement terminé",
      manageBranchSpace: "Gérer l'espace de la succursale",
      manageBranchSpaceHere:
        "Gérez votre espace agence ici pour vos agences ici...",
      createBranchSpace: "Créer un espace succursale",
      totalCount: "Le compte total",
      rentFree: "Loyer gratuit",
      rooms: "Pièces",
      rentDuration: "Durée du loyer",
      available: "Disponible",
      action: "Action",
      propertyName: "Nom de la propriété",
      rentFee: "Frais de location",
      numberOfRooms: "Nombre de chambres",
      numberOfRestrooms: "Nombre de salles de repos",
      additionalDetails: "Détails supplémentaires",
      branchLease: "Baux de succursale",
      viewBranchLease:
        "Consultez tous les baux des succursales en sélectionnant une succursale ici...",
      allLeases: "Tous les baux",
      selectBranch: "sélectionner la branche",
      leasedBy: "Loué par",
    },

    // Customer Fund Wallet
    fundWallet: {
      confirmingPayment: "Confirmation de votre paiement...",
      paymentconfirmed: "Paiement accepté",
      errorConfirming:
        "Erreur lors de la confirmation de votre paiement, veuillez réessayer.",
      bankTransfer: "Virement",
      fundWithCard: "Fonds avec carte",
      fundAccountWithCard:
        "Approvisionnez votre compte en payant avec votre carte en ligne",
      howMuch: "Avec combien aimeriez-vous alimenter votre porte-monnaie ?",
      payNow: "Payez maintenant",
      fundAccountWithBank:
        "Approvisionnez votre compte en effectuant un virement bancaire aux coordonnées bancaires suivantes",
      accountName: "Nom du compte",
      amount: "Montant",
      remis: "Remis",
      bankName: "Nom de banque",
      accountNumber: "Numéro de compte",
      processingFunding:
        "Votre portefeuille sera financé dans les prochaines minutes.",
      paymentConfirmed: "Paiement accepté!",
      paymentCompleted: "Paiement terminé",
      amountNotSet: "Veuillez entrer un montant",
    },

    // Outstanding Payments indev.vue and outstanding_payments.vue
    payments: {
      totalAmount: "Montant total",
      title: "Paiements impayés",
      makePayments: "Effectuer des paiements",
      branchName: "Nom de la station",
      address: "Adresse",
      accountName: "Nom du compte",
      accountNumber: "N ° de compte.",
      bankName: "Nom de banque",
      amount: "Montant",
      updateAccount: "Compte mis à jour",
      viewTransactions: "Afficher les opérations",
      processingPayments: "Traitement du paiement",
      amountToTransfer: "Montant à transférer",
      inputAmount: "Montant d'entrée",
      noAccountError:
        "Veuillez sélectionner au moins un compte pour effectuer le paiement",
      amountMissing: "Veuillez entrer un montant pour",
      amountLow: "Veuillez saisir un montant supérieur à 0 pour",
      successfulPayment: "Paiement effectué avec succès !",
    },

    // Wallet Transactions
    cusWalletTransactions: {
      totalTransactions: "Transactions totales",
      title: "Transactions de portefeuille",
      transBetween: "Transactions de portefeuille entre",
      date: "Date/Heure",
      amount: "Monnaie de {currency}",
      source: "Source",
      status: "Statut",
      walletBalance: "Solde du portefeuille {currency}",
    },

    // Customer Profile
    cusProfile: {
      accountSettings: "Paramètres du compte",
      email: "E-mail",
      firstName: "Prénom",
      lastName: "Nom de famille",
      phoneNumber: "Numéro de téléphone",
      editProfile: "Editer le profil",
      changeYourPassword: "Changez votre mot de passe",
      oldPassword: "ancien mot de passe",
      newPassword: "nouveau mot de passe",
      confirmPassword: "Confirmez le mot de passe",
      passwordMustContain: "Le mot de passe doit contenir",
      oneNumeric: "Un caractère numérique",
      specialCharacter: "Un caractère spécial",
      changePassword: "Changer le mot de passe",
      successfullyChanged: "Mot de passe changé avec succès !",
      fillIn: "Remplissez les champs manquants",
      updated: "Mise à jour du profil réussie!",
      oldPasswordMissing: "Veuillez entrer votre mot de passe actuel",
      passwordBlank: "Le champ du mot de passe ne peut pas être vide",
      passwordsDontMatch: "Les mots de passe ne correspondent pas",
      newPasswordMissing: "Veuillez entrer votre nouveau mot de passe",
      newPasswordShort:
        "Le nouveau mot de passe doit comporter entre 8 et 100 caractères",
      confirmPasswordError: "Veuillez confirmer votre nouveau mot de passe",
      passwordLackingError:
        "Le nouveau mot de passe doit inclure au moins un caractère alphanumérique et un caractère spécial",
    },

    // Customer Retainership
    cusRetainership: {
      title: "Mandats | FORFAIT",
      balance: "Équilibre",
      company: "Entreprise",
      wallet: "Portefeuille",
    },

    // Send Voucher
    sendVoucher: {
      sendVoucherBy: "Envoyer le bon par",
      voucherPin: "Broche de bon",
      voucherAmount: "Montant du bon d'achat",
      recipientEmail: "Destinataire E-mail",
      recipientPhone: "Numéro de téléphone du destinataire",
      message: "Message",
      sendSms: "Envoyer un SMS",
      sendMail: "Envoyer un mail",
      messageError: "Veuillez entrer un message",
      emailBlank: "Veuillez saisir l'e-mail du destinataire",
      phoneNoBlank: "Veuillez saisir le numéro de téléphone du destinataire",
      shortNo:
        "Le numéro de téléphone du destinataire doit comporter entre 10 et 13 caractères",
      successfullySent: "Bon envoyé avec succès",
    },

    // Sub Accounts
    subAccounts: {
      title: "Sous-comptes",
      createSubAccount: "Créer un sous-compte",
      email: "E-mail",
      firstName: "Prénom",
      lastName: "Nom de famille",
      phoneNumber: "Numéro de téléphone",
      balance: "Équilibre",
      details: "Détails",
      successfullyDeleted: "Sous-compte supprimé avec succès",
      confirmDelete: "Voulez-vous vraiment supprimer ce sous-compte ?",
    },

    // Create Sub Account
    createSubAccount: {
      addSubAccount: "Ajouter un sous-compte",
      fillFields: "Remplissez les champs",
      email: "email@email.com",
      firstName: "Prénom",
      lastName: "Nom de famille",
      phoneNumber: "Numéro de téléphone",
      successfullyCreated: "Sous-compte créé avec succès",
    },

    // Sub Account Details
    subAccountDetails: {
      title: "Sous-compte",
      vouchers: "Pièces justificatives",
      transactions: "Transactions",
      consumptions: "Consommations",
      consumptionRecords: "Registres de consommation",
      transBetween: "Transactions entre",
      date: "Date",
      volume: "Volume",
      pricePerLitre: "Prix/litre",
      voucherAmount: "Montant du bon d'achat",
      voucher: "Bon",
      amountPaid: "Le montant payé",
      stationName: "Nom de la station",
      city: "Ville",
      state: "État",
      status: "Statut",
      amount: "Montant",
      remark: "Remarque",
      currentBalance: "Solde actuel",
      dateCreated: "date créée",
      returnBalanceTo: "Retourner le solde à",
      isUsed: "Est utilisé",
      source: "Source",
      expiryDate: "Date d'expiration",
    },

    // Vehicles
    vehicles: {
      myVehicles: "Mes véhicules",
      generateVouchers: "Générer des bons pour les véhicules",
      sendVoucher: "Créer",
      wallet: "Portefeuille",
      bearer: "Porteur",
      never: "Jamais",
      sixHours: "6 heures",
      twelveHours: "12 heures",
      twentyFourHours: "24 heures",
      sevenDays: "7 jours",
      thirtyDays: "30 jours",
      never: "Jamais",
      all: "Tout",
      selectVehicle: "Sélectionnez le(s) véhicule(s)",
      used: "Peut être utilisé dans",
      listOfVehicles: "Liste des véhicules",
      printVoucher: "Imprimer le(s) bon(s)",
      driver: "Conducteur",
      vehicleType: "Type de véhicule",
      carMake: "Marque de voiture",
      allVehicles: "Tous les véhicules",
      errorOccured: "Une erreur s'est produite",
      carModel: "Modèle de voiture",
      modelYear: "Année modèle",
      plateNumber: "Numéro de la plaque",
      cardNumber: "Numéro de carte",
      amount: "Montant",
      networkError: "Erreur réseau Veuillez vérifier votre connexion Internet",
      balanceTo: "Solde à",
      validity: "Validité",
      canBeUsedIn: "Peut être utilisé dans",
      phoneNumber: "Numéro de téléphone",
      amountMissing: "Veuillez entrer un montant",
      balanceToMissing: "Veuillez sélectionner la destination du solde",
      validityMissing: "Veuillez sélectionner une option d'expiration",
      usedInMissing: "Veuillez sélectionner où ce bon peut être utilisé",
      successfullySent: "Bon envoyé avec succès",
      amountZeroError: "Le montant ne peut pas être nul",
      noVehicleError:
        "Veuillez sélectionner au moins un (1) véhicule pour continuer",
      fuelConsumed: "Carburant consommé",
      vehicleType: "Type de véhicule",
      vehicleMake: "Marque du véhicule",
      vehicleModel: "Modèle de véhicule",
      generateVehicleVoucher: "Générer un bon de véhicule",
      createVoucher: "Créer votre bon",
      enterDetails: "Entrez les détails du bon",
      year: "Année",
      returnBalance: "Retourner le solde à",
    },

    // Create Vehicle
    createVehicle: {
      title: "Créer un véhicule",
      enterVehicleDetails: "Entrez les détails du véhicule",
      selectVehicleType: "Sélectionnez le type de véhicule",
      carOrLorry: "Voiture/Camion",
      motorcycle: "Moto",
      selectVehicleMake: "Sélectionnez la marque du véhicule",
      selectVehicleModel: "Sélectionnez le modèle de véhicule",
      title: "Créer un véhicule",
      plateNumberPlaceholder: "Numéro de la plaque",
      fullName: "Nom et prénom",
      phoneNumber: "Numéro de téléphone",
      modelYear: "Année modèle",
      plateNumberMissing: "Veuillez entrer le numéro de plaque de la voiture",
      fullNameMissing:
        "Veuillez entrer le nom complet du propriétaire de la voiture",
      vehicleTypeMissing: "Veuillez sélectionner le type de véhicule",
      carMakeMissing: "Veuillez sélectionner la marque du véhicule",
      carModelMissing:
        "Veuillez sélectionner le modèle du véhicule Veuillez sélectionner le modèle du véhicule",
      modelYearMissing: "Veuillez saisir l'année de modèle du véhicule",
      successfullyCreated: "Véhicule créé avec succès",
    },

    // Verify Receipt
    verifyReceipt: {
      title: "VÉRIFIER LE REÇU",
      verify: "VÉRIFIER",
      amount: "Montant",
    },

    // Voucher
    voucher: {
      generated: "Pièces justificatives",
      transferred: "Transféré",
      expired: "Expiré",
      transBetween: "Transactions entre",
      sendByMail: "Envoyer par courrier",
      sendBySms: "Envoyer par SMS",
      listOfVouchers: "Liste des bons",
      printVoucher: "Imprimer le(s) bon(s)",
      title: "Bon",
      dateCreated: "date créée",
      amount: "Montant",
      returnBalanceTo: "Retourner le solde à",
      isUsed: "Est utilisé",
      source: "Source",
      expiryDate: "Date d'expiration",
      dateSent: "Date d'envoi",
      bearer: "Porteur",
      sentVia: "Envoyé via",
      successfullyPrinted: "Bons imprimés avec succès",
      selectAtLeast: "Sélectionnez au moins un (1) bon pour continuer",
    },

    // Create Voucher
    createVoucher: {
      createNew: "Créer un nouveau bon",
      completeAtLeast:
        "Veuillez remplir au moins un bon pour continuer, cliquez sur le bouton Ajouter plus pour ajouter un nouveau bon",
      amount: "Montant",
      byHowMany: "Par combien",
      date: "Date",
      returnBalanceTo: "Retourner le solde à",
      accountType: "Type de compte",
      expiry: "Expiration",
      canBeUsedIn: "Peut être utilisé dans",
      voucherAmount: "Montant du bon d'achat",
      validity: "Validité",
      bearer: "Porteur",
      wallet: "Portefeuille",
      never: "Jamais",
      sixHours: "6 heures",
      twelveHours: "12 heures",
      twentyFourHours: "24 heures",
      sevenDays: "7 jours",
      thirtyDays: "30 jours",
      all: "Tout",
      naira: "Naira",
      currency: "Monnaie",
      customer: "Client",
      addMore: "Ajouter plus",
      serviceCharge: "Chaque bon entraîne des frais de service de {currency}",
      list: "Liste des véhicules pour le bon généré",
      title: "Créer votre bon",
      amountInvalid: "Veuillez entrer un montant valide",
      lowVouchers: "Le nombre de bons à générer ne peut pas être inférieur à 1",
      amountMissing: "Veuillez entrer un montant",
      vouchersNumberBlank:
        "Le champ Nombre de bons à générer ne peut pas être vide",
      successfullyCreated: "Coupon créé avec succès",
    },

    // Account Confirmation
    accountConfirmation: {
      accountConfirmed: "Compte confirmé",
      thankYou: "Merci d'avoir confirmé votre email.",
      confirmed:
        "Vous pouvez maintenant vous connecter pour profiter des avantages offerts par Epump.",
      inProcess: "Confirmation par e-mail en cours",
      login: "Connexion",
      emailConfirmation: "confirmation de l'émail",
      pleaseWait: "Attends un peu s'il te plait",
      weConfirm: "nous confirmons votre email",
      proceed: "Procédez à la connexion après",
      afterSuccessfulConfirmation: "L'e-mail a été confirmé avec succès.",
      accountConfirm: "Compte confirmé",
      emailAddress: "Adresse e-mail",
      sign: "S'identifier",
      signIn: "Se connecter | S'IDENTIFIER",
      email: "E-mail",
      password: "Mot de passe",
      passwordLackingError:
        "Le mot de passe doit inclure au moins un caractère alphanumérique et un caractère spécial",
      thanksForConfirming:
        "Merci d'avoir confirmé votre e-mail, connectez-vous",
      loginSuccessful: "Connexion réussie",
      fillIn: "Remplissez les champs manquants",
      noAccount: "Vous n'avez pas de compte ?",
      signUp: "S'inscrire",
      noAccess:
        "Vous ne disposez d'aucun des rôles requis pour accéder au portail",
    },

    // Change Password
    changePassword: {
      changeYourPassword: "Changez votre mot de passe",
      passwordMustContain: "Le mot de passe doit contenir",
      oneNumeric: "Un caractère numérique",
      specialCharacter: "Un caractère spécial",
      title: "Changer le mot de passe",
      enterDetails:
        "Saisissez les détails de votre ancien mot de passe et de votre nouveau mot de passe",
      toReset: "Pour réinitialiser votre mot de passe",
      inProcess: "Confirmation par e-mail en cours",
      oldPassword: "ancien mot de passe",
      newPassword: "nouveau mot de passe",
      confirmPassword: "Confirmez le mot de passe",
      oldPasswordMissing: "Veuillez entrer votre mot de passe actuel",
      newPasswordMissing: "Veuillez entrer votre nouveau mot de passe",
      passwordLackingError:
        "Le nouveau mot de passe doit inclure au moins un caractère alphanumérique et un caractère spécial",
      newPasswordShort:
        "Le nouveau mot de passe doit comporter entre 8 et 100 caractères",
      passwordsDontMatch: "Les mots de passe ne correspondent pas",
      successfullyChanged: "Mot de passe modifié avec succès",
      confirmPasswordError: "Veuillez confirmer votre mot de passe",
    },

    // Password Email Notifiaction
    passwordEmailNotification: {
      passwordReset: "Réinitialisation du mot de passe",
      linkSent: "Un lien de réinitialisation du mot de passe a été",
      sentToMail: "envoyé à votre courrier",
      pleaseCheck:
        "Veuillez vérifier votre courrier et cliquez sur le bouton de réinitialisation",
      toReset: "lien pour réinitialiser votre mot de passe.",
      backToLogin: "Retour connexion",
    },

    // Password Reset Confirmation
    passwordResetConfirmation: {
      resetYourPassword: "Réinitialisez votre mot de passe",
      passwordMustContain: "Le mot de passe doit contenir",
      oneNumeric: "Un caractère numérique",
      specialCharacter: "Un caractère spécial",
      resetPassword: "réinitialiser le mot de passe",
      enterDetails:
        "Saisissez les détails de votre ancien mot de passe et de votre nouveau mot de passe",
      toReset: "pour réinitialiser votre mot de passe",
      pleaseWait:
        "Veuillez patienter pendant que nous remplissons votre demande de mot de passe !",
      email: "E-mail",
      emailAddress: "Adresse e-mail",
      password: "nouveau mot de passe",
      confirmPassword: "Confirmer le nouveau mot de passe",
      confirmPasswordError: "Veuillez confirmer votre mot de passe",
      passwordLackingError:
        "Le mot de passe doit inclure au moins un caractère alphanumérique et un caractère spécial",
      passwordsDontMatch: "Les mots de passe ne correspondent pas",
      resetCompleted:
        "La réinitialisation du mot de passe est terminée, passez à la connexion",
      fillIn: "Remplissez les champs manquants",
    },

    // Registration Completed
    registrationCompleted: {
      title: "Inscription terminée",
      linkSent: "Un lien de confirmation a été",
      sentToMail: "envoyé à votre courrier",
      pleaseCheck:
        "Veuillez vérifier votre courrier et cliquez sur la confirmation",
      toConfirm: "lien pour confirmer votre adresse e-mail.",
      backToLogin: "Retour connexion",
    },

    // signUp
    signUp: {
      signUp: "S'inscrire",
      firstName: "Prénom",
      lastName: "Nom de famille",
      emailAddress: "Adresse e-mail",
      phoneNumber: "Numéro de téléphone",
      password: "Mot de passe",
      register: "Enregistrer",
      existingAccount: "Vous avez déjà un compte?",
      signIn: "S'identifier",
      manageFueling: "Gérez votre ravitaillement au quotidien avec Epump",
      register: "Enregistrer",
    },

    // Reset Password
    resetPassword: {
      resetYourPassword: "Réinitialisez votre mot de passe",
      title: "réinitialiser le mot de passe",
      enterUserName: "Entrez votre adresse e-mail dans le champ à gauche",
      sectionReset: "section pour réinitialiser votre mot de passe",
      inProcess: "Confirmation par e-mail en cours",
      userName: "Nom d'utilisateur",
      email: "E-mail",
      linkSent:
        "Un lien de réinitialisation du mot de passe a été envoyé à votre adresse e-mail, cliquez dessus pour terminer la réinitialisation du mot de passe",
      userNameMissing: "Veuillez entrer un nom d'utilisateur",
    },

    // Login
    login: {
      selectALanguage: "Sélectionnez une langue",
      selectACountry: "Choisissez un pays",
      signIn: "Se connecter | S'IDENTIFIER",
      noAccount: "Vous n'avez pas de compte ?",
      signUp: "S'inscrire | S'INSCRIRE",
      forgotPassword: "Mot de passe oublié?",
      hello: "Bonjour",
      user: "Utilisateur!",
      keepConnected: "Pour rester en contact avec nous s'il vous plaît",
      loginWith: "connectez-vous avec vos informations de compte",
      or: "OU",
      enterDetails: "Entrez vos données personnelles et commencez",
      yourJourney: "votre voyage avec nous",
      createAccount: "Créer un compte | CRÉER UN COMPTE",
      passwordMustContain: "Le mot de passe doit contenir",
      oneNumeric: "Un caractère numérique",
      specialCharacter: "Un caractère spécial",
      haveAnAccount: "Avoir un compte?",
      email: "E-mail",
      emailAddress: "Adresse e-mail",
      password: "Mot de passe",
      phoneNumber: "Numéro de téléphone",
      firstName: "Prénom",
      lastName: "Nom de famille",
      confirmPassword: "Confirmez le mot de passe",
      passwordLackingError:
        "Le mot de passe doit inclure au moins un caractère alphanumérique et un caractère spécial",
      successfullySignedUp:
        "Vous vous êtes inscrit avec succès. Veuillez vérifier votre courrier pour un lien de confirmation",
      loginSuccessful: "Connexion réussie",
      confirmPasswordError: "Veuillez confirmer votre nouveau mot de passe",
      passwordsDontMatch: "Les mots de passe ne correspondent pas",
      forgotPassword: "Mot de passe oublié ?",
      manageFuelingEpump: "Gérez votre ravitaillement au quotidien avec epump",
      resetPassword: "réinitialiser le mot de passe",
    },
    /***** Modals */

    // Add Email To Branch
    addEmailToBranch: {
      mapUser: "Mapper l'utilisateur au point de vente",
      companyAdmin: "Administrateur de l'entreprise",
      branchManager: "Manager de station",
      customer: "Client",
      email: "E-mail",
      selectRole: "Sélectionnez un rôle",
      selectRoleError: "Veuillez sélectionner un rôle",
      successfullyMapped: "L'utilisateur a bien été mappé au point de vente",
    },

    // aaDetails Modal
    aaDetailsModal: {
      companyAddres: "Adresse de la société",
      companyName: "Nom de l'entreprise",
      orderNumber: "Numéro de commande",
      refNumber: "Numéro de réference",
      unregisteredTruck: "Camion non immatriculé",
      driverName: "Nom du conducteur",
      driverEmail: "Courriel du conducteur",
      driverPhone: "Téléphone du conducteur",
      licensePlate: "Plaque d'immatriculation",
      waybillDate: "Date de la lettre de voiture",
      comment: "Commentaire",
      truckName: "Nom du camion",
    },

    // Add AAModals
    addAAModal: {
      addAA: "Ajouter une alarme et une alerte",
      selectOwner: "Sélectionnez le propriétaire",
      selectEvent: "Sélectionnez l'événement",
      addAlertAlarm: "Ajouter une alarme d'alerte",
      chooseOwner: "Veuillez choisir un propriétaire",
      chooseEvent: "Veuillez choisir un événement",
      aaAdded: "AA ajouté avec succès",
    },

    // Update AAModal
    updateAAModal: {
      updateAA: "Mettre à jour l'alarme et l'alerte",
      update: "Mise à jour",
    },

    // Assets
    assets: {
      inflow: "Afflux",
      outflow: "Sortie",
      updateCreditLimit: "Mettre à jour la limite de crédit",
      walletTransactions: "Transaction de portefeuille",
      addAssetFile: "Ajouter des fichiers à l'actif",
      documents: "Documents",
      uploadDoc: "Télécharger des documents",
      successfullyAddedAssetFile: "Fichier d'actif ajouté avec succès",
      selectDoc: "Veuillez sélectionner un document",
      // Add assets to group
      assetName: "Nom de l'actif",
      assetDescription: "Description de l'actif",
      assetGroup: "Groupe d'actifs",
      selectGroup: "Sélectionnez le groupe",
      assetLicenseNo: "Numéro de licence d'actif",
      isServicable: "est réparable ?",
      isRenewable: "est renouvelable ?",
      serviceDate: "Date d'entretien",
      renewalDate: "Date de renouvellement",
      expiryDate: "Date d'expiration",
      createAsset: "Créer un actif",
      assetNameRequired: "Le nom de l'actif est requis",
      assetDescRequired: "La description de l'actif est requise",
      selectServiceDate: "Veuillez sélectionner une date de service",
      selectRenewalDate: "Veuillez sélectionner une date de renouvellement",
      sucessfullyRenewedAsset: "Actif renouvelé avec succès",
      successfullyCreatedAsset: "Élément créé avec succès",
      successfullyCreatedAssetGroup: "Le groupe d'éléments a bien été créé",
      successfullyUpdatedAsset: "Actif mis à jour avec succès",
      // Asset details
      assetN: "Nom de l'actif :",
      assetGName: "Nom du groupe d'éléments :",
      assetDescription: "Description de l'actif",
      assetStatus: "État de l'actif :",
      assetDetail: "Détails de l'actif",
      licenseNumber: "Numéro de licence:",
      currActive: "Actuellement actif :",
      servDate: "Date d'entretien :",
      nextRenewalDate: "Prochaine date de renouvellement :",
      lastRenewalDate: "Date du dernier renouvellement :",
      expirationDate: "Date d'expiration:",
      dateCreated: "Date créée:",
      // Create Asset Group
      createAssetGroup: "Créer un groupe d'actifs",
      groupName: "Nom de groupe",
      groupDesc: "Description du groupe",
      groupType: "Type de groupe",
      selectGroupType: "Sélectionnez le type de groupe",
      licensesPermits: "Licences et permis",
      physical: "Physique",
      inputGroupName: "Veuillez saisir un nom de groupe",
      inputDesc: "Veuillez entrer une description",
      selectGroupType: "Veuillez sélectionner un type de groupe",
      successfullyEditedAssetGroup: "Le groupe d'éléments a bien été modifié",
      downloadSuccessful: "Téléchargement réussi",
      fileDeleted: "Fichier supprimé avec succès",
    },

    // Edit asset
    editAsset: {
      editAsset: "Modifier l'actif",
      assetName: "Nom de l'actif",
      assetDescription: "Description de l'actif",
      save: "Sauvegarder",
      assetGroup: "Groupe d'actifs",
      // Edit asset Group
      editAssetGroup: "Modifier le groupe d'éléments",
    },

    // Record Service
    recordService: {
      recordService: "Service d'enregistrement",
      dateServiced: "Date d'entretien",
      nextServiceDate: "Prochaine date de service",
      note: "Note",
      chooseServiceDate: "Veuillez choisir la date de la prestation",
      chooseNextServiceDate: "Veuillez choisir une prochaine date de service",
      serviceRecorded: "Service enregistré avec succès",
    },

    // Company Domain
    companyDomain: {
      updateCompanyDomain: "Mettre à jour le domaine de l'entreprise",
      update: "Mise à jour",
      title: "Domaine de l'entreprise",
      domainMissing: "Veuillez saisir un domaine d'entreprise",
      successfullyUpdated: "Domaine de l'entreprise mis à jour avec succès",
    },

    // Add Truck Modal
    addTruckModal: {
      addTruck: "Ajouter un camion",
      selectCompanyProduct: "Sélectionnez le produit de l'entreprise",
      dpk: "DPK",
      ago: "Gasoil",
      pms: "Essence",
      vehicleType: "Type de véhicule (0 ou 1)",
      zero: "0",
      one: "1",
      productionDate: "Date de production",
      engineNumberRequired: "Le numéro de moteur est requis",
      brandRequired: "La marque est requise",
      licensePlateMissing: "Plaque d'immatriculation manquante",
      vinMissing: "NIV manquant",
      companyProductRequired: "Le produit de l'entreprise est requis",
      vehicleTypeRequired: "Le type de véhicule est requis",
      successMsg: "Camion ajouté avec succès",
      vin: "NIV",
      firstName: "Prénom du conducteur",
      lastName: "Nom du conducteur",
      driverEmail: "Courriel du conducteur",
      totalFTVol: "Volume total du réservoir de carburant",
      model: "Modèle",
      unitId: "Identifiant de l'unité",
      color: "Couleur",
    },

    // Truck Details
    truckDetailsModal: {
      truckDetailsFor: "Détails du camion pour",
      licensePlate: "Plaque d'immatriculation",
      brand: "Marque",
      vehicleName: "Nom du véhicule",
      companyProduct: "Produit de l'entreprise",
      engineNumber: "Numéro de moteur",
      chasisNumber: "Numéro de châssis",
      type: "Taper",
      totalTankVol: "Volume total du réservoir",
    },

    // Update Truck modal
    updateTruckModal: {
      updateTruck: "Mettre à jour le camion",
      updateTruckFor: "Mettre à jour le camion pour",
      model: "Modèle",
      fuelTankVol: "Volume du réservoir de carburant",
      engineNo: "Moteur Non",
      chasisNo: "Châssis Non",
      vehicleTyp: "Type de véhicule",
      select: "0 ou 1",
      successMsg: "Camion mis à jour avec succès",
    },

    // Dashboard Modal
    dModal: {
      dearCustomer: "Cher client,",
      accessDisabled:
        "Votre abonnement epump a expiré et votre accès au portail a été désactivé. Veuillez effectuer un paiement pour réactiver votre accès au portail. Merci..",
      viewInvoices: "Afficher les factures",
      subscriptionExpire: "Votre abonnement epump expirera dans",
      serviceDisabled:
        "Votre service sera désactivé si vous n'effectuez pas le paiement avant la date d'échéance. Merci.",
      continueToPortal: "Continuer vers le portail",
      trackHistory: "Suivre l'historique",
    },

    // Detail Action Modal
    detailAction: {
      detailsFor: "Détails pour",
      dueDate: "Date d'échéance",
      facilityType: "Type d'établissement",
      facilityName: "Nom de l'installation",
      status: "Statut",
      countDown: "Compte à rebours",
      update: "Mise à jour",
      done: "Marque comme Terminé",
      maintenanceTrackDetails: "Détails de la piste de maintenance",
      description: "Description",
      name: "Nom",
      email: "E-mail",
    },

    // Invoices
    invoicesModal: {
      export: "Exporter au format PDF",
      pdfInvoice: "Votre facture est prête à être téléchargée au format PDF.",
      cancel: "Annuler",
      downloadPdf: "Télécharger le PDF",
      successMsg: "Téléchargement réussi",
      errorMsg: "Impossible de télécharger le fichier",
      // Wallet Pay modal
      walletPay: "Payer depuis le portefeuille",
      enoughFundsInCompany:
        "Vous avez suffisamment de fonds dans le portefeuille de votre entreprise",
      walletBal: "Solde du portefeuille :",
      amountDue: "Montant dû:",
      pay: "PAYER",
      paymentSuccessful: "Paiement réussi",
    },

    // Drivers Modal
    driverModal: {
      assignDriver: "Attribuer un chauffeur à un camion",
      selectCompanyTruck: "Sélectionnez le camion de l'entreprise",
      assignTruck: "ATTRIBUER UN CAMION",
      successMsg: "Attribué avec succès",
      errorMsg: "Camion non sélectionné",
      linkVehicle: "Véhicule de liaison",
    },

    // Dry Stock
    dryStockModal: {
      rejectionReason: "Raison du rejet",
      rejectSupply: "Refuser l'approvisionnement",
      successMsg: "Fourniture rejetée avec succès",
    },

    addDriverModal: {
      title: "Ajouter un pilote",
      firstName: "Prénom",
      lastName: "Nom de famille",
      email: "E-mail",
      phoneNumber: "Pas de téléphone.",
      successfullyAdded: "Pilote ajouté avec succès",
    },

    // Group management modal
    gManagement: {
      addCompanyGroup: "Ajouter un groupe d'entreprises",
      addIndustryGroup: "Ajouter un groupe industriel",
      selectCategory: "Choisir une catégorie",
      addGroup: "Ajouter un groupe",
      inputName: "Veuillez entrer un nom",
      inputEmail: "Veuillez saisir un e-mail",
      inputDesc: "Veuillez entrer une description",
      chooseCategory: "Veuillez choisir une catégorie",
      groupCreated: "Groupe créé avec succès",
      mapGroupToBranch: "Mapper le groupe à la branche",
      selectIndustryBranch: "Sélectionnez la branche de l'industrie",
      selectCompanyBranch: "Sélectionnez la succursale de l'entreprise",
      mapGroup: "Groupe de cartes",
      noBranchCreated: "Il n'y a pas de succursale créée par cette société",
      errorMsg: "Branche non sélectionnée",
      successMsg: "Groupe cartographié avec succès",
      updateCompanyGroup: "Mettre à jour le groupe d'entreprises",
      updateIndustryGroup: "Mettre à jour le groupe industriel",
      updatedGroup: "Groupe mis à jour avec succès",
    },

    // Edit Driver Modal
    editDriverModal: {
      title: "Modifier le pilote",
      firstName: "Prénom",
      lastName: "Nom de famille",
      email: "E-mail",
      phoneNumber: "Pas de téléphone.",
      successfullyEdited: "Pilote modifié avec succès",
    },

    // Mange Expenses - Edit Category
    editCategoryModal: {
      title: "Modifier la catégorie",
      category: "CATÉGORIE",
      categoryPlaceholder: "Catégorie d'entrée",
      categoryMissing: "Veuillez entrer une catégorie",
      successfullyEdited: "Catégorie modifiée avec succès",
      unsuccessfulEdit: "Impossible de modifier la catégorie",
      sameCategoryError:
        "Veuillez entrer une catégorie différente de la catégorie actuelle",
    },

    // Order - Update Order Status
    updateOrderStatusModal: {
      setStatus: "Définir le statut de la commande",
      comment: "Commentaire",
      orderStatus: "Statut de la commande",
      driverAssigned: "Chauffeur assigné",
      paymentPending: "Paiement en attente",
      paymentCompleted: "Paiement terminé",
      paymentConfirmed: "Paiement accepté",
      orderCompleted: "Commande terminée",
      orderAccepted: "Commande acceptée",
      orderRejected: "Commande rejetée",
      processing: "Traitement",
      inTransit: "En transit",
      arrived: "Arrivé",
      ownerAccepted: "Propriétaire accepté",
      fillStarted: "Remplissage commencé",
      fillEnded: "Remplissage terminé",
      title: "État de mise à jour",
      commentMissing: "Veuillez entrer un commentaire",
      successfullyUpdated: "Statut de la commande mis à jour avec succès",
    },

    // Outstanding Payments - Edit Account Details Modal
    editAccountDetailsModal: {
      updateDetails: "Mettre à jour les détails du compte",
      accountNumber: "Numéro de compte",
      bankName: "Nom de banque",
      selectBank: "Sélectionnez une banque",
      accountName: "Nom du compte",
      accountBalance: "Solde du compte",
      title: "Compte mis à jour",
      verifyAccount: "vérifier le compte",
      amount: "Montant",
      accountNumberMissing: "Veuillez entrer un numéro de compte pour",
      bankMissing: "Veuillez sélectionner une banque pour",
      successfullyVerified: "Compte vérifié avec succès",
      successfullyUpdated: "Détails du compte mis à jour avec succès",
    },

    // Product
    editProductModal: {
      title: "Modifier le produit",
      productName: "Nom du produit",
      price: "Prix",
      state: "État",
      localGov: "Gouvernement local",
      area: "Zone | Zones",
      lgaName: "Nom LGA",
      deliveryHour: "Heure de livraison",
      addMore: "Ajouter plus",
      productNameMissing: "Veuillez saisir un nom de produit",
      priceMissing: "Veuillez entrer un prix",
      deliveryHourMissing: "Veuillez saisir une heure de livraison",
      successfullyEdited: "Produit modifié avec succès",
    },

    //  pumps
    editFaultModal: {
      title: "Modifier la cible",
      updateTarget: "Mettre à jour la cible",
      inputTarget: "Cible d'entrée",
      target: "CIBLE",
    },

    // Retainership - Edit Credit Limit
    editCreditLimit: {
      title: "Modifier la limite de crédit",
      edit: "Modifier",
      creditLimit: "Limite de crédit",
      creditLimitMissing: "Veuillez saisir une limite de crédit",
      successfullyEdited: "Limite de crédit modifiée avec succès",
      unsuccessfulEdit: "Impossible de modifier la limite de crédit",
    },

    // Shifts - Close Shifts
    closeShift: {
      title: "Fermer le quart",
      description: "DESCRIPTION",
      shiftDescription: "Description du quart de travail",
      closingReading: "Lecture de clôture | LECTURE DE CLÔTURE",
      closingReadingMissing: "Veuillez saisir une lecture de clôture",
      shiftDescriptionMissing: "Veuillez saisir une description d'équipe",
      successfullyClosed: "Quart fermé avec succès",
    },

    // Targets - Create Target
    createTargetModal: {
      title: "Créer une cible",
      monthlyTarget:
        "Objectif de ventes quotidiennes du point de vente au détail",
      salesProduct: "PRODUIT DE VENTE",
      selectAProduct: "choisissez un produit",
      target: "Cible | CIBLE",
      setTarget: "Choisir la cible",
      setBudget: "Définir le budget",
      productMissing: "Veuillez sélectionner un produit",
      targetMissing: "Veuillez saisir une cible",
      successfullyAdded:
        "Cible de point de vente au détail ajoutée avec succès",
      targetExists:
        "Ce produit a actuellement une cible, veuillez modifier la cible pour changer la cible",
    },

    // Targets - Edit Target and edit Faults
    editTargetModal: {
      title: "Modifier la cible",
      monthlyTarget:
        "Objectif de ventes quotidiennes du point de vente au détail",
      salesProduct: "PRODUIT DE VENTE",
      selectAProduct: "choisissez un produit",
      target: "Cible | CIBLE",
      productMissing: "Veuillez sélectionner un produit",
      targetMissing: "Veuillez saisir une cible",
      successfullyUpdated: "Cible de point de vente mise à jour avec succès",
      unsuccessfulUpdate: "Impossible de mettre à jour la cible",
    },

    // Trucks - Add Truck
    addTruckModal: {
      title: "Ajouter un camion",
      name: "Nom",
      plateNumber: "Numéro de la plaque",
      tankType: "Type de réservoir",
      capacity: "Capacité",
      nameMissing: "Veuillez entrer un nom",
      plateNumberMissing: "Veuillez entrer un numéro de plaque",
      tankTypeMissing: "Veuillez saisir un type de réservoir",
      capacityMissing: "Veuillez saisir une capacité",
      lowCapacity: "Veuillez entrer une capacité supérieure à 0",
      successfullyAdded: "Camion ajouté avec succès",
    },

    // Assign Truck Modal
    assignTruckModal: {
      title: "Attribuer un camion à un conducteur",
      selectCompanyDriver: "Sélectionnez le chauffeur de l'entreprise",
      assign: "ATTRIBUER UN CONDUCTEUR",
      driverError: "Pilote non sélectionné",
      assignSuccess: "Attribué avec succès",
    },

    // Trucks - Edit Truck
    editTruckModal: {
      title: "Modifier le camion",
      name: "Nom",
      plateNumber: "Numéro de la plaque",
      tankType: "Type de réservoir",
      capacity: "Capacité",
      nameMissing: "Veuillez entrer un nom",
      plateNumberMissing: "Veuillez entrer un numéro de plaque",
      tankTypeMissing: "Veuillez saisir un type de réservoir",
      capacityMissing: "Veuillez saisir une capacité",
      successfullyEdited: "Camion édité avec succès",
    },

    // Vehicle - Edit Vehicle
    editVehicleModal: {
      title: "Modifier le véhicule",
      edit: "Modifier",
      driver: "Chauffeur | CONDUCTEUR",
      phoneNumber: "Numéro de téléphone | NUMÉRO DE TÉLÉPHONE",
      vehicleType: "Type de véhicule | TYPE DE VÉHICULE",
      carMake: "Marque de voiture | MARQUE DE VOITURE",
      carModel: "Modèle de voiture | MODÈLE DE VOITURE",
      modelYear: "Année modèle | ANNÉE MODÈLE",
      plateNumber: "Numéro de plaque | NUMÉRO DE LA PLAQUE",
      driverMissing: "Veuillez saisir un pilote",
      vehicleTypeMissing: "Veuillez saisir un type de véhicule",
      carMakeMissing: "Veuillez saisir une marque de voiture",
      carModelMissing: "Veuillez saisir un modèle de voiture",
      modelYearMissing: "Veuillez saisir une année modèle",
      plateNumberMissing: "Veuillez entrer un numéro de plaque",
      successfullyEdited: "Véhicule modifié avec succès",
    },

    //Add card to vehicle
    addCardVehicle: {
      title: "Ajouter une carte au véhicule",
      cardNum: "Numéro de carte",
      newPin: "Nouvelle épingle",
      oldPin: "Ancienne broche",
      pin: "Broche",
      confirmPin: "Confirmer le NIP",
      addCard: "Ajouter une carte",
      cardError: "Veuillez saisir un numéro de carte",
      pinError: "Veuillez entrer une épingle",
      confirmPinError: "Veuillez confirmer votre NIP",
      pinNoMatch: "Les broches ne correspondent pas",
      cardSuccess: "Carte ajoutée avec succès au véhicule",
      oldPinError: "Veuillez saisir votre ancien code PIN",
      fourDigitErr: "Veuillez saisir un code PIN à 4 chiffres",
      newPinErr: "Veuillez saisir un nouveau code PIN",
      newPinFourErr: "Veuillez saisir un nouveau code PIN à 4 chiffres",
      successfullyChangedPin: "Épingle changée avec succès",
      sureBlockCard: "Voulez-vous vraiment bloquer cette carte ?",
      successfullyBlockedCard: "Carte bloquée avec succès",
    },

    // Add old user modal
    addOldUser: {
      addExistingUser: "Ajouter un utilisateur existant",
      selectAcessLevel: "sélectionner le niveau d'accès",
      select: "Sélectionner",
      addUser: "Ajouter un utilisateur",
      alreadyMapped: "Ce compte a déjà été associé à un compte d'entreprise.",
      alreadyMapped2:
        "vous avez donc accès à toutes les informations de la succursale",
      usedAdded: "Utilisateur ajouté",
    },

    // Fund SubAccount Modal
    fundSubAccount: {
      title: "Sous-compte de fonds",
      amtErr: "Le champ Montant ne peut pas être vide",
      fundSuccess: "Sous-comptes financés avec succès",
    },

    //Generate Deposit Modal
    generateDepositModal: {
      generateDeposit: "Générer un acompte",
      selectAccount: "Sélectionnez un compte",
      selectBank: "sélectionner la banque",
      selectDate: "sélectionner une date",
      ref: "Réf",
      generateReference: "Générer une référence",
      desc: "Faites du mayment dans n'importe quel",
      desc1: "banque utilisant PayDirect",
      // desc2: "comme la narration sur le caissier",
    },

    // Link bank account modal
    linkBankAccModal: {
      enterfullname: "Entrez le nom complet",
      back: "Dos",
      linkedAccounts: "Comptes liés",
      recommended: "Recommandé",
      desc: "Avec ce compte",
      desc1:
        "nous confirmons vos dépôts bancaires sur les comptes bancaires liés",

      proceed: "Oui continuer",
      nonlinkedAccounts: "Comptes non liés",
      regAccount: "Un compte régulier qui est ajouté pour les transactions",
      addNewBank: "Ajouter une nouvelle banque",
      nonlinkedAccounts: "Comptes non liés",
      nonLinkedDesc:
        "Remplissez le formulaire ci-dessous pour ajouter un compte non lié",
      accountName: "Nom du compte",
      accountNumber: "Numéro de compte",
      bank: "Banque",
      compNoBankAcc: "Votre entreprise n'a actuellement aucun compte bancaire",
      accWillBeDisplayed:
        "Les comptes bancaires seront affichés une fois ajoutés",
      noBankrecords: "Pas de relevés bancaires",
      addNewBank: "Ajouter une nouvelle banque",
      accNoErr: "Le numéro de compte doit comporter 10 caractères",
      linkAccSuccess: "Compte bancaire lié avec succès",
    },

    //Map to dealer modal
    mapToDealerModal: {
      title: "Mapper l'entreprise au concessionnaire",
      dealersEmail: "E-mail du revendeur",
      mapToDealer: "Plan vers le concessionnaire",
      mtdSuccess: "Concessionnaire cartographié avec succès",
    },

    // Max cash amount
    maxCashAmtModal: {
      title: "Montant maximal en espèces",
      inputAmount: "quantité d'entrée",
      updateAmt: "Mettre à jour le montant",
      amtErr: "Le montant est requis",
      inputDiffErr: "Veuillez saisir un montant différent du montant actuel",
      inputGreaterPrev: "Veuillez saisir un montant supérieur à 0",
      successfullyUpdatedCIR:
        "Ratio d'assurance en espèces mis à jour avec succès",
    },

    // Success signup modal
    successSUmodal: {
      desc: "Vous vous êtes inscrit avec succès",
      desc1:
        "Un lien de confirmation de compte a été envoyé à votre adresse e-mail",
    },

    varRejectModal: {
      varianceReject: "Rejet d'écart",
      groupName: "Nom de groupe",
      groupDescription: "Description du groupe",
      groupType: "Type de groupe",
      selectGroupType: "Sélectionnez le type de groupe",
      licencesAndPermits: "Licences et permis",
      Physical: "Physique",
      createAssetGroup: "Créer un groupe d'actifs",
      grpNameErr: "Veuillez saisir un nom de groupe",
      descErr: "Veuillez entrer une description",
      groupTypeErr: "Veuillez sélectionner un type de groupe",
      successfullyCreatedAG: "Le groupe d'éléments a bien été créé",
    },

    //Waybill Modals
    waybillModal: {
      add: "Ajouter une lettre de voiture",
      wbDate: "Date de la lettre de voiture",
      refNumber: "Numéro de réference",
      volume: "Volume",
      orderNo: "Numéro de commande",
      useComTruck: "Utiliser le camion de l'entreprise",
      selComTruck: "Sélectionnez le camion de l'entreprise",
      unregTruckDes: "Description du camion non enregistré",
      selectCompanyPro: "Sélectionnez le produit de l'entreprise",
      comment: "commentaire",
      dateErr: "La date est requise",
      refnoErr: "Le numéro de référence est requis",
      volErr: "Volume manquant",
      orderNoErr: "Numéro de commande manquant",
      successfullyAddedWb: "Bordereau de livraison ajouté avec succès",
      updateWbFor: "Mettre à jour la lettre de voiture pour",
      updateWb: "Mettre à jour la lettre de voiture",
      wbUpdateSuccess: "Bordereau d'expédition mis à jour avec succès",
      wbDetFor: "Détails de la lettre de voiture pour",
      companyName: "Nom de l'entreprise",
      companyAddress: "Adresse de la société",
      productName: "Nom du produit",
      unregisteredTruck: "Camion non immatriculé",
      driverName: "Nom du conducteur",
      driverEmail: "Courriel du conducteur",
      driverPhone: "Téléphone du conducteur",
      truckName: "Nom du camion",
      licensePlate: "Plaque d'immatriculation",
      waybillDate: "Date de la lettre de voiture",
    },

    // Zone - Edit Zone
    editZone: {
      title: "Zone d'édition",
      zone: "zone | ZONE",
      zoneMissing: "Veuillez saisir une zone",
      successfullyEdited: "Zone modifiée avec succès",
      unsuccessfulEdit: "Impossible de modifier la zone",
    },

    // Retainership - Add New Retainerhip
    addNewRetainership: {
      title: "Ajouter un nouveau mandat",
      firstName: "Prénom*",
      lastName: "Nom de famille*",
      email: "E-mail*",
      phoneNumber: "Numéro de téléphone*",
      password: "Mot de passe*",
      confirmPassword: "Confirmez le mot de passe*",
      openingBalance: "Solde d'ouverture",
      add: "Ajouter",
      successfullyAdded: "Mandat ajouté avec succès",
      confirmPasswordMissing: "Veuillez confirmer votre mot de passe",
      passwordsDontMatch: "Les mots de passe ne correspondent pas",
    },

    // Retainership - Add Existing
    addExisting: {
      title: "Ajouter existant",
      email: "E-mail",
      add: "Ajouter",
      successfullyAdded: "Mandat ajouté avec succès",
    },

    // Fund Wallet Modal
    fundWalletModal: {
      confirmingPayment: "Confirmation de votre paiement...",
      paymentconfirmed: "Paiement accepté",
      errorConfirming:
        "Erreur lors de la confirmation de votre paiement, veuillez réessayer..",
      payOnline: "Payer en ligne",
      fundWith: "Financer votre portefeuille avec ?",
      fundViaBank: "Financement via la banque",
      payNow: "Payez maintenant",
    },
    // Payment Confirmation
    paymentConfirmation: {
      openModal: "Mode ouvert",
    },

    //partner modals
    //mapPartnerToBranch modal
    mapPartnerToBranch: {
      title: "Associer un partenaire à une succursale",
      selectBranch: "Sélectionnez la branche",
    },

    //mapUserToPartner modal
    mapUserToPartner: {
      title: "Mapper l'utilisateur au partenaire",
      enterEmail: "Entrez l'e-mail",
      mapUser: "Utilisateur de la carte",
      removePartner: "Supprimer le partenaire de l'utilisateur",
    },

    //removeUserFromPartner modal
    removeUserFromPartnerModal: {
      unMapUsers: "Démapper l'utilisateur du partenaire",
      enterEmail: "Entrez l'e-mail",
    },

    // pos Modals
    posModal: {
      branchName: "Nom de la filiale:",
      transactionType: "Type de transaction:",
      cashBack: "Remise en argent",
      transactionDate: "Date de la transaction:",
      pumpName: "Nom de la pompe :",
      amount: "Montant:",
      charge: "Charge:",
      transactionRef: "Référence de transaction :",
      stan: "Stan :",
      RRN: "RRN:",
      maskedPan: "Casserole masquée :",
      customerName: "Nom du client :",
      status: "Statut:",
      cardExpiry: "Expiration de la carte :",
      terminalId: "Identifiant du terminal :",
      print: "Imprimer",
      providusBank: "BANQUE PROVIDUS",
      merchantName: "Nom du commerçant:",
      reprint: "RÉIMPRESSION",
      dateTime: "DATE/HEURE :",
      amount: "Montant:",
      expiryDate: "Date d'expiration:",
      responseCode: "Code de réponse:",
      refNumber: "Numéro de réference:",
      merchantCopy: "Copie marchand",
      pumpAuth: "Pompe autorisée par Epump",
      terminalID: "Identifiant du terminal :",
      STAN: "STAN",
    },

    //re-assign pos modal and reassign POS branch
    reAssignPosModal: {
      reAssignPos: "Réaffecter le POS",
      selectCompany: "Sélectionnez l'entreprise",
      selectBranch: "Sélectionnez la succursale",
    },

    //createTerminalModal
    createTerminalModal: {
      createTerminal: "Créer une borne",
      terminalId: "Identifiant du terminal",
      serialNo: "Numéro de série",
      bank: "Banque",
      selectBank: "Sélectionnez la banque",
    },

    // truck map
    createTrucksModal: {
      selectCredential: "sélectionner les informations d'identification",
      selectTruck: "sélectionner un camion",
      licensePlate: "Plaque d'immatriculation",
      model: "modèle",
      type: "Taper",
      vin: "vin",
      truckAlias: "Alias de camion",
      brand: "Marque",
      productionDate: "Date de production",
      selectDate: "Sélectionner une date",
      tankVol: "Volume du réservoir",
      engineNo: "Moteur non",
      chasisNo: "Châssis non",
      selectType: "sélectionner le genre",
      truck: "Camion",
      trailer: "Bande-annonce",
      selectProduct: "sélectionner un produit",
      customerVehicleName: "Nom du véhicule du client",
    },

    /***** Industrial Portal */

    // Industrial Master Layout
    iMasterLayout: {
      dashboard: "Tableau de bord",
      wallet: "Portefeuille",
      walletBalance: "Solde du portefeuille",
      transactionsDetails: "Détails des transactions",
      orderManagement: "La gestion des commandes",
      reports: "Rapports",
      consumptionReport: "Rapport d'utilisation",
      consumptionHistory: "Historique du carburant",
      tanksFilled: "Produits déchargés",
      events: "Événements",
      maintenance: "Entretien",
      addMaintenance: "Ajouter un entretien",
      schedules: "Des horaires",
      category: "Catégorie",
      addCategory: "ajouter une catégorie",
      hi: "Salut",
      isRunningOn: "fonctionne sur",
      signOut: "Se déconnecter",
      confirmLogout: "Voulez-vous vraiment vous déconnecter ?",
    },

    maintenance: {
      maintenanceList: "Liste d'entretien",
      viewMaintList: "Consultez votre liste de maintenance de groupe ici...",
      viewRegionMaintenance: "Consultez la maintenance de votre région ici...",
      totalMaintenance: "Entretien total",
      station: "Gare",
    },

    // send report
    sendReport: {
      report: "Rapport",
      reportdate: "Date du compte rendu",
      withAtgOnly: "Avec ATG uniquement",
      true: "Vrai",
      false: "FAUX",
      forwardReport: "Transférer le rapport",
      mailTo: "Envoyer à",
      enterRecipient: "Entrez le destinataire",
      dateAndTime: "Sélectionnez la date et l'heure",
      dateRange: "Sélectionnez la plage de dates",
      selDatePaid: "Sélectionnez la date de paiement",
    },

    // Industry Admin Master Layout
    iAdminMasterLayout: {
      dashboard: "Aperçu",
      branches: "Des sites",
      wallet: "Portefeuille",
      walletBalance: "Solde du portefeuille",
      transactionsDetails: "Détails des transactions",
      orderManagement: "La gestion des commandes",
      reports: "Rapports",
      consumptionReport: "Rapport de consommation",
      transactionHistory: "Historique des transactions",
      tanksFilled: "Produits déchargés",
      events: "Événements",
      maintenance: "Entretien",
      addMaintenance: "Ajouter un entretien",
      schedules: "Des horaires",
      hi: "Salut",
      signOut: "Se déconnecter",
      confirmLogout: "Voulez-vous vraiment vous déconnecter ?",
    },

    // Industrial Dashboard
    iDashboard: {
      totalHoursOnPowerGrid: "Nombre total d'heures sur le réseau électrique",
      totalHoursOnGenGrid: "Nombre total d'heures sur le réseau du générateur",
      hours: "Heures",
      orderFor: "Commande de Diesel",
      order: "Commande",
      walletBalance: "Solde du portefeuille",
      addFunds: "Ajouter des fonds",
      currentVolume: "Volume actuel",
      maxVolume: "Volume maximal",
      totalConsumedToday: "Volume total consommé aujourd'hui",
      litres: "Litres",
      hourlyUsage: "Utilisation horaire",
      dailyUsage: "Utilisation quotidienne",
      monthlyUsage: "Utilisation mensuelle",
      dailyUsageHours: "Utilisation quotidienne (heures)",
      hourlyUsageHours: "Utilisation horaire (heures)",
      monthlyUsageHours: "Utilisation mensuelle (heures)",
      totalTankDisplacement: "Déplacement total du réservoir",
      totalTankDisplacementLitres: "Déplacement total du réservoir (litres)",
      logoutTip: "Se déconnecter",
      //INDUSTRIAL ADMIN
      fuelVolume: "Volume total de carburant",
      companyWallet: "Solde total du portefeuille",
      branchConsumption: "Consommation totale de la station",
      allBranches: "Tous les sites",
      branchesTagline:
        "Apprenez à connaître les rapports quotidiens des stations",
      totalHours: "Nombre total d'heures sur le générateur",
      tankPercentage: "Réservoirs avec moins de 30 %",
      allTanks: "Voir tous les réservoirs",
      power: "Puissance (Heures)",
      generator: "Générateur (Heures)",
      fuel: "Carburant (Litres)",
      allBranchConsumption: "Voir toutes les consommations de la branche",
      volumeConsumed: "Volume consommé (litres)",
      branch: "Bifurquer",
      site: "Placer",
      tank: "Réservoir",
      overview: "Aperçu",
      powerHours: "Nombre total d'heures sous tension",
      waterVol: "Volume d'eau :",
      //branches
      tankVolume: "Volume total du réservoir",
      maxVolume: "Volume maximum",
      action: "Action",
      //branch tank
      tankConsumption: "Rapport de consommation du réservoir",
      companyReportsDetails:
        "Voir tous les détails sur les rapports de l'entreprise",
      tank: "Réservoir",
      currentVolume: "Volume actuel",
      maxCapacity: "Capacité maximale",
    },

    // industrial group management
    iGroupManagement: {
      groupManagement: "Gestion de groupe",
      createAndManage: "Créez et gérez vos groupes sectoriels ici",
      createNew: "CRÉER UN NOUVEAU",
      totalGroups: "Groupes totaux",
      name: "Nom",
      description: "Description",
      category: "Catégorie",
      email: "E-mail",
      action: "Action",
    },

    //industrial maintenance
    iMaintenance: {
      maintenanceTitle: "Entretien",
      maintenanceForAllBranch:
        "Afficher les détails de la maintenance pour toutes les succursales",
      allGenerators: "Tous les générateurs",
      serviceGenerators: "Groupes électrogènes ayant besoin d'entretien",
    },

    //industrial generators
    iGenerators: {
      branch: "Bifurquer",
      site: "Placer",
      startedDate: "Date de début",
      totalHours: "Heures totales",
      daysToMaintenance: "Jours d'entretien",
    },

    //industrial order management
    iOrderManagement: {
      orderManagement: "La gestion des commandes",
      cumulativeDetails:
        "Détails cumulés de toutes les commandes des succursales",
      branch: "Bifurquer",
      site: "Placer",
      totalOrder: "Commande totale",
      quantity: "Quantité (litre)",
      amount: "Montant",
      action: "Action",
    },

    // industrial order details
    iOrderDetails: {
      individualOrderDetails:
        "Afficher les détails des commandes de succursales individuelles",
      branch: "Bifurquer",
      product: "Produit",
      quantity: "Quantité (litre)",
      amount: "Montant",
      status: "Statut",
    },

    // industrial users
    iUsers: {
      title: "Utilisateurs",
      manageUsers: "Gérer les utilisateurs",
      usersAndRoles: "Gérez vos utilisateurs et leurs rôles ici...",
      createUsers: "Créer un utilisateur",
      addExistingUser: "Ajouter un utilisateur existant",
      firstName: "Prénom",
      lastName: "Nom de famille",
      email: "Adresse e-mail",
      status: "Statut",
      accessLevel: "Niveau d'accès",
      //user details
      phoneNumber: "Numéro de téléphone",
      active: "Actif",
      deactivated: "Désactivé",
      suspended: "Suspendu",
      selectAccessLevel: "Sélectionnez le niveau d'accès",
      selectAccess: "sélectionner le niveau d'accès",
      select: "Sélectionner",
      passwordChange: "Forcer le changement de mot de passe",
      search: "recherche...",
      updateUser: "Mettre à jour l'utilisateur",
      selectRole: "Sélectionner tous les rôles",
      roles: "Les rôles",
      //create user
      createUser: "Créer un utilisateur",
    },

    //industrial wallet
    iWallet: {
      wallet: "Portefeuille",
      branchOrderHistory:
        "Afficher l'historique des commandes et des transactions de la succursale",
      walletOverview: "Présentation du portefeuille",
      transactionDetails: "détails de la transaction",
      //transaction details
      amount: "Montant (Naira)",
      status: "Statut",
      description: "Description",
      date: "Date",
      // wallet Overview
      walletBalance: "Solde du portefeuille",
      totalIncome: "Revenu total des sept (7) derniers jours",
      totalExpenses: "Dépenses totales des sept (7) derniers jours",
    },

    // industrial group
    iGroup: {
      overview: "aperçu",
      viewOverview: "Voir la présentation du groupe",
      totalHoursOfGen: "Nombre total d'heures de générateur",
      tanksLessThan: "Réservoirs à moins de 30 %",
      seeAllTanks: "Voir tous les réservoirs",
      startedDate: "Date de début",
      totalHours: "Heures totales",
      daysToMaint: "Jours d'entretien",
      maintenance: "Entretien",
      viewMaintDetails:
        "Afficher les détails de la maintenance pour toutes les succursales",
      allGenerators: "Tous les générateurs",
      serviceGen: "Groupes électrogènes ayant besoin d'entretien",
      viewIndividualBranch:
        "Afficher les détails des commandes de succursales individuelles",
      date: "Date",
      product: "Produit",
      quantity: "Quantité (litre)",
      amount: "Montant",
      status: "Statut",
      description: "Description",
      orderManagement: "La gestion des commandes",
      cumulativeDetails:
        "Détails cumulés de toutes les commandes des succursales",
      totalOrder: "Commande totale",
      totalHoursOnGen: "Nombre total d'heures sur le générateur",
      litrs: "Litres",
      powerHours: "Puissance (Heures)",
      genHours: "Générateur (Heures)",
      volConsumed: "Volume consommé (litres)",
      fuelLitres: "Carburant (Litres)",
      viewBranchHistory:
        "Afficher l'historique des commandes et des transactions de la succursale",
      reports: "Rapports",
      report: "Rapport",
      consumption: "Consommation",
      tankReport: "Rapport de réservoir",
      totalIncome: "Revenu total des sept (7) derniers jours",
      amountNaira: "Montant (Naira)",
      wallet: "Portefeuille",
      walletBalance: "Solde du portefeuille",
      walletOverview: "Présentation du portefeuille",
      transactionDetails: "détails de la transaction",
      manageUsers: "gérer les utilisateurs",
      genRequireServicing: "générateur(s) nécessitant un entretien",
      groupManagement: "Gestion de groupe",
      genHours: "Heures de générateur :",
      branchConsumption: "Voir toutes les consommations de la branche",
      hours: "heures",
    },

    // industrial branch tank
    iBranchTank: {
      tank: "Réservoir",
      currVolume: "Volume actuel",
      maxCapacity: "Capacité maximale",
      branch: "Bifurquer",
      site: "Placer",
      totalTankVolume: "Volume total du réservoir",
      maxVolume: "volume maximum",
      action: "Action",
    },

    // Industrial Events
    iEvents: {
      eventReport: "Rapport d'événement",
      getToKnow:
        "Apprenez à connaître les événements quotidiens qui se sont produits dans votre immeuble.",
      logBetween: "Journal des événements entre",
      date: "Date",
      event: "Événement",
      startTime: "Heure de début",
      endTime: "Heure de fin",
      source: "Source",
      usageTime: "Temps d'utilisation",
    },

    // Industrial Fund Wallet
    iFundWallet: {
      confirmingPayment: "Confirmation de votre paiement...",
      paymentConfirmed: "Paiement accepté!",
      errorConfirming:
        "Erreur lors de la confirmation de votre paiement Veuillez réessayer.",
      fundWithCard: "Fonds avec carte",
      wallet: "Portefeuille",
      fundAccountWithCard:
        "Approvisionnez votre compte en payant avec votre carte en ligne",
      payNow: "Payez maintenant",
      fundAccountWithWallet:
        "Alimentez votre compte avec le portefeuille de votre station",
      amount: "Montant",
      amountMissing: "Veuillez entrer un montant",
      fundWithBank: "Compte de fonds auprès de votre banque",
      bankName: "Nom de banque:",
      providusBank: "Banque Providus",
      accountNumber: "Numéro de compte:",
      accountName: "Nom du compte:",
      clickContinue: "Cliquez sur continuer après avoir effectué le paiement",
      continue: "Continuer",
      bank: "Banque",
      card: "Carte",
      bankTransfer: "Virement",
      makePayment: "Effectuer le paiement",
      desc: "Effectuez un paiement avec votre banque pour mettre à jour le solde du portefeuille",
      desc2:
        "Cliquez sur l'icône d'actualisation pour vérifier le solde de votre portefeuille mis à jour et régler la facture lorsque le montant est mis à jour",
      desc3:
        "Cliquez sur l'icône d'actualisation pour afficher le solde du portefeuille mis à jour et",
      payMode: "Mode de paiement",
      bWallet: "Portefeuille de succursale",
      poweredBy: "... alimenté par",
      inputUSD: "Montant d'entrée en USD ($)",
    },

    // Industrial Report
    iReport: {
      dailyReport: "Rapport de consommation quotidienne",
      getReport: "Obtenez des rapports sur votre consommation quotidienne.",
      consumptionBetween: "Consommation entre",
      totalHoursOnPowerGrid: "Nombre total d'heures de réseau électrique",
      hour: "heures",
      totalHoursOnGenGrid: "Nombre total d'heures de générateur",
      totalFuelConsumption: "Consommation totale de carburant",
      litres: "Litres",
      powerDistribution: "Distribution d'énergie",
      generator: "Générateur",
      powerGrid: "Réseau électrique",
      dailyUsageChart: "Tableau d'utilisation quotidienne",
      dailyUsageHours: "Utilisation quotidienne (heures)",
      volUsed: "volume utilisé",
      report: "Rapports",
      orderHistory:
        "Afficher l'historique des commandes et des transactions de la succursale",
      consumption: "Consommation",
      tankReport: "Rapport de réservoir",
      tankVolChart: "Tableau de volume du réservoir",
    },

    // Industrial Wallet Transactions
    iWalletTransactions: {
      title: "Transactions de portefeuille",
      getReports:
        "Obtenez des rapports sur le total de vos transactions de portefeuille",
      walletTransBtw: "Transaction de portefeuille entre",
      amount: "Monnaie de {currency}",
      source: "Source",
      status: "Statut",
      walletBalance: "Solde Google Wallet {currency}",
    },

    // Industrial Wallet Balance
    iWalletBalance: {
      title: "Solde du portefeuille",
      addFunds: "Ajouter des fonds",
      totalExpenses: "Dépenses totales des sept (7) derniers jours",
      transactionSummary: "récapitulatif des transactions",
      viewMore: "Voir plus",
      noTransaction: "Aucune transaction de portefeuille pour le moment",
      amount: "Monnaie de {currency}",
      walletStatistics: "Statistiques du portefeuille",
      expenses: "Dépenses",
      income: "Revenu",
    },

    // Track Order
    iTrackOrder: {
      back: "Dos",
      statusUpdates: "Mises à jour de statut",
      litres: "Litres",
      from: "DEPUIS",
      to: "POUR",
      date: "Date",
      comment: "Commentaire",
      status: "Statut",
    },

    // Tanks Filled
    iTanksFilled: {
      title: "Produit déchargé",
      getReports:
        "Obtenez des rapports sur le total des transactions de réservoir",
      tanksFilledOn: "Produits déchargés le",
      tankName: "Nom du réservoir",
      eVolumeDischarged: "Volume de pompe déchargé (litres)",
      mVolumeDischarged: "Volume manuel déchargé (litres)",
      variance: "Variance",
      eStartVolume: "Volume de démarrage de la pompe (litres)",
      eVolumeEnd: "Volume final de la pompe (litres)",
      mStartVolume: "Volume de démarrage manuel (litres)",
      mEndVolume: "Volume final manuel (litres)",
      startTime: "Heure de début",
      endTime: "Heure de fin",
      noTanksFilledOn: "Aucun produit déchargé sur",
    },

    // Tank Transactions
    iTankTransactions: {
      title: "Rapport de consommation du réservoir",
      getReports:
        "Obtenez des rapports sur le total des transactions de réservoir",
      tankReportBtw: "Rapport de réservoirs entre",
      name: "Nom",
      volumeConsumed: "Volume consommé",
      volumeRefilled: "Volume rempli",
      openingVolume: "Volume d'ouverture",
      closingVolume: "Volume de clôture",
      tanksReport: "Rapport sur les réservoirs",
      totalVolume: "Volume total (Litres)",
      volumeSold: "Volume vendu",
      volumeFilled: "Volume rempli",
      viewDetailsReports:
        "Afficher tous les détails sur les rapports de groupe",
      tankReportsOn: "Rapports de réservoir sur",
      tankConsumptionSummary: "Résumé de la consommation du réservoir",
      volConsumed: "Volume consommé :",
      volFilled: "Volume rempli :",
      date: "Date",
      volumeUsed: "Volume utilisé",
    },

    //Industry tanks
    iTanks: {
      tanks: "réservoirs",
      waterLevel: "niveau d'eau",
      probeTransactions: "Sonder les transactions",
      dailyReport: "Rapport journalier",
    },

    //tank details
    iTankDetails: {
      dailyReport: "Rapport quotidien du réservoir",
      dateRange: "Sélectionnez une plage de dates",
      tanksFilled: "Réservoirs remplis entre",
      tank: "Réservoir",
      date: "Date",
      openingVol: "Volume d'ouverture",
      closingVol: "Volume de clôture",
      volFilled: "Volume rempli",
      volSold: "Volume vendu",
    },

    //tank probe transactions
    iTankProbe: {
      totalTransactions: "Transactions totales",
      tankProbeTransactions: "Transactions de sonde de réservoir",
      dateRange: "Sélectionnez une plage de dates",
      tanksFilled: "Réservoirs remplis entre",
      date: "Date",
      productHeight: "Hauteur du produit",
      productVolume: "Volume de produit",
      temperature: "Température",
      waterHeight: "Hauteur de l'eau",
      waterVol: "Volume d'eau",
    },

    // Service
    service: {
      service: "service",
      serviceName: "Nom du service",
      addService: "Ajouter un service",
      noServiceAdded: "Vous n'avez actuellement aucun service ajouté",
      serviceAddition:
        "les services seront ajoutés ici lorsqu'ils seront ajoutés",
      manageService: "Gérer les services",
      manageServiceFor: "Gérez vos services pour",
      manageTransFor: "Gérez vos transactions pour",
      viewTrans: "Afficher les transactions",
      totalServices: "Services totaux",
      totalTrans: "Transactions totales",
      totalAmount: "Montant total",
      action: "Action",
      trans: "transactions",
      here: "ici",
      totalSoldPrice: "Prix de vente total",
      date: "Date",
      serviceDesc: "Description du service",
      customer: "Client",
      price: "Prix",
      transHistory: "Historique des transactions",
      recordDate: "Date d'enregistrement",
      manageServiceTrans: "Gérer les transactions de services",
      station: "Gare",
      amount: "Montant",
    },

    // Schedule Maintenance
    iScheduleMaintenance: {
      nextMaintenance: "Prochain entretien",
      hi: "Salut",
      youCanFix:
        "Vous pouvez fixer une date et définir un rappel pour entretenir votre équipement",
      schedule: "Calendrier",
      facilityType: "Type d'établissement",
      facilityName: "Nom de l'installation",
      status: "Statut",
      date: "Date",
      dueDate: "Date d'échéance",
      countdown: "Compte à rebours",
      history: "Histoire",
      markAsDone: "Marque comme Terminé",
      hours: "heures",
      day: "jour | jours",
      expired: "Expiré",
      done: "Fait",
      pending: "En attente",
      countDown: "Compte à rebours",
    },

    // Maintenance History
    iMaintenanceHistory: {
      back: "Dos",
      title: "Histoire",
      nextMaintenance: "Prochain entretien",
      countdown: "Compte à rebours",
      resolvedOn: "Résolu le",
      at: "à",
      cost: "Coût",
      hours: "heures",
      day: "jour | jours",
      expired: "Expiré",
      done: "Fait",
      pending: "En attente",
    },

    // Add Maintenance
    iAddMaintenance: {
      scheduleMaintenance: "Planifier l'entretien",
      type: "Taper",
      facilityType: "Sélectionnez le type d'établissement",
      generator: "Générateur",
      tankSystem: "Système de réservoir",
      generatorName: "Nom du générateur",
      description: "Description",
      maintenanceDescription: "Description de l'entretien",
      resolved: "Résolu",
      true: "Vrai",
      false: "FAUX",
      dueDate: "Date d'échéance",
      schedule: "Calendrier",
      facilityTypeMissing: "Veuillez sélectionner le type d'établissement",
      generatorTypeNameMissing: "Veuillez saisir un nom de type de générateur",
      descriptionMissing: "Veuillez entrer une description",
      trueOrFalse: "Veuillez sélectionner vrai ou faux si résolu",
      successfullyAdded: "Horaire ajouté avec succès",
      category: "Catégorie",
      service: "Service",
    },

    // Request Diesel
    iRequestDiesel: {
      numberOfOrders: "Nombre de commandes",
      hi: "Salut",
      requestText: "Le diesel peut être demandé pour vous être livré.",
      requestDiesel: "Demander du diesel",
      date: "Date",
      volume: "Volume (litres)",
      price: "Prix",
      product: "Produit",
      amount: "Monnaie de{currency}",
      status: "Statut",
      trackOrder: "Suivi de commande",
      completeOrder: "Complétez la commande",
    },

    // Add Order & Complete Order
    iAddOrder: {
      confirmingPayment: "Confirmation de votre paiement...",
      paymentConfirmed: "Paiement accepté!",
      errorConfirming:
        "Erreur lors de la confirmation de votre paiement Veuillez réessayer.",
      order: "COMMANDE",
      shipping: "EXPÉDITION",
      payment: "PAIEMENT",
      fullAddress: "Adresse complète",
      station: "Gare",
      volume: "Volume",
      product: "Produit",
      selectAProduct: "Sélectionner un produit",
      addOrder: "Ajouter une commande",
      pricePerLitre: "Prix par litre | Prix/litre",
      amount: "Montant",
      litreVolume: "Volume en litre",
      litres: "Litres",
      deliveryAddress: "Adresse de livraison",
      previous: "Précédent",
      next: "Suivant",
      payWithCard: "Payer par carte",
      wallet: "Portefeuille",
      confirmAmount: "Confirmez le montant et procédez au paiement",
      payNow: "Payez maintenant",
      walletDebited: "Le solde du portefeuille de votre station serait débité",
      successfullyAdded: "Commande ajoutée Procéder au paiement avec succès",
      unsuccessfulAdd: "Échec de la commande",
      amountMissing: "Veuillez entrer un montant",
      addressMissing: "Veuillez entrer une adresse",
      stationMissing: "Veuillez entrer une station",
      volumeMissing: "Veuillez saisir un volume",
      productMissing: "Veuillez sélectionner un produit pour continuer",
      priceLiter: "Prix par litre",
      continue: "Continuer",
      bank: "Banque",
      fundWithBank: "Compte de fonds auprès de votre banque",
      makeTransfer: "Faire un virement sur le compte",
      availableBalance: "Le solde disponible estnt",
    },

    // Mark Maintenance
    iMarkMaintenance: {
      markAsDone: "Marque comme Terminé",
      totalCost: "Coût total de l'entretien",
      inputAmount: "Montant d'entrée",
      comment: "Commentaire",
      updateComment: "Mettre à jour le commentaire",
      mark: "Marquer",
      amountMissing: "Veuillez entrer un montant",
      commentMissing: "Veuillez entrer un commentaire",
      successfullyCompleted: "Maintenance terminée avec succès",
      successfullyyUpdatedTrack: "Piste de maintenance mise à jour",
      conGraph: "Graphique de la plage de consommation",
    },

    //Reorder Level
    reorderLevel: {
      title: "Niveau de réapprovisionnement",
      desc: "Affichez et gérez les détails du niveau de réapprovisionnement de votre réservoir ici",
      addRe: "Ajouter un niveau de réapprovisionnement",
      editRe: "Modifier le niveau de réapprovisionnement",
      selPro: "Sélectionner un produit",
      inputRL: "Niveau de réorganisation des entrées",
      proCap: "Capacité du produit",
      deleted: "Niveau de réapprovisionnement supprimé",
      revert: "Revenir",
      reverted: "Inversé",
    },

    //Price Manager
    priceManager: {
      title: "Approbations",
      title2: "Cluster de branches",
      desc: "Consultez vos responsables des approbations ici...",
      desc2: "Consultez vos approbations de changement de prix ici",
      desc3: "Affichez votre cluster de branches ici",
      priceChange: "Changement de prix",
      position: "Position",
      missingPosition: "Position d'entrée",
      selectUser: "Sélectionner un utilisateur",
      loading: "chargement...",
      addPM: "Ajouter un gestionnaire de prix",
      addedPM: "Gestionnaire de prix ajouté",
      updatedPM: "Gestionnaire de prix mis à jour",
      updatePM: "Mettre à jour le gestionnaire de prix",
      deletedPM: "Gestionnaire de prix supprimé",
      deletePMWarn:
        "Etes-vous sûr de vouloir supprimer le gestionnaire de prix ?",
      approvals: "Approbations",
      decline: "Déclin",
      approveWarn: "Etes-vous sûr de vouloir approuver ?",
      approveSuccess: "Approuvé avec succès",
      declineWarn: "Êtes-vous sûr de vouloir refuser ?",
      declineSuccess: "Refusé avec succès",
      unauthorized: "Non autorisé",
      level: "Niveau",
      selectLevel: "Choisir le niveau",
      selTypeToEnable: "sélectionnez le type à activer",
      submitted: "Soumise",
      reasonFor: "Raison du refus",
      initiatedBy: "Initié par",
    },

    //Omitted
    omit: {
      stationSalesRep: "RAPPORT SUR LES VENTES DE LA STATION",
      branchAdd: "Adresse de la succursale",
      dailyGrowth: "Croissance quotidienne",
      totLitTra: "Total Litre par transaction",
      totPmsSold: "Total des PMS vendus",
      totAgoSold: "Total AGO vendu",
      totDpkSold: "Total de DPK vendus",
      totDisp: "Total distribué",
      listGenVou: "Liste des bons générés",
      viewTerList: "Consultez la liste de vos bornes ici",
      allComp: "Toutes les entreprises",
      allBanks: "Toutes les banques",
      allTerminals: "Toutes les bornes",
      allOwners: "Tous les propriétaires",
      enterPass: "tapez votre mot de passe",
      enterEmail: "email@email.com",
      showTransfer: "Afficher le transfert",
      hideTransfer: "Masquer le transfert",
      posTransact: "Transactions au point de vente",
      moMo: "Argent mobile",
      consumptionChart: "Tableau de consommation",
      backToGroupDash: "Retour au tableau de bord du groupe",
      paymentSucceeded: "Paiement réussi !",
      paymentProcessing: "Traitement des paiements !",
      paymentNotSuccessful:
        "Votre paiement n'a pas abouti, veuillez réessayer.",
      somethingWentWrong: "Quelque chose s'est mal passé.",
      unexpectedError: "Une erreur inattendue est apparue.",
      checking: "vérification...",
      noTanksDisplay: "Aucun réservoir à afficher",
      deleteTerminal: "Voulez-vous vraiment supprimer le terminal?",
      terminalDeleted: "Terminal supprimé avec succès",
      successfullyDownloaded: "Téléchargé avec succès",
      successfullyReassignedPOS: "PDV réaffecté avec succès",
      tokenMissing: "Veuillez saisir votre jeton",
      paymentChannel: "CANAL DE PAIEMENT",
      revenue: "REVENU",
      wetStock: "Stock humide",
      rtt: "RTT",
      is: "est",
      dispensed: "Distribué",
      esaleSummary:
        "Consultez votre résumé et vos détails de vente en ligne ici",
      retainershipSummary:
        "Consultez le récapitulatif et les détails de vos ventes de mandat ici",
      uniqueID: "Identifiant unique",
      voucherCardNo: "Numéro de carte de bon d'achat",
      remisSales: "Ventes Rémis",
      walletTU: "Rechargement du portefeuille",
      avgLtr: "Litre moyen par transaction",
      lastUpdated: "et dernière mise à jour le",
      searchRole: "Rôle de recherche",
      selectRoles: "Sélectionnez tous les rôles",
      mappedRoles: "Rôles mappés",
      addMappedRoles: "Ajouter des rôles",
      successfullyUpdatedRole: "Sous-catégorie mise à jour avec succès",
      sureToDelete: "Etes-vous sûr que vous voulez supprimer?",
      removeRole: "Êtes-vous sûr de vouloir désinstaller",
      removedRoleSuccess: "Rôle supprimé avec succès",
      mapRolesFor: "Mapper les rôles pour",
      manageSubcat: "Accès en équipe",
      manageSubcatDet: "Consultez l'accès de votre équipe ici...",
      upSubcat: "Mettre à jour le type d'accès de l'équipe",
      addSubcat: "Ajouter un type d'accès d'équipe",
      mapRoles: "Mapper les rôles",
      priceChangeLog: "Journal des changements de prix",
      tp: "Débit",
      tpfor: "Débit pour",
      selectSubcat: "Sélectionnez une sous-catégorie",
      openreadThirtyDays: "Lecture d'ouverture des 30 derniers jours",
      openreadCurDate: "Lecture d'ouverture pour la date actuelle",
      approve: "Approuver",
      approvePrice: "Approbations de prix",
      oldPrice: "Ancien prix",
      selectOpenCloseDate: "Sélectionnez la date d'ouverture et de fermeture",
      successful: "Réussie",
      failed: "Échoué",
      payDirect: "Payer directement",
      directTransfer: "Transfert direct",
      dataRejected: "Données rejetées avec succès",
      sureReject: "Etes-vous sûr de vouloir rejeter l'enregistrement ?",
      addRec: "Ajouter un enregistrement",
      uploadTI: "Télécharger l'image du totalisateur",
      passRequirement: "Le mot de passe ne répond pas à toutes les exigences",
      oneUpper: "Utilisez au moins une lettre majuscule",
      oneNum: "Utilisez au moins un numéro",
      oneSpec: "Utilisez au moins un caractère spécial",
      eightChar: "Utilisez au moins 8 caractères",
      pickOrSearch: "Choisissez ou recherchez pour sélectionner",
      initialPosting: "Publication initiale",
      remisWallet: "Portefeuille Rémis",
    },
  },
};
